/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type ActivePeriod = {
  __typename?: 'ActivePeriod';
  isActivePeriod: Scalars['Boolean']['output'];
  totalMonths?: Maybe<Scalars['Float']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type AdditionalQuestion = {
  __typename?: 'AdditionalQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  askEachAthlete?: Maybe<Scalars['Boolean']['output']>;
  askOnlyOnce?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fieldOptions?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isHide?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  question?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategories?: Maybe<Array<CategorySetting>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Album = {
  __typename?: 'Album';
  albumCustomEvent?: Maybe<Scalars['String']['output']>;
  albumTags?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isAlbumPublic?: Maybe<Scalars['Boolean']['output']>;
  isSpecificTournament?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  media?: Maybe<Array<Media>>;
  platform?: Maybe<Platform>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Albums = {
  __typename?: 'Albums';
  albums: Array<Album>;
  total: Scalars['Int']['output'];
};

export type Athlete = {
  __typename?: 'Athlete';
  athlete?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AthleteAchievement = {
  __typename?: 'AthleteAchievement';
  activeFrom: Scalars['DateTime']['output'];
  activeTo: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  entry: TournamentRegistration;
  external_id: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  league: League;
  place: Scalars['String']['output'];
  points: Scalars['Float']['output'];
  tournament: Tournament;
  tournamentCategory: TournamentCategory;
  updatedAt: Scalars['DateTime']['output'];
};

export type AthleteAchievementsByYear = {
  __typename?: 'AthleteAchievementsByYear';
  data: Array<AthleteAchievement>;
  year: Scalars['String']['output'];
};

export type AthleteTournamentStats = {
  __typename?: 'AthleteTournamentStats';
  activeTournamentNames?: Maybe<Array<TournamentName>>;
  activeTournaments?: Maybe<Scalars['Int']['output']>;
  allTournamentNames?: Maybe<Array<TournamentName>>;
  allTournaments?: Maybe<Scalars['Int']['output']>;
  leagues?: Maybe<Scalars['Int']['output']>;
  matches?: Maybe<MatchStats>;
  pastTournamentNames?: Maybe<Array<TournamentName>>;
  pastTournaments?: Maybe<Scalars['Int']['output']>;
  upcomingTournamentNames?: Maybe<Array<TournamentName>>;
  upcomingTournaments?: Maybe<Scalars['Int']['output']>;
  userWonTournaments?: Maybe<Scalars['Int']['output']>;
};

export type Banner = {
  __typename?: 'Banner';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  images?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Array<Sport>>;
  status?: Maybe<Scalars['String']['output']>;
  subHeadLine?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CalculatePaymentInput = {
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type Category = {
  __typename?: 'Category';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageLimit?: Maybe<Scalars['Float']['output']>;
  ageLimitType?: Maybe<Scalars['String']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  categoryRules?: Maybe<Array<CategoryRule>>;
  countAllTournament?: Maybe<Scalars['Boolean']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fixedPoints?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isDisplayBirthYear?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Array<License>>;
  maxTournaments?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlyThirdPartyRanking?: Maybe<Scalars['Boolean']['output']>;
  penalty?: Maybe<Scalars['Boolean']['output']>;
  penaltyRule?: Maybe<Scalars['String']['output']>;
  selectStage?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
  specificTournament?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timePeriod?: Maybe<Scalars['String']['output']>;
  tournamentCatgories?: Maybe<Array<RankingTournamentCategory>>;
  tournaments?: Maybe<Array<CategoryTournament>>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryPaymentInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  alreayExist?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  leagueTitle?: InputMaybe<Scalars['String']['input']>;
  licenseTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onSiteAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  purchasedLicenseId?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  yearsToAdd?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryRule = {
  __typename?: 'CategoryRule';
  category?: Maybe<Category>;
  coefficient?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  licenseSubtypes?: Maybe<Scalars['String']['output']>;
  numberOfTournaments?: Maybe<Scalars['Int']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  thirdPartyLicense?: Maybe<ThirdPartyLicense>;
  tournamentCategories?: Maybe<Array<TournamentCategory>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategorySetting = {
  __typename?: 'CategorySetting';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  category?: Maybe<TournamentCategory>;
  color?: Maybe<Scalars['String']['output']>;
  consolation?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  extraTime?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  isVATAmount?: Maybe<Scalars['Boolean']['output']>;
  mde?: Maybe<Scalars['Float']['output']>;
  mds?: Maybe<Scalars['Float']['output']>;
  mdwc?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  moveToSingle?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['String']['output']>;
  onsiteFee?: Maybe<Scalars['Int']['output']>;
  pairing?: Maybe<Scalars['String']['output']>;
  partnersCount?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  qe?: Maybe<Scalars['Float']['output']>;
  qs?: Maybe<Scalars['Float']['output']>;
  qwc?: Maybe<Scalars['Float']['output']>;
  registrationLimit?: Maybe<Scalars['Float']['output']>;
  rounds?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['Int']['output']>;
  singleCategory?: Maybe<CategorySetting>;
  sortBy?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  timeAfterMove?: Maybe<Scalars['Float']['output']>;
  timePerMove?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  vatAmount?: Maybe<Scalars['Float']['output']>;
};

export type CategoryTournament = {
  __typename?: 'CategoryTournament';
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Club = {
  __typename?: 'Club';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clubMainAdministrator?: Maybe<User>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubServices?: Maybe<Array<ClubService>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Federation>;
  howToFindUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  isAdminVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  isAthleteClub?: Maybe<Scalars['Boolean']['output']>;
  isEnableEmail?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<ClubMember>>;
  news?: Maybe<Array<ClubNews>>;
  platform?: Maybe<Platform>;
  sports?: Maybe<Array<Sport>>;
  status?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  tikTok?: Maybe<Scalars['String']['output']>;
  tournaments?: Maybe<Array<Tournament>>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ClubAdministrator = {
  __typename?: 'ClubAdministrator';
  administrator?: Maybe<User>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubCoach = {
  __typename?: 'ClubCoach';
  club?: Maybe<Club>;
  coach?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubMember = {
  __typename?: 'ClubMember';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type ClubMemberResult = {
  __typename?: 'ClubMemberResult';
  clubMembers: Array<ClubMember>;
  total: Scalars['Int']['output'];
};

export type ClubNews = {
  __typename?: 'ClubNews';
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubResult = {
  __typename?: 'ClubResult';
  club: Array<Club>;
  total: Scalars['Int']['output'];
};

export type ClubService = {
  __typename?: 'ClubService';
  club?: Maybe<Club>;
  clubServiceResource?: Maybe<Array<ClubServiceResource>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  services?: Maybe<ResourceService>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubServiceResource = {
  __typename?: 'ClubServiceResource';
  club?: Maybe<Club>;
  clubService?: Maybe<ClubService>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  services?: Maybe<ResourceService>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CountSportFishingEntriesMetric = {
  __typename?: 'CountSportFishingEntriesMetric';
  confirmed?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Court = {
  __typename?: 'Court';
  allowAttachingMediaContent?: Maybe<Scalars['Boolean']['output']>;
  allowParticipantsToAddResults?: Maybe<Scalars['Boolean']['output']>;
  attachmentsStatus?: Maybe<Scalars['String']['output']>;
  autoConfirmSubmittedResults?: Maybe<Scalars['Boolean']['output']>;
  bestResultsLimit?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  generalLimit?: Maybe<Scalars['Float']['output']>;
  hideOtherParticipantResults?: Maybe<Scalars['Boolean']['output']>;
  hideResultsType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  individualMetricLimit?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  metricContext?: Maybe<Array<SportFishingMetricContext>>;
  metrics?: Maybe<Array<SportFishingMatric>>;
  name?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submissionType?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  primaryColor: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status: Scalars['String']['input'];
  subHeadLine: Scalars['String']['input'];
};

export type CreateCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryRuleInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  licenseSubtypes?: InputMaybe<Scalars['String']['input']>;
  numberOfTournaments?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateCategorySettingInput = {
  category: Scalars['Int']['input'];
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method: Scalars['String']['input'];
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCategoryTournamentInput = {
  category: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
};

export type CreateClubAdministratorInput = {
  administrator: Scalars['Int']['input'];
  club: Scalars['Int']['input'];
};

export type CreateClubCoachInput = {
  club: Scalars['Int']['input'];
  coach: Scalars['Int']['input'];
};

export type CreateClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator: Scalars['Int']['input'];
  clubName: Scalars['String']['input'];
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation: Scalars['Int']['input'];
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubMemberInput = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['Int']['input'];
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubNewsInput = {
  club: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
};

export type CreateClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubsServiceInput = {
  club: Scalars['Int']['input'];
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};

export type CreateDisciplineInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['Int']['input'];
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDisplaySettingInput = {
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['String']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawScoreInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateFactSheetInput = {
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFederationInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federationEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFederationLeagueInput = {
  federation: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateFederationNewsInput = {
  federation: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
};

export type CreateGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group: Scalars['Int']['input'];
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory: Scalars['Int']['input'];
};

export type CreateGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
  tournamentCategory: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateImageInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateLandingInput = {
  landingAbbr?: InputMaybe<Scalars['String']['input']>;
  landingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  landingCountry?: InputMaybe<Scalars['String']['input']>;
  landingCustomPlatform?: InputMaybe<Scalars['String']['input']>;
  landingHeadline?: InputMaybe<Scalars['String']['input']>;
  landingHeroLayout?: InputMaybe<Scalars['String']['input']>;
  landingLang?: InputMaybe<Scalars['String']['input']>;
  landingLayout?: InputMaybe<Scalars['String']['input']>;
  landingLocations?: InputMaybe<Scalars['String']['input']>;
  landingLogo?: InputMaybe<Scalars['String']['input']>;
  landingLogoDark?: InputMaybe<Scalars['String']['input']>;
  landingOrganizations?: InputMaybe<Scalars['String']['input']>;
  landingPrimary?: InputMaybe<Scalars['String']['input']>;
  landingPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSubtitle?: InputMaybe<Scalars['String']['input']>;
  landingSupportedSports?: InputMaybe<Scalars['String']['input']>;
  landingTeamPages?: InputMaybe<Scalars['String']['input']>;
  landingTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLandingMemberInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  show_on_pages?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLandingPotmInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_updated?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLandingRoadmapInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  item1?: InputMaybe<Scalars['String']['input']>;
  item2?: InputMaybe<Scalars['String']['input']>;
  item3?: InputMaybe<Scalars['String']['input']>;
  item4?: InputMaybe<Scalars['String']['input']>;
  item5?: InputMaybe<Scalars['String']['input']>;
  item6?: InputMaybe<Scalars['String']['input']>;
  item7?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLandingSliderInput = {
  button?: InputMaybe<Scalars['String']['input']>;
  date_added?: InputMaybe<Scalars['String']['input']>;
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLeagueCategoryInput = {
  category: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeagueMemberInput = {
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  member: Scalars['Int']['input'];
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateLeagueMemberRoleInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueMember?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueNewsInput = {
  league: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
};

export type CreateLeagueOwnerInput = {
  federation: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueTournamentCategoryInput = {
  category: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateLeagueTournamentInput = {
  league: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
};

export type CreateLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fee: Scalars['Float']['input'];
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLicenseLeagueInput = {
  league: Scalars['Int']['input'];
  license: Scalars['Int']['input'];
};

export type CreateLicensePaymentInput = {
  alreayExist?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  leagueTitle?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licenseTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  purchasedLicenseId?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  yearsToAdd?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLicenseQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLiveStandingInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatchScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatchesScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  groupEntry?: InputMaybe<Scalars['Int']['input']>;
  groupEntryPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMediaInput = {
  album?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  photoCaption?: InputMaybe<Scalars['String']['input']>;
  photoLink?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNewsInput = {
  author: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postText: Scalars['String']['input'];
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOnboardingInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateOrganizationPlatformInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrganizationPlatformMemberInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerSearchRequestInput = {
  requesterId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type CreatePlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
  price?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlateformSportInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePlatformCoachInput = {
  category: Scalars['String']['input'];
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  displayOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole: Scalars['String']['input'];
};

export type CreatePlatformDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalender?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePlatformFeeInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  feeType: FeeType;
  id?: InputMaybe<Scalars['Int']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMonetization?: InputMaybe<Scalars['Boolean']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinFee?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  rangeEnd: Scalars['Float']['input'];
  rangeStart: Scalars['Float']['input'];
  serviceType: ServiceType;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinFee?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['String']['input'];
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType: Scalars['String']['input'];
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName: Scalars['String']['input'];
  signeeRole: Scalars['String']['input'];
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePurchasedLicenseInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license: Scalars['Int']['input'];
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  promo?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
};

export type CreateRankingCategoryPointInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRankingPointCategoryInput = {
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRankingPointInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRankingTournamentCategoryInput = {
  rankingCategory: Scalars['Int']['input'];
  tournamentCategory: Scalars['Int']['input'];
};

export type CreateRegistrationPaymentInput = {
  VATFee: Scalars['Float']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryFee?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformProcessingFee: Scalars['Float']['input'];
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  registrationRequestIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  totalPartnerServiceFee: Scalars['Float']['input'];
  totalTournatedServiceFee: Scalars['Float']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateResourceServiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoundInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  matches?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingMetricContextInput = {
  metricId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStatInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateStripeSessionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSubscriptionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Payment_Method>;
  paymentStatus?: InputMaybe<Payment_Status>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateTeamInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTeamMemberInput = {
  member?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTemplateInput = {
  template?: InputMaybe<Scalars['Upload']['input']>;
};

export type CreateThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentAdditionalRefereeInput = {
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentCategoryGroupInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['String']['input'];
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: Scalars['String']['input'];
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentCategoryLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentDiscountInput = {
  discount?: InputMaybe<Scalars['Int']['input']>;
  numberOfCategories?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateTournamentOrganizerInput = {
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsManInput = {
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsWomanInput = {
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRefereeInput = {
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentRegistrationQuestionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentTeamMemberInput = {
  amountPaid?: InputMaybe<Scalars['Float']['input']>;
  blitzElo?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  fideTitle?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rapidElo?: InputMaybe<Scalars['String']['input']>;
  registrationRequest: Scalars['Int']['input'];
  standardElo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  tournament: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionHistoryInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  paidAmount: Scalars['Float']['input'];
  partnerFee: Scalars['Float']['input'];
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee: Scalars['Float']['input'];
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee: Scalars['Float']['input'];
  transactionType?: InputMaybe<TransactionType>;
  user: Scalars['Int']['input'];
};

export type CreateUserCoachInput = {
  coaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  user: Scalars['Int']['input'];
};

export type CreateUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserParentInput = {
  parent: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
};

export type CreateUserPlanInput = {
  plan?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserSportInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type Discipline = {
  __typename?: 'Discipline';
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Platform>>;
  resultType?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sport?: Maybe<Sport>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DisplaySetting = {
  __typename?: 'DisplaySetting';
  id: Scalars['Float']['output'];
  isDisplayAthleteChessTitle?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  sport?: Maybe<Sport>;
};

export type Draw = {
  __typename?: 'Draw';
  algo?: Maybe<Scalars['String']['output']>;
  consolationDrawEntries?: Maybe<Scalars['String']['output']>;
  consolationMainDraw?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  drawEntries?: Maybe<Array<DrawEntry>>;
  drawImage?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  genDraw?: Maybe<Scalars['String']['output']>;
  /** Group ids when generating draw from groups */
  groupIds?: Maybe<Scalars['JSON']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  is24DoubleEliminator?: Maybe<Scalars['Boolean']['output']>;
  isDisplayParticipantsClub?: Maybe<Scalars['Boolean']['output']>;
  isDistributeClubMembers?: Maybe<Scalars['Boolean']['output']>;
  liveStanding?: Maybe<LiveStanding>;
  mainDraw?: Maybe<Draw>;
  place?: Maybe<Scalars['String']['output']>;
  qualWinners?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DrawEntry = {
  __typename?: 'DrawEntry';
  bracketType?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  draw?: Maybe<Draw>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<TournamentRegistration>;
  entry1group?: Maybe<Scalars['String']['output']>;
  entry1groupId?: Maybe<Group>;
  entry1pig?: Maybe<Scalars['Float']['output']>;
  entry2?: Maybe<TournamentRegistration>;
  entry2group?: Maybe<Scalars['String']['output']>;
  entry2groupId?: Maybe<Group>;
  entry2pig?: Maybe<Scalars['Float']['output']>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<TournamentRegistration>;
};

export type DrawScore = {
  __typename?: 'DrawScore';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type FactSheet = {
  __typename?: 'FactSheet';
  createdAt: Scalars['DateTime']['output'];
  fieldTitle?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  options?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Federation = {
  __typename?: 'Federation';
  about?: Maybe<Scalars['String']['output']>;
  clubs?: Maybe<Array<Club>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  leagues?: Maybe<Array<LeagueOwner>>;
  logo?: Maybe<Scalars['String']['output']>;
  news?: Maybe<Array<FederationNews>>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<OrganizationPlatform>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FederationLeague = {
  __typename?: 'FederationLeague';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FederationNews = {
  __typename?: 'FederationNews';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FederationResult = {
  __typename?: 'FederationResult';
  federations: Array<Federation>;
  total: Scalars['Int']['output'];
};

export type FederationSummary = {
  __typename?: 'FederationSummary';
  activePeriod: ActivePeriod;
  federationName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalMonths: Scalars['Int']['output'];
  totalPaid: Scalars['Float']['output'];
};

export type FederationUserToken = {
  __typename?: 'FederationUserToken';
  accessToken: Scalars['String']['output'];
  federation: Federation;
};

/** Possible type of a fee */
export enum FeeType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type FindUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayMatches?: Maybe<Scalars['Boolean']['output']>;
  displayPlayOrder?: Maybe<Scalars['Boolean']['output']>;
  entries?: Maybe<Array<GroupEntry>>;
  external_id?: Maybe<Scalars['Float']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  matches?: Maybe<Array<GroupMatch>>;
  name?: Maybe<Scalars['String']['output']>;
  participantsAddScore?: Maybe<Scalars['Boolean']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupEntry = {
  __typename?: 'GroupEntry';
  external_id?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Group>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  place?: Maybe<Scalars['Float']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  score?: Maybe<Array<MatchScore>>;
  tournamentCategory?: Maybe<CategorySetting>;
};

export type GroupMatch = {
  __typename?: 'GroupMatch';
  conflict?: Maybe<Scalars['Boolean']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<GroupEntry>;
  entry1partner?: Maybe<GroupEntry>;
  entry2?: Maybe<GroupEntry>;
  entry2partner?: Maybe<GroupEntry>;
  external_id?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Group>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  rounds?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Array<MatchScore>>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<GroupEntry>;
  winnerPartner?: Maybe<GroupEntry>;
};

export type GroupResult = {
  __typename?: 'GroupResult';
  groups: Array<Group>;
  total: Scalars['Int']['output'];
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['Float']['output'];
  image: Scalars['String']['output'];
  tournament: Tournament;
};

export type Landing = {
  __typename?: 'Landing';
  id: Scalars['Int']['output'];
  landingAbbr?: Maybe<Scalars['String']['output']>;
  landingBaseUrl?: Maybe<Scalars['String']['output']>;
  landingCountry?: Maybe<Scalars['String']['output']>;
  landingCustomPlatform?: Maybe<Scalars['String']['output']>;
  landingHeadline?: Maybe<Scalars['String']['output']>;
  landingHeroLayout?: Maybe<Scalars['String']['output']>;
  landingLang?: Maybe<Scalars['String']['output']>;
  landingLayout?: Maybe<Scalars['String']['output']>;
  landingLocations?: Maybe<Scalars['String']['output']>;
  landingLogo?: Maybe<Scalars['String']['output']>;
  landingLogoDark?: Maybe<Scalars['String']['output']>;
  landingOrganizations?: Maybe<Scalars['String']['output']>;
  landingPrimary?: Maybe<Scalars['String']['output']>;
  landingPrimaryColor?: Maybe<Scalars['String']['output']>;
  landingSecondaryColor?: Maybe<Scalars['String']['output']>;
  landingSubtitle?: Maybe<Scalars['String']['output']>;
  landingSupportedSports?: Maybe<Scalars['String']['output']>;
  landingTeamPages?: Maybe<Scalars['String']['output']>;
  landingTitle?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
};

export type LandingMember = {
  __typename?: 'LandingMember';
  avatar?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  role?: Maybe<Scalars['String']['output']>;
  show_on_pages?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

export type LandingPotm = {
  __typename?: 'LandingPotm';
  age?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  placement?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  platform_code?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
};

export type LandingRoadmap = {
  __typename?: 'LandingRoadmap';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  item1?: Maybe<Scalars['String']['output']>;
  item2?: Maybe<Scalars['String']['output']>;
  item3?: Maybe<Scalars['String']['output']>;
  item4?: Maybe<Scalars['String']['output']>;
  item5?: Maybe<Scalars['String']['output']>;
  item6?: Maybe<Scalars['String']['output']>;
  item7?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LandingSlider = {
  __typename?: 'LandingSlider';
  button?: Maybe<Scalars['String']['output']>;
  date_added?: Maybe<Scalars['String']['output']>;
  date_from?: Maybe<Scalars['String']['output']>;
  date_to?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  platform_code?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sorting?: Maybe<Scalars['Float']['output']>;
};

export type League = {
  __typename?: 'League';
  abbreviation?: Maybe<Scalars['String']['output']>;
  abbreviationLogo?: Maybe<Scalars['String']['output']>;
  album?: Maybe<Album>;
  athlete?: Maybe<Array<Athlete>>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  enableOnlinePayments?: Maybe<Scalars['Boolean']['output']>;
  enableRankings?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  factSheet?: Maybe<Array<FactSheet>>;
  id: Scalars['Float']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  leagueCategory?: Maybe<Array<LeagueCategory>>;
  leagueRanking?: Maybe<Array<LeagueRanking>>;
  license?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<LeagueMember>>;
  news?: Maybe<Array<LeagueNews>>;
  owner?: Maybe<LeagueOwner>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  priority?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournamentCategoryGroups?: Maybe<TournamentCategoryGroup>;
  tournaments?: Maybe<Array<LeagueTournament>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type LeagueCategory = {
  __typename?: 'LeagueCategory';
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueDocument = {
  __typename?: 'LeagueDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isLeaguePage?: Maybe<Scalars['Boolean']['output']>;
  isRankings?: Maybe<Scalars['Boolean']['output']>;
  isTournamentCalendar?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueMember = {
  __typename?: 'LeagueMember';
  createdAt: Scalars['DateTime']['output'];
  displayMember?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isOrganization?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  member?: Maybe<User>;
  organizationEmail?: Maybe<Scalars['String']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPhone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Array<LeagueMemberRole>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueMemberRole = {
  __typename?: 'LeagueMemberRole';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  leagueMember?: Maybe<LeagueMember>;
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type LeagueMembersResult = {
  __typename?: 'LeagueMembersResult';
  members: Array<LeagueMember>;
  total: Scalars['Int']['output'];
};

export type LeagueNews = {
  __typename?: 'LeagueNews';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueOwner = {
  __typename?: 'LeagueOwner';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueRanking = {
  __typename?: 'LeagueRanking';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  place?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rankingCategory?: Maybe<LeagueCategory>;
  thirdPartyPoints?: Maybe<Scalars['String']['output']>;
  tournaments?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type LeagueRankingResult = {
  __typename?: 'LeagueRankingResult';
  rankings: Array<LeagueRanking>;
  top3: Array<LeagueRanking>;
  total: Scalars['Int']['output'];
};

export type LeagueResult = {
  __typename?: 'LeagueResult';
  league: Array<League>;
  total: Scalars['Int']['output'];
};

export type LeagueTournament = {
  __typename?: 'LeagueTournament';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueTournamentCategory = {
  __typename?: 'LeagueTournamentCategory';
  category?: Maybe<TournamentCategory>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type License = {
  __typename?: 'License';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  cantBuy?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isManagerPayingPartnerFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPlatformFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingStripeFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingTournatedFee?: Maybe<Scalars['Boolean']['output']>;
  leagues?: Maybe<Array<LicenseLeague>>;
  nationality?: Maybe<Scalars['String']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LicenseLeague = {
  __typename?: 'LicenseLeague';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Possible statuses of a payment */
export enum LicensePaymentStatus {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type LicenseQuestion = {
  __typename?: 'LicenseQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  purchasedLicense?: Maybe<PurchasedLicense>;
  question?: Maybe<AdditionalQuestion>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Possible statuses of a license */
export enum LicenseStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Upcoming = 'UPCOMING'
}

export type ListAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type ListBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type ListCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type ListCategorySettingInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  categoryType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ListClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator?: InputMaybe<Scalars['Int']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListClubMembers = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type ListClubServiceInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type ListClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListCoachInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  displayOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type ListCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListDisciplineInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['String']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListFactSheetInput = {
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListFederationInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federationEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListFederationNewsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Float']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListLeagueMemberInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  member?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ListLeagueNewsInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
};

export type ListLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListLiveStandingsInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Float']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Float']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Float']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Float']['input']>;
};

export type ListMatchesScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  groupEntry?: InputMaybe<Scalars['Int']['input']>;
  groupEntryPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListNewsInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postText?: InputMaybe<Scalars['String']['input']>;
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type ListOrganizationPlatformMembersInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ListOrganizationPlatformsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerSearchRequestInput = {
  requesterId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type ListPlatformDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalender?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName?: InputMaybe<Scalars['String']['input']>;
  signeeRole?: InputMaybe<Scalars['String']['input']>;
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type ListPurchasedLicensesInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Int']['input']>;
  licenseStatus?: InputMaybe<Scalars['String']['input']>;
  licenseStatusArray?: InputMaybe<Array<Scalars['String']['input']>>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priceRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  priceRangeStart?: InputMaybe<Scalars['Float']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeArray?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
  validUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListRankingCatgoryPointsInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListRankingPointsInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListResourceServiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListTeamInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListTeamMemberInput = {
  member?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type ListThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentCategoryGroupInput = {
  league?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentTeamMembersInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTransactionHistory = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserParentInput = {
  parent?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUsersInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type ListUsersLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveStanding = {
  __typename?: 'LiveStanding';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  segment?: Maybe<Scalars['String']['output']>;
  sorting?: Maybe<Scalars['String']['output']>;
  standings?: Maybe<Array<LiveStandingsEntry>>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LiveStandingsEntry = {
  __typename?: 'LiveStandingsEntry';
  country?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<GroupEntry>;
  group?: Maybe<Group>;
  groupPlace?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  liveStanding?: Maybe<LiveStanding>;
  place?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  pointsRatio?: Maybe<Scalars['Float']['output']>;
  setRatio?: Maybe<Scalars['Float']['output']>;
  sorting?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LoginUserInput = {
  /** email of the user */
  email: Scalars['String']['input'];
  /** password of the user */
  password: Scalars['String']['input'];
  /** remember user login for 7 days */
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  isUnderMaintenance?: Maybe<Scalars['Boolean']['output']>;
  maintenanceStartTime?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Match = {
  __typename?: 'Match';
  conflict?: Maybe<Scalars['Boolean']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  draw?: Maybe<Draw>;
  drawEntry1?: Maybe<TournamentRegistration>;
  drawEntry2?: Maybe<TournamentRegistration>;
  drawWinner?: Maybe<TournamentRegistration>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<TournamentRegistration>;
  entry1group?: Maybe<Scalars['String']['output']>;
  entry1partner?: Maybe<GroupEntry>;
  entry1pig?: Maybe<Scalars['Float']['output']>;
  entry2?: Maybe<TournamentRegistration>;
  entry2group?: Maybe<Scalars['String']['output']>;
  entry2partner?: Maybe<GroupEntry>;
  entry2pig?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Group>;
  groupEntry1?: Maybe<GroupEntry>;
  groupEntry2?: Maybe<GroupEntry>;
  groupWinner?: Maybe<GroupEntry>;
  groupWinnerPartner?: Maybe<GroupEntry>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  rounds?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  teamMembers?: Maybe<Array<TournamentTeamMember>>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  tournamentRegistration?: Maybe<TournamentRegistration>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<TournamentRegistration>;
};

export type MatchPartial = {
  __typename?: 'MatchPartial';
  court?: Maybe<Scalars['String']['output']>;
  courtName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  entry1Id?: Maybe<Scalars['Int']['output']>;
  entry2Id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
  tournamentCity?: Maybe<Scalars['String']['output']>;
  tournamentStartDate?: Maybe<Scalars['String']['output']>;
  tournamentTitle?: Maybe<Scalars['String']['output']>;
  user1?: Maybe<Scalars['String']['output']>;
  user1Avatar?: Maybe<Scalars['String']['output']>;
  user1Id?: Maybe<Scalars['Int']['output']>;
  user1Name?: Maybe<Scalars['String']['output']>;
  user1Surname?: Maybe<Scalars['String']['output']>;
  user2?: Maybe<Scalars['String']['output']>;
  user2Avatar?: Maybe<Scalars['String']['output']>;
  user2Country?: Maybe<Scalars['String']['output']>;
  user2Id?: Maybe<Scalars['Int']['output']>;
  user2Name?: Maybe<Scalars['String']['output']>;
  user2Nation?: Maybe<Scalars['String']['output']>;
  user2Surname?: Maybe<Scalars['String']['output']>;
};

export type MatchPartialV2 = {
  __typename?: 'MatchPartialV2';
  categoryname?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Court>;
  courtname?: Maybe<Scalars['String']['output']>;
  createdat?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  entry1id?: Maybe<Scalars['Int']['output']>;
  entry2id?: Maybe<Scalars['Int']['output']>;
  groupname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
  tournamentcity?: Maybe<Scalars['String']['output']>;
  tournamentenddate?: Maybe<Scalars['DateTime']['output']>;
  tournamentid?: Maybe<Scalars['Int']['output']>;
  tournamentlogo?: Maybe<Scalars['String']['output']>;
  tournamentstartdate?: Maybe<Scalars['DateTime']['output']>;
  tournamenttitle?: Maybe<Scalars['String']['output']>;
  user1?: Maybe<Scalars['String']['output']>;
  user1avatar?: Maybe<Scalars['String']['output']>;
  user1id?: Maybe<Scalars['Int']['output']>;
  user1name?: Maybe<Scalars['String']['output']>;
  user1surname?: Maybe<Scalars['String']['output']>;
  user2?: Maybe<Scalars['String']['output']>;
  user2avatar?: Maybe<Scalars['String']['output']>;
  user2country?: Maybe<Scalars['String']['output']>;
  user2id?: Maybe<Scalars['Int']['output']>;
  user2name?: Maybe<Scalars['String']['output']>;
  user2nation?: Maybe<Scalars['String']['output']>;
  user2surname?: Maybe<Scalars['String']['output']>;
  winnerid?: Maybe<Scalars['Int']['output']>;
};

export type MatchResult = {
  __typename?: 'MatchResult';
  matches: Array<Match>;
  total: Scalars['Int']['output'];
};

export type MatchScore = {
  __typename?: 'MatchScore';
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<GroupEntry>;
  entryPartner?: Maybe<GroupEntry>;
  group?: Maybe<Group>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<GroupMatch>;
  round?: Maybe<Scalars['Float']['output']>;
  roundFormat?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchStats = {
  __typename?: 'MatchStats';
  lost?: Maybe<Scalars['Int']['output']>;
  matches?: Maybe<Array<MatchPartial>>;
  total?: Maybe<Scalars['Int']['output']>;
  won?: Maybe<Scalars['Int']['output']>;
};

/** The different matches conflicts that can be found */
export enum MatchesConflicts {
  Court = 'COURT',
  Match = 'MATCH',
  Rest = 'REST'
}

export type MatchesScore = {
  __typename?: 'MatchesScore';
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<Group>;
  groupEntry?: Maybe<GroupEntry>;
  groupEntryPartner?: Maybe<GroupEntry>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<GroupMatch>;
  round?: Maybe<Scalars['Float']['output']>;
  roundFormat?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Media = {
  __typename?: 'Media';
  album?: Maybe<Album>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  photoCaption?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MobileVersion = {
  __typename?: 'MobileVersion';
  androidForceUpdate: Scalars['Boolean']['output'];
  androidReleaseNotes?: Maybe<Scalars['String']['output']>;
  androidVersion: Scalars['String']['output'];
  iOSForceUpdate: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  iosReleaseNotes?: Maybe<Scalars['String']['output']>;
  iosVersion: Scalars['String']['output'];
};

export type ModifiedFedaration = {
  __typename?: 'ModifiedFedaration';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ModifiedSport = {
  __typename?: 'ModifiedSport';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDrawEntry: DrawEntry;
  addDrawScore: DrawEntry;
  addFriend: User;
  addGroupMember: Group;
  addMember: League;
  adminLogin: User;
  adminOTPVerification: User;
  approveTournamentRegistrations: Array<TournamentRegistration>;
  changeRegistrationStatus: Array<TournamentRegistration>;
  changeResultPublishStatus: Array<SportFishingResult>;
  checkValidations: Scalars['JSON']['output'];
  checkValidations2: Scalars['JSON']['output'];
  checkValidationsToBeDepriciated: Scalars['JSON']['output'];
  cloneTournament: Tournament;
  copyLatinPassportNames: Array<User>;
  copyLeagueCategory: Array<LeagueCategory>;
  copyRankingCategoryPoints: Array<RankingCategoryPoint>;
  copyRankingPoint: Array<RankingPoint>;
  copyTournamentCategories: Array<TournamentCategory>;
  copyTournamentRanking: TournamentRanking;
  copyTournamentRegistration: Array<TournamentRegistration>;
  createAdditionalQuestion: AdditionalQuestion;
  createAlbum: Album;
  createAthlete: Athlete;
  createBanner: Banner;
  createCategory: Category;
  createCategoryRule: CategoryRule;
  createCategorySetting: CategorySetting;
  createCategoryTournament: CategoryTournament;
  createCheckoutSession: Scalars['JSONObject']['output'];
  createClub: Club;
  createClubAdministrator: ClubAdministrator;
  createClubCoach: ClubCoach;
  createClubMember: ClubMember;
  createClubNews: ClubNews;
  createClubServiceResource: ClubServiceResource;
  createClubsService: ClubService;
  createCourt: Court;
  createDiscipline: Discipline;
  createDisplaySetting: DisplaySetting;
  createDraw: Draw;
  createDrawEntry: DrawEntry;
  createDrawFromGroups: Draw;
  createDrawFromGroupsWithLiveStandings: Draw;
  createDrawScore: DrawScore;
  createDrawsFromCSV: Array<Draw>;
  createEmptyGroup: Array<Group>;
  createFactSheet: FactSheet;
  createFederation: FederationUserToken;
  createFederationByAdmin: Federation;
  createFederationLeague: FederationLeague;
  createFederationNews: FederationNews;
  createFederationsFromCSV: Array<Federation>;
  createGroup: Array<Group>;
  createGroupEntry: Array<GroupEntry>;
  createGroupEntryFromCSV: Array<GroupEntry>;
  createGroupFromCSV: Array<Group>;
  createGroupMatch: Array<GroupMatch>;
  createGroupMatchesFromCSV: Array<GroupMatch>;
  createImage: Image;
  createKingFormatGroups: Array<Group>;
  createLanding: Landing;
  createLandingFromCSV: Array<Landing>;
  createLandingMember: LandingMember;
  createLandingMemberFromCSV: Array<LandingMember>;
  createLandingPotm: LandingPotm;
  createLandingPotmFromCSV: Array<LandingPotm>;
  createLandingRoadmap: LandingRoadmap;
  createLandingRoadmapFromCSV: Array<LandingRoadmap>;
  createLandingSlider: LandingSlider;
  createLandingSliderFromCSV: Array<LandingSlider>;
  createLeague: League;
  createLeagueCategory: LeagueCategory;
  createLeagueDocument: Array<LeagueDocument>;
  createLeagueMember: LeagueMember;
  createLeagueMemberRole: LeagueMemberRole;
  createLeagueNews: LeagueNews;
  createLeagueOwner: LeagueOwner;
  createLeagueRanking: Array<LeagueRanking>;
  createLeagueRankingForChess: Array<Scalars['JSONObject']['output']>;
  createLeagueRankingFromCSV: Array<LeagueRanking>;
  createLeagueTournament: LeagueTournament;
  createLeagueTournamentCategory: LeagueTournamentCategory;
  createLeaguesFromCSV: Array<League>;
  createLeaguesFromJSON: Array<League>;
  createLicense: License;
  createLicenseLeague: LicenseLeague;
  createLicensePayment: Scalars['JSONObject']['output'];
  createLicenseQuestion: LicenseQuestion;
  createLicensesFromCSV: Array<License>;
  createLiveStanding: Array<LiveStanding>;
  createLiveStandingsEntry: LiveStandingsEntry;
  createLocations: SportFishingResultEntry;
  createMaintenance: Maintenance;
  createMatch: Match;
  createMatchScore: Array<MatchScore>;
  createMatchesScore: MatchesScore;
  createMedia: Media;
  createMediaFromCSV: Array<Media>;
  createMobileVersion: MobileVersion;
  createNews: News;
  createNewsFromJSON: Array<News>;
  createNotificationSubscription: Scalars['JSON']['output'];
  createOnboarding: Onboarding;
  createOrderOfPlay: Array<GroupMatch>;
  createOrderOfPlayDraws: Array<DrawEntry>;
  createOrderOfPlayForAllGroups: Array<GroupMatch>;
  createOrderOfPlayForKingsFormat: Array<GroupMatch>;
  createOrganizationPlatform: OrganizationPlatform;
  createOrganizationPlatformMember: OrganizationPlatformMember;
  createPairing: Pairing;
  createPairingEntry: PairingEntry;
  createPartner: Partner;
  createPartnerRequest: Scalars['JSONObject']['output'];
  createPartnerSearch: PartnerSearch;
  createPartnerSearchRequest: PartnerSearchRequest;
  createPartnersFromCSV: Array<Partner>;
  createPlan: Plan;
  createPlateformSport: PlateformSport;
  createPlatform: Platform;
  createPlatformCoach: PlatformCoach;
  createPlatformCoachFromCSV: Array<PlatformCoach>;
  createPlatformDocument: PlatformDocument;
  createPlatformFee: PlatformFee;
  createPlatformsFromCSV: Array<Platform>;
  createProPlan: Scalars['JSON']['output'];
  createPurchasedLicense: ResponseType;
  createPurchasedLicensesFromCSV: Array<PurchasedLicense>;
  createRankingCategoryPoint: RankingCategoryPoint;
  createRankingPoint: RankingPoint;
  createRankingPointCategory: RankingPointCategory;
  createRankingPointRule: RankingPointRule;
  createRankingPointsFromCSV: Array<RankingPoint>;
  createRankingTournamentCategory: RankingTournamentCategory;
  createRecords: Scalars['JSON']['output'];
  createRecordsForDoubles: Scalars['JSON']['output'];
  createRecordsForSingle: Scalars['JSON']['output'];
  createRegistrationRequest: TournamentRegistration;
  createResourceService: ResourceService;
  createRole: Role;
  createRound: Round;
  createSport: Sport;
  createSportFishingEntriesMatric: SportFishingEntriesMatric;
  createSportFishingEntriesMetricFromCSV: Array<SportFishingEntriesMatric>;
  createSportFishingMatric: SportFishingMatric;
  createSportFishingMetricContext: SportFishingMetricContext;
  createSportFishingMetricFromCSV: Array<SportFishingMatric>;
  createSportFishingResult: SportFishingResult;
  createSportFishingResultEntry: SportFishingResultEntry;
  createSportFishingResultForManualEntries: SportFishingResult;
  createSportFishingResultFromCSV: Array<SportFishingResult>;
  createStat: Stat;
  createStripePayment: Scalars['JSONObject']['output'];
  createStripeSession: Scalars['JSONObject']['output'];
  createSubscription: Subscription;
  createTeam: Team;
  createTeamMember: TeamMember;
  createTeamRegistrationRequest: TournamentRegistration;
  createTemplate: Template;
  createThirdPartyLicense: ThirdPartyLicense;
  createTournament: Tournament;
  createTournamentAdditionalReferee: TournamentAdditionalReferee;
  createTournamentCategoriesFromCSV: Array<TournamentCategory>;
  createTournamentCategory: TournamentCategory;
  createTournamentCategoryGroup: TournamentCategoryGroup;
  createTournamentCategoryLicense: TournamentCategoryLicense;
  createTournamentDiscount: TournamentDiscount;
  createTournamentDocument: TournamentDocument;
  createTournamentFactSheet: TournamentFactSheet;
  createTournamentFactSheets: Array<TournamentFactSheet>;
  createTournamentOrganizer: TournamentOrganizer;
  createTournamentRanking: TournamentRanking;
  createTournamentRankingEntryFromCSV: Array<TournamentRankingsEntry>;
  createTournamentRankingFromCSV: Array<TournamentRanking>;
  createTournamentRankingsEntry: TournamentRankingsEntry;
  createTournamentRankingsMan: TournamentRankingsMan;
  createTournamentRankingsWoman: TournamentRankingsWoman;
  createTournamentReferee: TournamentReferee;
  createTournamentRegistration: TournamentRegistration;
  createTournamentRegistrationPayment: Scalars['JSONObject']['output'];
  createTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  createTournamentRegistrations: Array<TournamentRegistration>;
  createTournamentRegistrationsFromCSVAsync: Array<TournamentRegistration>;
  createTournamentTeamMember: TournamentTeamMember;
  createTournamentsFromCSV: Array<Tournament>;
  createTournamentsFromCSVAsync: Array<Tournament>;
  createTournamentsFromJSON: Array<Tournament>;
  createTransactionHistory: TransactionHistory;
  createUserCoach: UserCoach;
  createUserLicense: UserLicense;
  createUserParent: UserParent;
  createUserPlan: UserPlan;
  createUserPurchasedLicense: ResponseType;
  createUserSport: UserSport;
  createUsersFromCSV: Array<User>;
  createUsersFromJSON: Array<User>;
  createUsersInBatchFromCSV: Array<User>;
  deleteRequest: TournamentTeamMember;
  deleteSportFishingEntriesMatricMedia: SportFishingEntriesMatric;
  deleteTournamentCategoryGroup: TournamentCategoryGroup;
  deleteTournamentMatches: Array<Scalars['JSONObject']['output']>;
  extendLicense: PurchasedLicense;
  extendSubscription: Scalars['JSON']['output'];
  findStats: Scalars['JSONObject']['output'];
  forgetPassword: Scalars['Boolean']['output'];
  forwardByes: Array<DrawEntry>;
  getOTPThroughToken: Scalars['JSONObject']['output'];
  hideUnhideAllDraws: Array<Draw>;
  hideUnhideAllGroups: Array<Group>;
  login: User;
  logoutUser: UserLogout;
  masterUpdateRegistrationSegment: Array<TournamentRegistration>;
  purchaseBasicPlan: Federation;
  recoverSingleGroup: Group;
  rejectTournamentRegistrations: Array<TournamentRegistration>;
  removeAdditionalQuestion: AdditionalQuestion;
  removeAlbum: Album;
  removeAthlete: Athlete;
  removeBanner: Banner;
  removeCache: Scalars['JSON']['output'];
  removeCategoriesFromTournamentCategoryGroup: TournamentCategoryGroup;
  removeCategory: Category;
  removeCategoryRule: CategoryRule;
  removeCategorySetting: CategorySetting;
  removeCategoryTournament: CategoryTournament;
  removeClub: Club;
  removeClubAdministrator: ClubAdministrator;
  removeClubCoach: ClubCoach;
  removeClubMember: ClubMember;
  removeClubNews: ClubNews;
  removeClubServiceResource: ClubServiceResource;
  removeClubsService: ClubService;
  removeCourt: Court;
  removeDiscipline: Discipline;
  removeDisplaySetting: DisplaySetting;
  removeDraw: Draw;
  removeDrawEntry: Array<DrawEntry>;
  removeDrawMatch: Array<DrawEntry>;
  removeDrawMatchScore: Array<DrawEntry>;
  removeDrawScore: DrawScore;
  removeFactSheet: FactSheet;
  removeFederation: Federation;
  removeFederationLeague: FederationLeague;
  removeFederationNews: FederationNews;
  removeFriend: User;
  removeGroup: Group;
  removeGroupEntry: Array<GroupEntry>;
  removeGroupMatch: GroupMatch;
  removeImage: Image;
  removeLanding: Landing;
  removeLandingMember: LandingMember;
  removeLandingPotm: LandingPotm;
  removeLandingRoadmap: LandingRoadmap;
  removeLandingSlider: LandingSlider;
  removeLeague: League;
  removeLeagueCategory: Array<LeagueCategory>;
  removeLeagueDocument: LeagueDocument;
  removeLeagueMember: LeagueMember;
  removeLeagueMemberRole: LeagueMemberRole;
  removeLeagueNews: LeagueNews;
  removeLeagueOwner: LeagueOwner;
  removeLeagueRanking: LeagueRanking;
  removeLeagueRankings: Array<LeagueRanking>;
  removeLeagueTournament: LeagueTournament;
  removeLeagueTournamentCategory: LeagueTournamentCategory;
  removeLicense: License;
  removeLicenseLeague: LicenseLeague;
  removeLicenseQuestion: LicenseQuestion;
  removeLiveStanding: LiveStanding;
  removeLiveStandingsEntry: LiveStandingsEntry;
  removeMaintenance: Scalars['Boolean']['output'];
  removeMatch: Match;
  removeMatchScore: MatchScore;
  removeMatchesScore: MatchesScore;
  removeMedia: Media;
  removeMediaList: Array<Media>;
  removeMobileVersion: Scalars['Boolean']['output'];
  removeMultipleDraws: Array<Draw>;
  removeMultipleGroups: Array<Group>;
  removeMultipleStandings: Array<LiveStanding>;
  removeMultipleTournamentRankings: TournamentRanking;
  removeMultipleTournamentRankingsEntries: Array<TournamentRankingsEntry>;
  removeNews: News;
  removeNotificationSubscription: Scalars['JSON']['output'];
  removeOnboarding: Onboarding;
  removeOrganizationPlatform: Scalars['JSON']['output'];
  removeOrganizationPlatformMember: OrganizationPlatformMember;
  removePairing: Pairing;
  removePairingEntry: PairingEntry;
  removePartner: Partner;
  removePartnerSearch: PartnerSearch;
  removePartnerSearchRequest: PartnerSearchRequest;
  removePlan: Plan;
  removePlateformSport: PlateformSport;
  removePlatform: Platform;
  removePlatformCoach: PlatformCoach;
  removePlatformDocument: PlatformDocument;
  removePlatformFee: PlatformFee;
  removePurchasedLicense: PurchasedLicense;
  removeRankingCategoryPoint: RankingCategoryPoint;
  removeRankingPoint: RankingPoint;
  removeRankingPointCategory: RankingPointCategory;
  removeRankingPointRule: RankingPointRule;
  removeRankingPoints: Scalars['JSONObject']['output'];
  removeRankingTournamentCategory: RankingTournamentCategory;
  removeResourceService: ResourceService;
  removeRole: Role;
  removeRound: Round;
  removeSingleGroup: Group;
  removeSport: Sport;
  removeSportFishingEntriesMatric: SportFishingEntriesMatric;
  removeSportFishingEntriesMatricBulk: Array<SportFishingEntriesMatric>;
  removeSportFishingMatric: SportFishingMatric;
  removeSportFishingResult: SportFishingResult;
  removeSportFishingResultEntry: SportFishingResultEntry;
  removeStat: Stat;
  removeSubscription: Subscription;
  removeTeam: Team;
  removeTeamMember: TeamMember;
  removeTemplate: Template;
  removeThirdPartyLicense: ThirdPartyLicense;
  removeTournament: Tournament;
  removeTournamentAdditionalReferee: TournamentAdditionalReferee;
  removeTournamentCategory: Array<TournamentCategory>;
  removeTournamentCategoryGroup: TournamentCategoryGroup;
  removeTournamentCategoryLicense: TournamentCategoryLicense;
  removeTournamentDiscount: TournamentDiscount;
  removeTournamentDocument: TournamentDocument;
  removeTournamentDraw: Draw;
  removeTournamentFactSheet: TournamentFactSheet;
  removeTournamentRanking: TournamentRanking;
  removeTournamentRankingsEntry: TournamentRankingsEntry;
  removeTournamentRankingsMan: TournamentRankingsMan;
  removeTournamentRankingsWoman: TournamentRankingsWoman;
  removeTournamentReferee: TournamentReferee;
  removeTournamentRegistration: TournamentRegistration;
  removeTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  removeTournamentTeamMember: TournamentTeamMember;
  removeTransactionHistory: TransactionHistory;
  removeUser: User;
  removeUserAccount: User;
  removeUserCoach: UserCoach;
  removeUserLicense: UserLicense;
  removeUserParent: UserParent;
  removeUserPlan: UserPlan;
  removeUserSport: UserSport;
  renewUserLicense: ResponseType;
  sendNotification: Scalars['String']['output'];
  signUp: User;
  submitResults: SportFishingResultEntry;
  subscribeEmail: Scalars['String']['output'];
  subscriptionFilters: SubscriptionFilters;
  swapDrawMatches: Array<DrawEntry>;
  swapGroupEntries: Array<Scalars['JSON']['output']>;
  swapGroupMatches: Array<GroupMatch>;
  swapMatches: Array<Match>;
  toggleNotificationSubscription: Scalars['JSON']['output'];
  tournamentLogin: User;
  updateAdditionalQuestion: AdditionalQuestion;
  updateAlbum: Album;
  updateAthlete: Athlete;
  updateBanner: Banner;
  updateCategory: Category;
  updateCategoryRule: CategoryRule;
  updateCategorySetting: CategorySetting;
  updateCategorySettings: Array<CategorySetting>;
  updateCategoryTournament: CategoryTournament;
  updateClub: Club;
  updateClubAdministrator: ClubAdministrator;
  updateClubCoach: ClubCoach;
  updateClubMember: ClubMember;
  updateClubNews: ClubNews;
  updateClubServiceResource: ClubServiceResource;
  updateClubsService: ClubService;
  updateCourt: Court;
  updateCourtSorting: Array<Court>;
  updateDUPRRating: Array<TournamentRegistration>;
  updateDiscipline: Discipline;
  updateDisciplineSorting: Array<Discipline>;
  updateDisplaySetting: DisplaySetting;
  updateDraw: Draw;
  updateDrawEntry: Array<DrawEntry>;
  updateDrawScore: DrawScore;
  updateFactSheet: FactSheet;
  updateFactSheetSorting: Array<FactSheet>;
  updateFederation: Federation;
  updateFederationLeague: FederationLeague;
  updateFederationNews: FederationNews;
  updateGroup: Group;
  updateGroupEntry: GroupEntry;
  updateGroupMatch: GroupMatch;
  updateGroupPositions: Array<Scalars['JSONObject']['output']>;
  updateImage: Image;
  updateLanding: Landing;
  updateLandingMember: LandingMember;
  updateLandingPotm: LandingPotm;
  updateLandingRoadmap: LandingRoadmap;
  updateLandingSlider: LandingSlider;
  updateLeague: League;
  updateLeagueCategory: Array<LeagueCategory>;
  updateLeagueDocument: LeagueDocument;
  updateLeagueMember: LeagueMember;
  updateLeagueMemberRole: LeagueMemberRole;
  updateLeagueNews: LeagueNews;
  updateLeagueRanking: LeagueRanking;
  updateLeagueRankingPoints: Array<LeagueRanking>;
  updateLeagueRankings: Array<LeagueRanking>;
  updateLeagueTournament: LeagueTournament;
  updateLeagueTournamentCategory: LeagueTournamentCategory;
  updateLicense: License;
  updateLicenseLeague: LicenseLeague;
  updateLicenseQuestion: LicenseQuestion;
  updateLicensesPaymentMethod: Array<License>;
  updateLiveStanding: LiveStanding;
  updateLiveStandingsEntry: LiveStandingsEntry;
  updateMaintenance: Maintenance;
  updateMatch: Match;
  updateMatchScore: MatchScore;
  updateMatchesScore: MatchesScore;
  updateMedia: Media;
  updateMobileVersion: MobileVersion;
  updateMultipleCourts: Array<Court>;
  updateMultipleDrawMatches: Array<Scalars['JSONObject']['output']>;
  updateMultipleGroupMatches: Array<MatchScore>;
  updateMultipleGroups: Array<Group>;
  updateMultipleMatches: Array<Match>;
  updateNews: News;
  updateNotificationSubscription: Scalars['JSON']['output'];
  updateOnboarding: Onboarding;
  updateOrganizationPlatform: OrganizationPlatform;
  updateOrganizationPlatformMember: OrganizationPlatformMember;
  updatePairing: Pairing;
  updatePairingEntry: PairingEntry;
  updatePairingScore: PairingEntry;
  updatePartner: Partner;
  updatePartnerSearch: PartnerSearch;
  updatePartnerSorting: Array<Partner>;
  updatePlan: Plan;
  updatePlateformSport: PlateformSport;
  updatePlatform: Platform;
  updatePlatformCoach: PlatformCoach;
  updatePlatformDocument: PlatformDocument;
  updatePlatformDocumentSorting: Array<PlatformDocument>;
  updatePlatformFee: PlatformFee;
  updatePurchasedLicense: PurchasedLicense;
  updateRankingCategoryPoints: Array<RankingCategoryPoint>;
  updateRankingPoint: Array<RankingCategoryPoint>;
  updateRankingPointCategory: RankingPointCategory;
  updateRankingPointRule: RankingPointRule;
  updateRankingTournamentCategory: RankingTournamentCategory;
  updateRegistrationRequest: TournamentRegistration;
  updateRegistrationSegment: Array<TournamentRegistration>;
  updateRegistrationsRankings: Array<TournamentRegistration>;
  updateResourceService: ResourceService;
  updateRole: Role;
  updateRound: Round;
  updateSimpleRankingPoint: RankingPoint;
  updateSport: Sport;
  updateSportFishingEntriesMatric: SportFishingEntriesMatric;
  updateSportFishingEntriesMatricBulk: Array<SportFishingEntriesMatric>;
  updateSportFishingMatric: SportFishingMatric;
  updateSportFishingResult: SportFishingResult;
  updateSportFishingResultEntry: SportFishingResultEntry;
  updateSportSorting: Array<Sport>;
  updateSubscription: Subscription;
  updateTeam: Team;
  updateTeamMember: TeamMember;
  updateTemplate: Template;
  updateThirdPartyLicense: ThirdPartyLicense;
  updateTournament: Tournament;
  updateTournamentAdditionalReferee: TournamentAdditionalReferee;
  updateTournamentCategories: Array<TournamentCategory>;
  updateTournamentCategory: TournamentCategory;
  updateTournamentCategoryGroup: TournamentCategoryGroup;
  updateTournamentCategoryLicense: TournamentCategoryLicense;
  updateTournamentCategorySorting: Array<TournamentCategory>;
  updateTournamentDiscount: TournamentDiscount;
  updateTournamentDocument: TournamentDocument;
  updateTournamentFactSheet: TournamentFactSheet;
  updateTournamentMatches: Array<Scalars['JSONObject']['output']>;
  updateTournamentOrganizer: TournamentOrganizer;
  updateTournamentRanking: TournamentRanking;
  updateTournamentRankingsEntry: TournamentRankingsEntry;
  updateTournamentRankingsMan: TournamentRankingsMan;
  updateTournamentRankingsWoman: TournamentRankingsWoman;
  updateTournamentReferee: TournamentReferee;
  updateTournamentRegistration: TournamentRegistration;
  updateTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  updateTournamentRegistrations: Array<TournamentRegistration>;
  updateTournamentTeamMember: TournamentTeamMember;
  updateTournamentTeamMemberDUPR: TournamentRegistration;
  updateTournamentsCountry: Array<Tournament>;
  updateTournamentsFromCSVAsync: Array<Tournament>;
  updateTransactionHistory: TransactionHistory;
  updateUser: User;
  updateUserCoach: UserCoach;
  updateUserGender: UsersResult;
  updateUserLicense: UserLicense;
  updateUserParent: UserParent;
  updateUserPassword: User;
  updateUserPlan: UserPlan;
  updateUserPlatform: Array<User>;
  updateUserSport: UserSport;
  userLogin: User;
  withdrawRegistrations: TournamentRegistration;
};


export type MutationAddDrawEntryArgs = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationAddDrawScoreArgs = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationAddFriendArgs = {
  friendId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddGroupMemberArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationAddMemberArgs = {
  updateLeagueInput: UpdateLeagueInput;
};


export type MutationAdminLoginArgs = {
  query: LoginUserInput;
};


export type MutationAdminOtpVerificationArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


export type MutationApproveTournamentRegistrationsArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationChangeRegistrationStatusArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};


export type MutationChangeResultPublishStatusArgs = {
  updateSportFishingResultInput: UpdateSportFishingResultInput;
};


export type MutationCheckValidationsArgs = {
  category: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};


export type MutationCheckValidations2Args = {
  category: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};


export type MutationCheckValidationsToBeDepriciatedArgs = {
  category: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};


export type MutationCloneTournamentArgs = {
  endDate: Scalars['String']['input'];
  entryDeadline: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tournamentId: Scalars['Float']['input'];
  withdrawlDeadline: Scalars['String']['input'];
};


export type MutationCopyLeagueCategoryArgs = {
  catIds: Array<Scalars['Int']['input']>;
  leagueId: Scalars['Int']['input'];
};


export type MutationCopyRankingCategoryPointsArgs = {
  createRankingCategoryPointInput: CreateRankingCategoryPointInput;
};


export type MutationCopyRankingPointArgs = {
  createRankingPointInput: CreateRankingPointInput;
};


export type MutationCopyTournamentCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
  leagueId: Scalars['Int']['input'];
};


export type MutationCopyTournamentRankingArgs = {
  createTournamentRankingInput: CreateTournamentRankingInput;
};


export type MutationCopyTournamentRegistrationArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateAdditionalQuestionArgs = {
  createAdditionalQuestionInput: CreateAdditionalQuestionInput;
};


export type MutationCreateAlbumArgs = {
  createAlbumInput: CreateAlbumInput;
};


export type MutationCreateAthleteArgs = {
  createAthleteInput: CreateAthleteInput;
};


export type MutationCreateBannerArgs = {
  createBannerInput: CreateBannerInput;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateCategoryRuleArgs = {
  createCategoryRuleInput: CreateCategoryRuleInput;
};


export type MutationCreateCategorySettingArgs = {
  createCategorySettingInput: CreateCategorySettingInput;
};


export type MutationCreateCategoryTournamentArgs = {
  createCategoryTournamentInput: CreateCategoryTournamentInput;
};


export type MutationCreateCheckoutSessionArgs = {
  createRegistrationPaymentInput: CreateRegistrationPaymentInput;
};


export type MutationCreateClubArgs = {
  createClubInput: CreateClubInput;
  createClubServiceResourceInput?: InputMaybe<Array<CreateClubServiceResourceInput>>;
};


export type MutationCreateClubAdministratorArgs = {
  createClubAdministratorInput: CreateClubAdministratorInput;
};


export type MutationCreateClubCoachArgs = {
  createClubCoachInput: CreateClubCoachInput;
};


export type MutationCreateClubMemberArgs = {
  createClubMemberInput: CreateClubMemberInput;
};


export type MutationCreateClubNewsArgs = {
  createClubNewsInput: CreateClubNewsInput;
};


export type MutationCreateClubServiceResourceArgs = {
  createClubServiceResourceInput: CreateClubServiceResourceInput;
};


export type MutationCreateClubsServiceArgs = {
  createClubsServiceInput: CreateClubsServiceInput;
};


export type MutationCreateCourtArgs = {
  createCourtInput: CreateCourtInput;
};


export type MutationCreateDisciplineArgs = {
  createDisciplineInput: CreateDisciplineInput;
};


export type MutationCreateDisplaySettingArgs = {
  createDisplaySettingInput: CreateDisplaySettingInput;
};


export type MutationCreateDrawArgs = {
  createDrawInput: CreateDrawInput;
};


export type MutationCreateDrawEntryArgs = {
  createDrawEntryInput: CreateDrawEntryInput;
};


export type MutationCreateDrawFromGroupsArgs = {
  createDrawInput: CreateDrawInput;
  drawId?: InputMaybe<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
};


export type MutationCreateDrawFromGroupsWithLiveStandingsArgs = {
  createDrawInput: CreateDrawInput;
  drawId?: InputMaybe<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  places?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationCreateDrawScoreArgs = {
  createDrawScoreInput: CreateDrawScoreInput;
};


export type MutationCreateEmptyGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationCreateFactSheetArgs = {
  createFactSheetInput: CreateFactSheetInput;
};


export type MutationCreateFederationArgs = {
  createCustomEntryFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createCustomLicenseFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createFederationInput: CreateFederationInput;
};


export type MutationCreateFederationByAdminArgs = {
  createCustomEntryFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createCustomLicenseFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createFederationInput: CreateFederationInput;
};


export type MutationCreateFederationLeagueArgs = {
  createFederationLeagueInput: CreateFederationLeagueInput;
};


export type MutationCreateFederationNewsArgs = {
  createFederationNewsInput: CreateFederationNewsInput;
};


export type MutationCreateGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationCreateGroupEntryArgs = {
  createGroupEntryInput: CreateGroupEntryInput;
};


export type MutationCreateGroupMatchArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateImageArgs = {
  createImageInput: CreateImageInput;
};


export type MutationCreateKingFormatGroupsArgs = {
  filter: ListGroupInput;
};


export type MutationCreateLandingArgs = {
  createLandingInput: CreateLandingInput;
};


export type MutationCreateLandingMemberArgs = {
  createLandingMemberInput: CreateLandingMemberInput;
};


export type MutationCreateLandingPotmArgs = {
  createLandingPotmInput: CreateLandingPotmInput;
};


export type MutationCreateLandingRoadmapArgs = {
  createLandingRoadmapInput: CreateLandingRoadmapInput;
};


export type MutationCreateLandingSliderArgs = {
  createLandingSliderInput: CreateLandingSliderInput;
};


export type MutationCreateLeagueArgs = {
  createFactSheetInput?: InputMaybe<Array<CreateFactSheetInput>>;
  createLeagueInput: CreateLeagueInput;
};


export type MutationCreateLeagueCategoryArgs = {
  createLeagueCategoryInput: CreateLeagueCategoryInput;
};


export type MutationCreateLeagueDocumentArgs = {
  createLeagueDocumentInput?: InputMaybe<Array<CreateLeagueDocumentInput>>;
};


export type MutationCreateLeagueMemberArgs = {
  createLeagueMemberInput: CreateLeagueMemberInput;
};


export type MutationCreateLeagueMemberRoleArgs = {
  createLeagueMemberRoleInput: CreateLeagueMemberRoleInput;
};


export type MutationCreateLeagueNewsArgs = {
  createLeagueNewsInput: CreateLeagueNewsInput;
};


export type MutationCreateLeagueOwnerArgs = {
  createLeagueOwnerInput: CreateLeagueOwnerInput;
};


export type MutationCreateLeagueRankingArgs = {
  createLeagueRankingInput: CreateLeagueRankingInput;
};


export type MutationCreateLeagueRankingForChessArgs = {
  createLeagueRankingInput: CreateLeagueRankingInput;
};


export type MutationCreateLeagueTournamentArgs = {
  createLeagueTournamentInput: CreateLeagueTournamentInput;
};


export type MutationCreateLeagueTournamentCategoryArgs = {
  createLeagueTournamentCategoryInput: CreateLeagueTournamentCategoryInput;
};


export type MutationCreateLeaguesFromJsonArgs = {
  createLeagueInput: CreateLeagueInput;
};


export type MutationCreateLicenseArgs = {
  createLicenseInput: CreateLicenseInput;
};


export type MutationCreateLicenseLeagueArgs = {
  createLicenseLeagueInput: CreateLicenseLeagueInput;
};


export type MutationCreateLicensePaymentArgs = {
  createLicensePaymentInput: CreateLicensePaymentInput;
};


export type MutationCreateLicenseQuestionArgs = {
  createLicenseQuestionInput: CreateLicenseQuestionInput;
};


export type MutationCreateLiveStandingArgs = {
  createLiveStandingInput: CreateLiveStandingInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateLiveStandingsEntryArgs = {
  createLiveStandingsEntryInput: CreateLiveStandingsEntryInput;
};


export type MutationCreateLocationsArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
  locations?: InputMaybe<Scalars['Int']['input']>;
  setPositions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMaintenanceArgs = {
  isUnderMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMatchArgs = {
  createMatchInput: CreateMatchInput;
};


export type MutationCreateMatchScoreArgs = {
  createMatchScoreInput: CreateMatchScoreInput;
};


export type MutationCreateMatchesScoreArgs = {
  createMatchesScoreInput: CreateMatchesScoreInput;
};


export type MutationCreateMediaArgs = {
  createMediaInput: CreateMediaInput;
};


export type MutationCreateMobileVersionArgs = {
  androidForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  androidReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  androidVersion: Scalars['String']['input'];
  iOSForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  iosReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  iosVersion: Scalars['String']['input'];
};


export type MutationCreateNewsArgs = {
  createNewsInput: CreateNewsInput;
};


export type MutationCreateNotificationSubscriptionArgs = {
  deviceType: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCreateOnboardingArgs = {
  createOnboardingInput: CreateOnboardingInput;
};


export type MutationCreateOrderOfPlayArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrderOfPlayDrawsArgs = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationCreateOrderOfPlayForAllGroupsArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrderOfPlayForKingsFormatArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrganizationPlatformArgs = {
  createOrganizationPlatformInput: CreateOrganizationPlatformInput;
};


export type MutationCreateOrganizationPlatformMemberArgs = {
  createOrganizationPlatformMemberInput: CreateOrganizationPlatformMemberInput;
  createUserInput?: InputMaybe<CreateUserInput>;
};


export type MutationCreatePairingArgs = {
  createPairingInput: CreatePairingInput;
};


export type MutationCreatePairingEntryArgs = {
  createPairingEntryInput: CreatePairingEntryInput;
};


export type MutationCreatePartnerArgs = {
  createPartnerInput: CreatePartnerInput;
};


export type MutationCreatePartnerRequestArgs = {
  createPartnerSearchInput: CreatePartnerSearchInput;
  partnerId: Scalars['Int']['input'];
};


export type MutationCreatePartnerSearchArgs = {
  createPartnerSearchInput: CreatePartnerSearchInput;
};


export type MutationCreatePartnerSearchRequestArgs = {
  createPartnerSearchRequestInput: CreatePartnerSearchRequestInput;
};


export type MutationCreatePlanArgs = {
  createPlanInput: CreatePlanInput;
};


export type MutationCreatePlateformSportArgs = {
  createPlateformSportInput: CreatePlateformSportInput;
};


export type MutationCreatePlatformArgs = {
  createCustomEntryFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createCustomLicenseFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createFederationInput?: InputMaybe<CreateFederationInput>;
  createOrganizationPlatformInput?: InputMaybe<CreateOrganizationPlatformInput>;
  createPlatformInput: CreatePlatformInput;
};


export type MutationCreatePlatformCoachArgs = {
  createPlatformCoachInput: CreatePlatformCoachInput;
  createUserInput?: InputMaybe<CreateUserInput>;
};


export type MutationCreatePlatformDocumentArgs = {
  createPlatformDocumentInput: CreatePlatformDocumentInput;
};


export type MutationCreatePlatformFeeArgs = {
  createPlatformFeeInput: CreatePlatformFeeInput;
};


export type MutationCreateProPlanArgs = {
  createBasicPlanInput: CreateSubscriptionInput;
  months: Scalars['Int']['input'];
};


export type MutationCreatePurchasedLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationCreateRankingCategoryPointArgs = {
  createRankingCategoryPointInput: CreateRankingCategoryPointInput;
};


export type MutationCreateRankingPointArgs = {
  createRankingPointInput: CreateRankingPointInput;
};


export type MutationCreateRankingPointCategoryArgs = {
  createRankingPointCategoryInput: CreateRankingPointCategoryInput;
};


export type MutationCreateRankingPointRuleArgs = {
  createRankingPointRuleInput: CreateRankingPointRuleInput;
};


export type MutationCreateRankingTournamentCategoryArgs = {
  createRankingTournamentCategoryInput: CreateRankingTournamentCategoryInput;
};


export type MutationCreateRecordsArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRecordsForDoublesArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRecordsForSingleArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  updateRankings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateResourceServiceArgs = {
  createResourceServiceInput: CreateResourceServiceInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRoundArgs = {
  createRoundInput: CreateRoundInput;
};


export type MutationCreateSportArgs = {
  createSportInput: CreateSportInput;
};


export type MutationCreateSportFishingEntriesMatricArgs = {
  createSportFishingEntriesMatricInput: CreateSportFishingEntriesMatricInput;
};


export type MutationCreateSportFishingMatricArgs = {
  createSportFishingMatricInput: CreateSportFishingMatricInput;
};


export type MutationCreateSportFishingMetricContextArgs = {
  input: CreateSportFishingMetricContextInput;
};


export type MutationCreateSportFishingResultArgs = {
  createSportFishingResultInput: CreateSportFishingResultInput;
};


export type MutationCreateSportFishingResultEntryArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
};


export type MutationCreateSportFishingResultForManualEntriesArgs = {
  createSportFishingResultInput: CreateSportFishingResultInput;
  entryId: Scalars['Int']['input'];
  sportFishingResult: Scalars['Int']['input'];
};


export type MutationCreateStatArgs = {
  createStatInput: CreateStatInput;
};


export type MutationCreateStripePaymentArgs = {
  amount: Scalars['Float']['input'];
  connectedAccountId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCreateStripeSessionArgs = {
  createStripeSessionInput: CreateStripeSessionInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationCreateTeamArgs = {
  createTeamInput: CreateTeamInput;
};


export type MutationCreateTeamMemberArgs = {
  createTeamMemberInput: CreateTeamMemberInput;
};


export type MutationCreateTeamRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateTemplateArgs = {
  createTemplateInput: CreateTemplateInput;
};


export type MutationCreateThirdPartyLicenseArgs = {
  createThirdPartyLicenseInput: CreateThirdPartyLicenseInput;
};


export type MutationCreateTournamentArgs = {
  createTournamentInput: CreateTournamentInput;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTournamentAdditionalRefereeArgs = {
  createTournamentAdditionalRefereeInput: CreateTournamentAdditionalRefereeInput;
};


export type MutationCreateTournamentCategoryArgs = {
  createTournamentCategoryInput: CreateTournamentCategoryInput;
};


export type MutationCreateTournamentCategoryGroupArgs = {
  createTournamentCategoryGroupInput: CreateTournamentCategoryGroupInput;
};


export type MutationCreateTournamentCategoryLicenseArgs = {
  createTournamentCategoryLicenseInput: CreateTournamentCategoryLicenseInput;
};


export type MutationCreateTournamentDiscountArgs = {
  createTournamentDiscountInput: CreateTournamentDiscountInput;
};


export type MutationCreateTournamentDocumentArgs = {
  createTournamentDocumentInput: CreateTournamentDocumentInput;
};


export type MutationCreateTournamentFactSheetArgs = {
  createTournamentFactSheetInput: CreateTournamentFactSheetInput;
};


export type MutationCreateTournamentFactSheetsArgs = {
  createTournamentFactSheetInput?: InputMaybe<Array<CreateTournamentFactSheetInput>>;
};


export type MutationCreateTournamentOrganizerArgs = {
  createTournamentOrganizerInput: CreateTournamentOrganizerInput;
};


export type MutationCreateTournamentRankingArgs = {
  createTournamentRankingInput: CreateTournamentRankingInput;
};


export type MutationCreateTournamentRankingsEntryArgs = {
  createTournamentRankingsEntryInput: CreateTournamentRankingsEntryInput;
};


export type MutationCreateTournamentRankingsManArgs = {
  createTournamentRankingsManInput: CreateTournamentRankingsManInput;
};


export type MutationCreateTournamentRankingsWomanArgs = {
  createTournamentRankingsWomanInput: CreateTournamentRankingsWomanInput;
};


export type MutationCreateTournamentRefereeArgs = {
  createTournamentRefereeInput: CreateTournamentRefereeInput;
};


export type MutationCreateTournamentRegistrationArgs = {
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateTournamentRegistrationPaymentArgs = {
  createRegistrationPaymentInput: CreateRegistrationPaymentInput;
};


export type MutationCreateTournamentRegistrationQuestionArgs = {
  createTournamentRegistrationQuestionInput: CreateTournamentRegistrationQuestionInput;
};


export type MutationCreateTournamentRegistrationsArgs = {
  createTournamentRegistrationInputs?: InputMaybe<Array<CreateTournamentRegistrationInput>>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTournamentTeamMemberArgs = {
  createTournamentTeamMemberInput: CreateTournamentTeamMemberInput;
};


export type MutationCreateTransactionHistoryArgs = {
  createTransactionHistoryInput: CreateTransactionHistoryInput;
};


export type MutationCreateUserCoachArgs = {
  createUserCoachInput: CreateUserCoachInput;
};


export type MutationCreateUserLicenseArgs = {
  createUserLicenseInput: CreateUserLicenseInput;
};


export type MutationCreateUserParentArgs = {
  createUserParentInput: CreateUserParentInput;
};


export type MutationCreateUserPlanArgs = {
  createUserPlanInput: CreateUserPlanInput;
};


export type MutationCreateUserPurchasedLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationCreateUserSportArgs = {
  createUserSportInput: CreateUserSportInput;
};


export type MutationDeleteRequestArgs = {
  id: Array<Scalars['Int']['input']>;
};


export type MutationDeleteSportFishingEntriesMatricMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTournamentMatchesArgs = {
  drawIds: Array<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  matchIds: Array<Scalars['Int']['input']>;
};


export type MutationExtendLicenseArgs = {
  id: Scalars['Int']['input'];
  yearsToAdd: Scalars['Int']['input'];
};


export type MutationExtendSubscriptionArgs = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  federationId: Scalars['Int']['input'];
  months: Scalars['Int']['input'];
  plan: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
};


export type MutationFindStatsArgs = {
  createStatInput: CreateStatInput;
};


export type MutationForgetPasswordArgs = {
  email: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForwardByesArgs = {
  entryIds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};


export type MutationHideUnhideAllDrawsArgs = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationHideUnhideAllGroupsArgs = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationLoginArgs = {
  query: LoginUserInput;
};


export type MutationLogoutUserArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMasterUpdateRegistrationSegmentArgs = {
  categoryId: Scalars['Float']['input'];
  segment?: InputMaybe<Array<RegistrationSegment>>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationPurchaseBasicPlanArgs = {
  createFederationInput: CreateFederationInput;
};


export type MutationRecoverSingleGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRejectTournamentRegistrationsArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationRemoveAdditionalQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAlbumArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAthleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveBannerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCategoriesFromTournamentCategoryGroupArgs = {
  removeTournamentCategoriesInput: RemoveTournamentCategoriesInput;
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategorySettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubServiceResourceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubsServiceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCourtArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDisciplineArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDisplaySettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawMatchArgs = {
  drawId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveDrawMatchScoreArgs = {
  drawId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveDrawScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFriendArgs = {
  friendId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveGroupEntryArgs = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<Scalars['Int']['input']>;
  isKingFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveGroupMatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveImageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingPotmArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingRoadmapArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingSliderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueCategoryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveLeagueDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueMemberRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueOwnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueRankingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueRankingsArgs = {
  date: Scalars['String']['input'];
  league: Scalars['Int']['input'];
  rankingCategory: Scalars['Int']['input'];
};


export type MutationRemoveLeagueTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLicenseLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLicenseQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLiveStandingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLiveStandingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMaintenanceArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveMatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMatchScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMatchesScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMediaListArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMobileVersionArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveMultipleDrawsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleStandingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleTournamentRankingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleTournamentRankingsEntriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveNotificationSubscriptionArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveOnboardingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOrganizationPlatformArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOrganizationPlatformMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePairingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePairingEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerSearchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerSearchRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlateformSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformFeeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePurchasedLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingCategoryPointArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveRankingPointArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveRankingTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveResourceServiceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRoundArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSingleGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingEntriesMatricArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingEntriesMatricBulkArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveSportFishingMatricArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingResultArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingResultEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveStatArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTeamArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveThirdPartyLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveTournamentAdditionalRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentCategoryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentCategoryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDiscountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDrawArgs = {
  tournament: Scalars['Int']['input'];
};


export type MutationRemoveTournamentFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsManArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsWomanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRegistrationArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveTournamentRegistrationQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTransactionHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveUserAccountArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveUserCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserParentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserPlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRenewUserLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationSendNotificationArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSignUpArgs = {
  createUserInput: CreateUserInput;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitResultsArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
};


export type MutationSubscribeEmailArgs = {
  email: Scalars['String']['input'];
  topicArn?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscriptionFiltersArgs = {
  connectedAccountId: Scalars['String']['input'];
};


export type MutationSwapDrawMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationSwapGroupEntriesArgs = {
  entry1: Scalars['Int']['input'];
  entry2: Scalars['Int']['input'];
  group1Id?: InputMaybe<Scalars['Int']['input']>;
  group2Id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSwapGroupMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationSwapMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationToggleNotificationSubscriptionArgs = {
  status: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationTournamentLoginArgs = {
  query: LoginUserInput;
};


export type MutationUpdateAdditionalQuestionArgs = {
  updateAdditionalQuestionInput: UpdateAdditionalQuestionInput;
};


export type MutationUpdateAlbumArgs = {
  updateAlbumInput: UpdateAlbumInput;
};


export type MutationUpdateAthleteArgs = {
  updateAthleteInput: UpdateAthleteInput;
};


export type MutationUpdateBannerArgs = {
  updateBannerInput: UpdateBannerInput;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateCategoryRuleArgs = {
  updateCategoryRuleInput: UpdateCategoryRuleInput;
};


export type MutationUpdateCategorySettingArgs = {
  updateCategorySettingInput: UpdateCategorySettingInput;
};


export type MutationUpdateCategorySettingsArgs = {
  categryIds: Array<Scalars['Int']['input']>;
  updateCategorySettingInput: UpdateCategorySettingInput;
};


export type MutationUpdateCategoryTournamentArgs = {
  updateCategoryTournamentInput: UpdateCategoryTournamentInput;
};


export type MutationUpdateClubArgs = {
  updateClubInput: UpdateClubInput;
};


export type MutationUpdateClubAdministratorArgs = {
  updateClubAdministratorInput: UpdateClubAdministratorInput;
};


export type MutationUpdateClubCoachArgs = {
  updateClubCoachInput: UpdateClubCoachInput;
};


export type MutationUpdateClubMemberArgs = {
  updateClubMemberInput: UpdateClubMemberInput;
};


export type MutationUpdateClubNewsArgs = {
  updateClubNewsInput: UpdateClubNewsInput;
};


export type MutationUpdateClubServiceResourceArgs = {
  updateClubServiceResourceInput: UpdateClubServiceResourceInput;
};


export type MutationUpdateClubsServiceArgs = {
  updateClubsServiceInput: UpdateClubsServiceInput;
};


export type MutationUpdateCourtArgs = {
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateCourtSortingArgs = {
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateDuprRatingArgs = {
  categoryId: Scalars['Float']['input'];
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateDisciplineArgs = {
  updateDisciplineInput: UpdateDisciplineInput;
};


export type MutationUpdateDisciplineSortingArgs = {
  updateDisciplineInput: UpdateDisciplineInput;
};


export type MutationUpdateDisplaySettingArgs = {
  updateDisplaySettingInput: UpdateDisplaySettingInput;
};


export type MutationUpdateDrawArgs = {
  updateDrawInput: UpdateDrawInput;
};


export type MutationUpdateDrawEntryArgs = {
  entryIdToUpdate?: InputMaybe<Scalars['Int']['input']>;
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationUpdateDrawScoreArgs = {
  updateDrawScoreInput: UpdateDrawScoreInput;
};


export type MutationUpdateFactSheetArgs = {
  updateFactSheetInput: UpdateFactSheetInput;
};


export type MutationUpdateFactSheetSortingArgs = {
  updateFactSheetInput: UpdateFactSheetInput;
};


export type MutationUpdateFederationArgs = {
  isAlreadyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  updateCustomEntryFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updateCustomLicenseFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updateFederationInput: UpdateFederationInput;
};


export type MutationUpdateFederationLeagueArgs = {
  updateFederationLeagueInput: UpdateFederationLeagueInput;
};


export type MutationUpdateFederationNewsArgs = {
  updateFederationNewsInput: UpdateFederationNewsInput;
};


export type MutationUpdateGroupArgs = {
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateGroupEntryArgs = {
  updateGroupEntryInput: UpdateGroupEntryInput;
};


export type MutationUpdateGroupMatchArgs = {
  updateGroupMatchInput: UpdateGroupMatchInput;
};


export type MutationUpdateGroupPositionsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateImageArgs = {
  updateImageInput: UpdateImageInput;
};


export type MutationUpdateLandingArgs = {
  updateLandingInput: UpdateLandingInput;
};


export type MutationUpdateLandingMemberArgs = {
  updateLandingMemberInput: UpdateLandingMemberInput;
};


export type MutationUpdateLandingPotmArgs = {
  updateLandingPotmInput: UpdateLandingPotmInput;
};


export type MutationUpdateLandingRoadmapArgs = {
  updateLandingRoadmapInput: UpdateLandingRoadmapInput;
};


export type MutationUpdateLandingSliderArgs = {
  updateLandingSliderInput: UpdateLandingSliderInput;
};


export type MutationUpdateLeagueArgs = {
  updateLeagueInput: UpdateLeagueInput;
};


export type MutationUpdateLeagueCategoryArgs = {
  updateLeagueCategoryInput: UpdateLeagueCategoryInput;
};


export type MutationUpdateLeagueDocumentArgs = {
  updateLeagueDocumentInput: UpdateLeagueDocumentInput;
};


export type MutationUpdateLeagueMemberArgs = {
  updateLeagueMemberInput: UpdateLeagueMemberInput;
};


export type MutationUpdateLeagueMemberRoleArgs = {
  updateLeagueMemberRoleInput: UpdateLeagueMemberRoleInput;
};


export type MutationUpdateLeagueNewsArgs = {
  updateLeagueNewsInput: UpdateLeagueNewsInput;
};


export type MutationUpdateLeagueRankingArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueRankingPointsArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueRankingsArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueTournamentArgs = {
  updateLeagueTournamentInput: UpdateLeagueTournamentInput;
};


export type MutationUpdateLeagueTournamentCategoryArgs = {
  updateLeagueTournamentCategoryInput: UpdateLeagueTournamentCategoryInput;
};


export type MutationUpdateLicenseArgs = {
  updateLicenseInput: UpdateLicenseInput;
};


export type MutationUpdateLicenseLeagueArgs = {
  updateLicenseLeagueInput: UpdateLicenseLeagueInput;
};


export type MutationUpdateLicenseQuestionArgs = {
  updateLicenseQuestionInput: UpdateLicenseQuestionInput;
};


export type MutationUpdateLiveStandingArgs = {
  updateLiveStandingInput: UpdateLiveStandingInput;
};


export type MutationUpdateLiveStandingsEntryArgs = {
  updateLiveStandingsEntryInput: UpdateLiveStandingsEntryInput;
};


export type MutationUpdateMaintenanceArgs = {
  id: Scalars['Float']['input'];
  isUnderMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchArgs = {
  updateMatchInput: UpdateMatchInput;
};


export type MutationUpdateMatchScoreArgs = {
  updateMatchScoreInput: UpdateMatchScoreInput;
};


export type MutationUpdateMatchesScoreArgs = {
  updateMatchesScoreInput: UpdateMatchesScoreInput;
};


export type MutationUpdateMediaArgs = {
  updateMediaInput: UpdateMediaInput;
};


export type MutationUpdateMobileVersionArgs = {
  androidForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  androidReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  iOSForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  iosReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  iosVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMultipleCourtsArgs = {
  courtIds: Array<Scalars['Int']['input']>;
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateMultipleDrawMatchesArgs = {
  updateDrawMatchInput: Array<UpdateDrawEntryInput>;
};


export type MutationUpdateMultipleGroupMatchesArgs = {
  updateGroupMatchInput: Array<CreateMatchScoreInput>;
};


export type MutationUpdateMultipleGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateMultipleMatchesArgs = {
  updateMatchInput: Array<UpdateMatchInput>;
};


export type MutationUpdateNewsArgs = {
  updateNewsInput: UpdateNewsInput;
};


export type MutationUpdateNotificationSubscriptionArgs = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOnboardingArgs = {
  updateOnboardingInput: UpdateOnboardingInput;
};


export type MutationUpdateOrganizationPlatformArgs = {
  updateOrganizationPlatformInput: UpdateOrganizationPlatformInput;
};


export type MutationUpdateOrganizationPlatformMemberArgs = {
  updateOrganizationPlatformMemberInput: UpdateOrganizationPlatformMemberInput;
};


export type MutationUpdatePairingArgs = {
  updatePairingInput: UpdatePairingInput;
};


export type MutationUpdatePairingEntryArgs = {
  updatePairingEntryInput: UpdatePairingEntryInput;
};


export type MutationUpdatePairingScoreArgs = {
  roundId?: InputMaybe<Scalars['Int']['input']>;
  updatePairingEntryInputs: Array<UpdatePairingEntryInput>;
};


export type MutationUpdatePartnerArgs = {
  updatePartnerInput: UpdatePartnerInput;
};


export type MutationUpdatePartnerSearchArgs = {
  updatePartnerSearchInput: UpdatePartnerSearchInput;
};


export type MutationUpdatePartnerSortingArgs = {
  updatePartnerInput: UpdatePartnerInput;
};


export type MutationUpdatePlanArgs = {
  updatePlanInput: UpdatePlanInput;
};


export type MutationUpdatePlateformSportArgs = {
  updatePlateformSportInput: UpdatePlateformSportInput;
};


export type MutationUpdatePlatformArgs = {
  isAlreadyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  updateCustomEntryFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updateCustomLicenseFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updatePlatformInput: UpdatePlatformInput;
};


export type MutationUpdatePlatformCoachArgs = {
  updatePlatformCoachInput: UpdatePlatformCoachInput;
};


export type MutationUpdatePlatformDocumentArgs = {
  updatePlatformDocumentInput: UpdatePlatformDocumentInput;
};


export type MutationUpdatePlatformDocumentSortingArgs = {
  updatePlatformDocumentInput: UpdatePlatformDocumentInput;
};


export type MutationUpdatePlatformFeeArgs = {
  updatePlatformFeeInput: UpdatePlatformFeeInput;
};


export type MutationUpdatePurchasedLicenseArgs = {
  updatePurchasedLicenseInput: UpdatePurchasedLicenseInput;
};


export type MutationUpdateRankingCategoryPointsArgs = {
  updateRankingCategoryPointsInput: Array<UpdateRankingCategoryPointInput>;
};


export type MutationUpdateRankingPointArgs = {
  updateRankingCategoryPointInput: UpdateRankingCategoryPointInput;
};


export type MutationUpdateRankingPointCategoryArgs = {
  updateRankingPointCategoryInput: UpdateRankingPointCategoryInput;
};


export type MutationUpdateRankingPointRuleArgs = {
  updateRankingPointRuleInput: UpdateRankingPointRuleInput;
};


export type MutationUpdateRankingTournamentCategoryArgs = {
  updateRankingTournamentCategoryInput: UpdateRankingTournamentCategoryInput;
};


export type MutationUpdateRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateRegistrationSegmentArgs = {
  categoryId: Scalars['Float']['input'];
  onlySeed?: InputMaybe<Scalars['Boolean']['input']>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateRegistrationsRankingsArgs = {
  categoryId: Scalars['Float']['input'];
  ids: Array<Scalars['Int']['input']>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateResourceServiceArgs = {
  updateResourceServiceInput: UpdateResourceServiceInput;
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRoundArgs = {
  updateRoundInput: UpdateRoundInput;
};


export type MutationUpdateSimpleRankingPointArgs = {
  updateRankingPointInput: UpdateRankingPointInput;
};


export type MutationUpdateSportArgs = {
  updateSportInput: UpdateSportInput;
};


export type MutationUpdateSportFishingEntriesMatricArgs = {
  updateSportFishingEntriesMatricInput: UpdateSportFishingEntriesMatricInput;
};


export type MutationUpdateSportFishingEntriesMatricBulkArgs = {
  inputs: Array<UpdateSportFishingEntriesMatricInput>;
};


export type MutationUpdateSportFishingMatricArgs = {
  updateSportFishingMatricInput: UpdateSportFishingMatricInput;
};


export type MutationUpdateSportFishingResultArgs = {
  updateSportFishingResultInput: UpdateSportFishingResultInput;
};


export type MutationUpdateSportFishingResultEntryArgs = {
  updateSportFishingResultEntryInput: UpdateSportFishingResultEntryInput;
};


export type MutationUpdateSportSortingArgs = {
  updateSportInput: UpdateSportInput;
};


export type MutationUpdateSubscriptionArgs = {
  updateSubscriptionInput: UpdateSubscriptionInput;
};


export type MutationUpdateTeamArgs = {
  updateTeamInput: UpdateTeamInput;
};


export type MutationUpdateTeamMemberArgs = {
  updateTeamMemberInput: UpdateTeamMemberInput;
};


export type MutationUpdateTemplateArgs = {
  updateTemplateInput: UpdateTemplateInput;
};


export type MutationUpdateThirdPartyLicenseArgs = {
  updateThirdPartyLicenseInput: UpdateThirdPartyLicenseInput;
};


export type MutationUpdateTournamentArgs = {
  updateTournamentInput: UpdateTournamentInput;
};


export type MutationUpdateTournamentAdditionalRefereeArgs = {
  updateTournamentAdditionalRefereeInput: UpdateTournamentAdditionalRefereeInput;
};


export type MutationUpdateTournamentCategoriesArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentCategoryArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
  updateTournamentCategoryGroupInput: UpdateTournamentCategoryGroupInput;
};


export type MutationUpdateTournamentCategoryLicenseArgs = {
  updateTournamentCategoryLicenseInput: UpdateTournamentCategoryLicenseInput;
};


export type MutationUpdateTournamentCategorySortingArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentDiscountArgs = {
  updateTournamentDiscountInput: UpdateTournamentDiscountInput;
};


export type MutationUpdateTournamentDocumentArgs = {
  updateTournamentDocumentInput: UpdateTournamentDocumentInput;
};


export type MutationUpdateTournamentFactSheetArgs = {
  updateTournamentFactSheetInput: UpdateTournamentFactSheetInput;
};


export type MutationUpdateTournamentMatchesArgs = {
  updateDrawMatchInput: Array<UpdateDrawEntryInput>;
  updateGroupMatchInput: Array<UpdateGroupMatchInput>;
};


export type MutationUpdateTournamentOrganizerArgs = {
  updateTournamentOrganizerInput: UpdateTournamentOrganizerInput;
};


export type MutationUpdateTournamentRankingArgs = {
  updateTournamentRankingInput: UpdateTournamentRankingInput;
};


export type MutationUpdateTournamentRankingsEntryArgs = {
  updateTournamentRankingsEntryInput: UpdateTournamentRankingsEntryInput;
};


export type MutationUpdateTournamentRankingsManArgs = {
  updateTournamentRankingsManInput: UpdateTournamentRankingsManInput;
};


export type MutationUpdateTournamentRankingsWomanArgs = {
  updateTournamentRankingsWomanInput: UpdateTournamentRankingsWomanInput;
};


export type MutationUpdateTournamentRefereeArgs = {
  updateTournamentRefereeInput: UpdateTournamentRefereeInput;
};


export type MutationUpdateTournamentRegistrationArgs = {
  updateTournamentRegistrationInput: UpdateTournamentRegistrationInput;
};


export type MutationUpdateTournamentRegistrationQuestionArgs = {
  updateTournamentRegistrationQuestionInput: UpdateTournamentRegistrationQuestionInput;
};


export type MutationUpdateTournamentRegistrationsArgs = {
  categryId: Scalars['Int']['input'];
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateTournamentTeamMemberArgs = {
  updateTournamentTeamMemberInput: UpdateTournamentTeamMemberInput;
};


export type MutationUpdateTournamentTeamMemberDuprArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateTournamentsCountryArgs = {
  updateTournamentInput?: InputMaybe<UpdateTournamentInput>;
};


export type MutationUpdateTransactionHistoryArgs = {
  updateTransactionHistoryInput: UpdateTransactionHistoryInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserCoachArgs = {
  updateUserCoachInput: UpdateUserCoachInput;
};


export type MutationUpdateUserGenderArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserLicenseArgs = {
  updateUserLicenseInput: UpdateUserLicenseInput;
};


export type MutationUpdateUserParentArgs = {
  updateUserParentInput: UpdateUserParentInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserpassword: UpdateUserInput;
};


export type MutationUpdateUserPlanArgs = {
  updateUserPlanInput: UpdateUserPlanInput;
};


export type MutationUpdateUserSportArgs = {
  updateUserSportInput: UpdateUserSportInput;
};


export type MutationUserLoginArgs = {
  appleId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facebookId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWithdrawRegistrationsArgs = {
  updateTournamentRegistrationInput: UpdateTournamentRegistrationInput;
};

export type News = {
  __typename?: 'News';
  author?: Maybe<User>;
  category?: Maybe<Scalars['String']['output']>;
  clubNews?: Maybe<Array<ClubNews>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']['output']>;
  federationNews?: Maybe<Array<FederationNews>>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDisplayLanding?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  leagueNews?: Maybe<Array<LeagueNews>>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  postText?: Maybe<Scalars['String']['output']>;
  ptiority?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  youtubeVideoLink?: Maybe<Scalars['String']['output']>;
};

export type NewsResult = {
  __typename?: 'NewsResult';
  news: Array<News>;
  total: Scalars['Int']['output'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type OrganizationPlatform = {
  __typename?: 'OrganizationPlatform';
  createdAt: Scalars['DateTime']['output'];
  customFee?: Maybe<Array<PlatformFee>>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  platform?: Maybe<Platform>;
  platformMembers?: Maybe<Array<OrganizationPlatformMember>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationPlatformMember = {
  __typename?: 'OrganizationPlatformMember';
  addedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  organizationPlatform?: Maybe<OrganizationPlatform>;
  platform?: Maybe<Platform>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription';
  createdAt: Scalars['DateTime']['output'];
  customFee?: Maybe<Array<PlatformFee>>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isValidSubscription: Scalars['Boolean']['output'];
  platform?: Maybe<Platform>;
  platformMembers?: Maybe<Array<OrganizationPlatformMember>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Possible options for payment method */
export enum Payment_Method {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Online = 'ONLINE',
  Stripe = 'STRIPE'
}

/** Possible options for payment status */
export enum Payment_Status {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Successful = 'SUCCESSFUL'
}

export type PLatformStats = {
  __typename?: 'PLatformStats';
  leagueCount: Scalars['Int']['output'];
  tournamentCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

export type Pairing = {
  __typename?: 'Pairing';
  algo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hide?: Maybe<Scalars['Boolean']['output']>;
  hideStandings?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  pairingEntries?: Maybe<Array<PairingEntry>>;
  place?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PairingEntry = {
  __typename?: 'PairingEntry';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  entry1?: Maybe<TournamentRegistration>;
  entry2?: Maybe<TournamentRegistration>;
  id: Scalars['Float']['output'];
  matchStatus?: Maybe<Scalars['String']['output']>;
  pairing?: Maybe<Pairing>;
  pts?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<TournamentRegistration>;
};

export type Partner = {
  __typename?: 'Partner';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  ageRestriction?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  federation?: Maybe<Federation>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  league?: Maybe<League>;
  license?: Maybe<Scalars['String']['output']>;
  licenseRequired?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  priority?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sponsorText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentsSum?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerSearch = {
  __typename?: 'PartnerSearch';
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  duprRating?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  partner?: Maybe<User>;
  partnerInformation?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  selfInformation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type PartnerSearchRequest = {
  __typename?: 'PartnerSearchRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  requester: User;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type PartnerSearchsResult = {
  __typename?: 'PartnerSearchsResult';
  partnerSearches: Array<PartnerSearch>;
  total: Scalars['Int']['output'];
  uniqueTotal: Scalars['Int']['output'];
};

/** Possible statuses of a payment */
export enum PaymentStatus {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type Plan = {
  __typename?: 'Plan';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  monthlyDiscount?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  yearlyDiscount?: Maybe<Scalars['String']['output']>;
};

export type PlateformSport = {
  __typename?: 'PlateformSport';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Platform = {
  __typename?: 'Platform';
  abbreviation?: Maybe<Scalars['String']['output']>;
  albums?: Maybe<Album>;
  alreadyDomain?: Maybe<Scalars['Boolean']['output']>;
  club?: Maybe<Array<Club>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customFee?: Maybe<Array<PlatformFee>>;
  darkEmblem?: Maybe<Scalars['String']['output']>;
  darkLogo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<Discipline>>;
  domain?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  graphicsForSmm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isEnableMaintenance?: Maybe<Scalars['Boolean']['output']>;
  isEnablePrice?: Maybe<Scalars['Boolean']['output']>;
  isVatFeeApplicable?: Maybe<Scalars['Boolean']['output']>;
  landingLink?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  licenseMemberships?: Maybe<Scalars['Boolean']['output']>;
  lightEmblem?: Maybe<Scalars['String']['output']>;
  lightLogo?: Maybe<Scalars['String']['output']>;
  liveScoring?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming?: Maybe<Scalars['Boolean']['output']>;
  maintenanceDescription?: Maybe<Scalars['String']['output']>;
  maintenanceTitle?: Maybe<Scalars['String']['output']>;
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  needIntegration?: Maybe<Scalars['Boolean']['output']>;
  needLanding?: Maybe<Scalars['Boolean']['output']>;
  onlineBookingCourts?: Maybe<Scalars['Boolean']['output']>;
  onlinePayment?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<OrganizationPlatform>>;
  owner?: Maybe<Federation>;
  partnerEntryFee?: Maybe<Scalars['Float']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  platformLink?: Maybe<Scalars['String']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  signeeFullName?: Maybe<Scalars['String']['output']>;
  signeeRole?: Maybe<Scalars['String']['output']>;
  smm?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Array<PlateformSport>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  subDomain?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  template?: Maybe<Template>;
  thirdPartyLicenses?: Maybe<Array<ThirdPartyLicense>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedEntryFee?: Maybe<Scalars['Float']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadFile?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
  vatFee?: Maybe<Scalars['Float']['output']>;
  yourRequest?: Maybe<Scalars['String']['output']>;
};

export type PlatformCoach = {
  __typename?: 'PlatformCoach';
  category?: Maybe<Scalars['String']['output']>;
  clubs?: Maybe<Array<Club>>;
  createdBy?: Maybe<User>;
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
  displayOnLandingPage?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  students?: Maybe<Array<UserCoach>>;
  user?: Maybe<User>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type PlatformCoachResult = {
  __typename?: 'PlatformCoachResult';
  platformCoaches: Array<PlatformCoach>;
  total: Scalars['Int']['output'];
};

export type PlatformDocument = {
  __typename?: 'PlatformDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isLeaguePage?: Maybe<Scalars['Boolean']['output']>;
  isRankings?: Maybe<Scalars['Boolean']['output']>;
  isTournamentCalender?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformFee = {
  __typename?: 'PlatformFee';
  currency?: Maybe<Scalars['String']['output']>;
  feeType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isMonetization?: Maybe<Scalars['Boolean']['output']>;
  organizationPlatform: OrganizationPlatform;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  partnerMaxFee?: Maybe<Scalars['Float']['output']>;
  partnerMinFee?: Maybe<Scalars['Float']['output']>;
  platform: Platform;
  rangeEnd: Scalars['Float']['output'];
  rangeStart: Scalars['Float']['output'];
  serviceType: Scalars['String']['output'];
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  tournatedMaxFee?: Maybe<Scalars['Float']['output']>;
  tournatedMinFee?: Maybe<Scalars['Float']['output']>;
};

export type PlatformWithSubscription = {
  __typename?: 'PlatformWithSubscription';
  abbreviation?: Maybe<Scalars['String']['output']>;
  albums?: Maybe<Album>;
  alreadyDomain?: Maybe<Scalars['Boolean']['output']>;
  club?: Maybe<Array<Club>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customFee?: Maybe<Array<PlatformFee>>;
  darkEmblem?: Maybe<Scalars['String']['output']>;
  darkLogo?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<Discipline>>;
  domain?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  graphicsForSmm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isEnableMaintenance?: Maybe<Scalars['Boolean']['output']>;
  isEnablePrice?: Maybe<Scalars['Boolean']['output']>;
  isValidSubscription: Scalars['Boolean']['output'];
  isVatFeeApplicable?: Maybe<Scalars['Boolean']['output']>;
  landingLink?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  licenseMemberships?: Maybe<Scalars['Boolean']['output']>;
  lightEmblem?: Maybe<Scalars['String']['output']>;
  lightLogo?: Maybe<Scalars['String']['output']>;
  liveScoring?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming?: Maybe<Scalars['Boolean']['output']>;
  maintenanceDescription?: Maybe<Scalars['String']['output']>;
  maintenanceTitle?: Maybe<Scalars['String']['output']>;
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  needIntegration?: Maybe<Scalars['Boolean']['output']>;
  needLanding?: Maybe<Scalars['Boolean']['output']>;
  onlineBookingCourts?: Maybe<Scalars['Boolean']['output']>;
  onlinePayment?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<OrganizationPlatform>>;
  owner?: Maybe<Federation>;
  partnerEntryFee?: Maybe<Scalars['Float']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  platformLink?: Maybe<Scalars['String']['output']>;
  platformType?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  signeeFullName?: Maybe<Scalars['String']['output']>;
  signeeRole?: Maybe<Scalars['String']['output']>;
  smm?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Array<PlateformSport>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  subDomain?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  template?: Maybe<Template>;
  thirdPartyLicenses?: Maybe<Array<ThirdPartyLicense>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedEntryFee?: Maybe<Scalars['Float']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadFile?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
  vatFee?: Maybe<Scalars['Float']['output']>;
  yourRequest?: Maybe<Scalars['String']['output']>;
};

export type PlatformsResult = {
  __typename?: 'PlatformsResult';
  platforms: Array<Platform>;
  total: Scalars['Int']['output'];
};

/** Possible types of products */
export enum Products {
  License = 'LICENSE',
  Registration = 'REGISTRATION'
}

export type PurchasedLicense = {
  __typename?: 'PurchasedLicense';
  activePeriod: Scalars['String']['output'];
  addedBy?: Maybe<User>;
  additionalQuestions?: Maybe<Array<LicenseQuestion>>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  licenseStatus: LicenseStatus;
  noOfLicense?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type Query = {
  __typename?: 'Query';
  CsvGenerationForPickleballGroups: Scalars['String']['output'];
  CsvGenerationForPickleballOOP: Scalars['String']['output'];
  CsvGenerationForPickleballOOPFansPlay: Scalars['String']['output'];
  PdfGeneration: Scalars['String']['output'];
  PdfGenerationForDraw: Scalars['String']['output'];
  PdfGenerationForGrid: Scalars['String']['output'];
  PdfGenerationForGroup: Scalars['String']['output'];
  PdfGenerationForPickleball: Scalars['String']['output'];
  PdfGenerationForScoreCard: Scalars['String']['output'];
  TournamentAdditionalReferee: TournamentAdditionalReferee;
  activePlayersOfOrganization: Scalars['JSON']['output'];
  additionalQuestion: AdditionalQuestion;
  additionalQuestions: Array<AdditionalQuestion>;
  album: Album;
  allClubNews: Array<ClubNews>;
  allDashboardStats: Scalars['JSONObject']['output'];
  allDraws: Array<Draw>;
  allFederationNews: Array<FederationNews>;
  allGroupMatches: GroupResult;
  allGroups: GroupResult;
  allGroupsStandings: GroupResult;
  allLeagueMembers: LeagueMembersResult;
  allLeagueNews: Array<LeagueNews>;
  allLeagues: Array<League>;
  allLeaguesForManager: Array<League>;
  allLeaguesNames: Array<League>;
  allLeaguesWithCount: Scalars['JSON']['output'];
  allNews: NewsResult;
  allPlatformsNames: Array<Platform>;
  allStatsData: Scalars['JSONObject']['output'];
  allStatsGraphData: Scalars['JSONObject']['output'];
  allStatsTransactionData: Scalars['JSONObject']['output'];
  allTournamentCategories: Array<Scalars['JSONObject']['output']>;
  allTournamentCategoriesList: Array<Scalars['JSONObject']['output']>;
  allTournamentCategoriesUpdated: Array<CategorySetting>;
  allTournamentNames: Scalars['JSON']['output'];
  allTournamentWithMatches: Scalars['JSON']['output'];
  allTournaments: Array<Tournament>;
  allTournamentsList: Scalars['JSON']['output'];
  allTransactionHistory: Array<TransactionHistory>;
  allstats: Array<Stat>;
  alltournament: TournamentsResult;
  athlete: Athlete;
  athleteAchievements: Array<AthleteAchievementsByYear>;
  athleteTournamentStats: AthleteTournamentStats;
  athletes: Array<Athlete>;
  banner: Banner;
  banners: Array<Banner>;
  breakDownRankingOfOrganization: Scalars['JSON']['output'];
  calculateDrawPoints: Scalars['JSONObject']['output'];
  calculateEntryPoints: Scalars['JSONObject']['output'];
  calculateGroupScore: Array<Scalars['JSONObject']['output']>;
  calculateLeaguePoints: Array<Scalars['JSONObject']['output']>;
  calculateLiveStandingPoints: Scalars['JSONObject']['output'];
  calculatePayments: Scalars['JSONObject']['output'];
  calculateTeamTotaltResult: Scalars['JSON']['output'];
  calculateTotaltFishingResult: Array<Scalars['JSONObject']['output']>;
  captainTeams: Array<Team>;
  categories: Array<Category>;
  category: Category;
  categoryRule: CategoryRule;
  categoryRules: Array<CategoryRule>;
  categorySetting: CategorySetting;
  categorySettings: Array<CategorySetting>;
  categoryTournament: CategoryTournament;
  categoryTournaments: Array<CategoryTournament>;
  checkSubscription: Scalars['JSON']['output'];
  checkUserAsParentOrCoach: Scalars['JSONObject']['output'];
  checkUserRole: Scalars['JSONObject']['output'];
  club: Club;
  clubAdministrator: ClubAdministrator;
  clubAdministrators: Array<ClubAdministrator>;
  clubCoach: ClubCoach;
  clubCoaches: Array<ClubCoach>;
  clubDetails: Scalars['JSON']['output'];
  clubMember: ClubMember;
  clubMembers: ClubMemberResult;
  clubNews: ClubNews;
  clubServiceResource: ClubServiceResource;
  clubServiceResources: Array<ClubServiceResource>;
  clubs: Scalars['JSON']['output'];
  clubsBySportIds: ClubResult;
  clubsServices: Array<ClubService>;
  court: Court;
  courts: Array<Court>;
  currentSubscriptionDetails: Scalars['JSON']['output'];
  discipline: Discipline;
  disciplines: Array<Discipline>;
  displaySetting: DisplaySetting;
  displaySettings: Array<DisplaySetting>;
  draw: Draw;
  drawEntries: Array<DrawEntry>;
  drawEntry: DrawEntry;
  drawScore: DrawScore;
  draws: Array<Scalars['JSONObject']['output']>;
  drawsDetail: Scalars['JSONObject']['output'];
  eligibleTeamMembers: Array<TeamMember>;
  factSheet: FactSheet;
  factSheets: Array<FactSheet>;
  featuredLeagues: Scalars['JSON']['output'];
  featuredTournaments: Array<Tournament>;
  federation: Federation;
  federationDataCount: Scalars['JSON']['output'];
  federationDetails: Scalars['JSON']['output'];
  federationLeague: FederationLeague;
  federationLeagues: Array<FederationLeague>;
  federationNews: FederationNews;
  federationWithPlatforms: Federation;
  federations: FederationResult;
  fetchGroupEntry: GroupEntry;
  fetchOnboardingDetails: Scalars['JSONObject']['output'];
  fetchTournamentsByDate: TournamentsResult;
  fetchUserPlan: Scalars['JSON']['output'];
  findAllAlbum: Albums;
  findAllTeamMembers: Array<TeamMember>;
  findAllTournamentCategoryGroup: Array<TournamentCategoryGroup>;
  findFederation: Federation;
  findGroupMatchesWithRounds: Scalars['JSONObject']['output'];
  findPlatformAthletes: TournamentTeamMembersResult;
  findTournamentCategoryGroup: TournamentCategoryGroup;
  findTournamentsByDate: Scalars['JSON']['output'];
  findUserRequests: TournamentTeamMembersResult;
  findUserTournamentRole: Scalars['JSON']['output'];
  getAllStripeProducts: Array<Scalars['JSONObject']['output']>;
  getClubCoachMetaData: ClubCoach;
  getClubMetaData: Club;
  getCurrentRankings: Scalars['JSON']['output'];
  getFederationMetadata: Federation;
  getLeagueMetaData: League;
  getNewsMetadata: News;
  getPlatformCoachMetaData: Scalars['JSONObject']['output'];
  getPlatformMetadata: Platform;
  getPlatformStats: PLatformStats;
  getPlayerFideRanking: Scalars['JSON']['output'];
  getPlayerIDByName: Scalars['JSON']['output'];
  getPlayerRankingsByPlayerID: Scalars['JSON']['output'];
  getPlayerRankingsByTennisId: Scalars['JSON']['output'];
  getPlayerResults: Scalars['JSON']['output'];
  getPlayerResultsByPlayerId: Scalars['JSON']['output'];
  getProfile: User;
  getRatingByDUPRId: Scalars['JSON']['output'];
  getStripeConnectedAccounts: Scalars['JSONObject']['output'];
  getStripePlan: Scalars['JSONObject']['output'];
  getStripeProduct: Scalars['JSONObject']['output'];
  getTeamMetaData: Team;
  getTournamentMetaData: Tournament;
  getUserCount: Scalars['JSON']['output'];
  getUserFCMToken: Array<SnsSubscription>;
  getUserMatches: Array<MatchPartialV2>;
  getUserMetaData: User;
  getUserPartners: Scalars['JSONObject']['output'];
  getUserStats: Scalars['JSON']['output'];
  group: Group;
  groupEntries: Array<GroupEntry>;
  groupEntry: GroupEntry;
  groupMatch: GroupMatch;
  groupMatches: Array<GroupMatch>;
  groups: Array<Group>;
  groupsAndDraws: Scalars['JSONObject']['output'];
  homePageLeagueRanking: Array<LeagueRanking>;
  image: Image;
  landing: Landing;
  landingMember: LandingMember;
  landingMembers: Array<LandingMember>;
  landingPotm: LandingPotm;
  landingPotms: Array<LandingPotm>;
  landingRoadmap: LandingRoadmap;
  landingRoadmaps: Array<LandingRoadmap>;
  landingSlider: LandingSlider;
  landingSliders: Array<LandingSlider>;
  landings: Array<Landing>;
  latestLeagueRanking: Array<LeagueRanking>;
  league: League;
  leagueAthletes: Array<Scalars['JSON']['output']>;
  leagueCategories: Array<LeagueCategory>;
  leagueCategory: LeagueCategory;
  leagueDocument: LeagueDocument;
  leagueDocuments: Array<LeagueDocument>;
  leagueForRankings: Array<League>;
  leagueGeneralTournaments: Array<Tournament>;
  leagueLatestWinners: Array<TournamentRankingsEntry>;
  leagueMember: LeagueMember;
  leagueMemberRole: LeagueMemberRole;
  leagueMemberRoles: Array<LeagueMemberRole>;
  leagueMembers: Array<LeagueMember>;
  leagueNews: LeagueNews;
  leagueOwner: LeagueOwner;
  leaguePageLeagueRanking: Array<LeagueRanking>;
  leagueRanking: LeagueRanking;
  leagueRankings: Array<LeagueRanking>;
  leagueRankingsCustom: LeagueRankingResult;
  leagueRankingsDate: Array<LeagueRanking>;
  leagueRoles: Array<Role>;
  leagueStats: Scalars['JSON']['output'];
  leagueTournament: LeagueTournament;
  leagueTournamentCategories: Array<LeagueTournamentCategory>;
  leagueTournamentCategory: LeagueTournamentCategory;
  leagueTournaments: Scalars['JSON']['output'];
  leagues: Array<League>;
  leaguesForDashboard: Array<League>;
  leaguesSortedByActiveTournaments: Array<League>;
  leaguesWithCount: LeagueResult;
  license: License;
  licenseLeague: LicenseLeague;
  licenseLeagues: Array<LicenseLeague>;
  licenseQuestion: LicenseQuestion;
  licenseQuestions: Array<LicenseQuestion>;
  licenseStats: Scalars['JSONObject']['output'];
  licenses: Array<License>;
  liveStanding: LiveStanding;
  liveStandings: Array<LiveStanding>;
  liveStandingsEntries: Array<LiveStandingsEntry>;
  liveStandingsEntry: LiveStandingsEntry;
  maintenance?: Maybe<Maintenance>;
  maintenances: Array<Maintenance>;
  match: Match;
  matchScore: MatchScore;
  matches: MatchResult;
  matchesOfOrganization: Scalars['JSON']['output'];
  matchesScore: MatchesScore;
  media: Media;
  memberClubs: ClubResult;
  mobileVersion?: Maybe<MobileVersion>;
  mobileVersions: Array<MobileVersion>;
  myCareer: Scalars['JSON']['output'];
  news: News;
  onboarding: Onboarding;
  organizationPlatform: OrganizationPlatform;
  organizationPlatformByFields: OrganizationSubscription;
  organizationPlatformMember: OrganizationPlatformMember;
  organizationPlatformMembers: Array<OrganizationPlatformMember>;
  organizationPlatforms: Array<OrganizationPlatform>;
  pairing: Scalars['JSONObject']['output'];
  pairingEntries: Array<PairingEntry>;
  pairingEntry: PairingEntry;
  pairingResults: Scalars['JSONObject']['output'];
  pairings: Array<Pairing>;
  partner: Partner;
  partnerSearch: PartnerSearch;
  partnerSearchRequest: PartnerSearchRequest;
  partnerSearchRequests: Array<PartnerSearchRequest>;
  partnerSearches: PartnerSearchsResult;
  partners: Array<Partner>;
  pdfGenerationForPairing: Scalars['String']['output'];
  plan: Plan;
  plans: Array<Plan>;
  plateformSport: PlateformSport;
  plateformSports: Array<PlateformSport>;
  platform: PlatformWithSubscription;
  platformClubs: Platform;
  platformCoach: PlatformCoach;
  platformCoaches: PlatformCoachResult;
  platformDocument: PlatformDocument;
  platformDocuments: Array<PlatformDocument>;
  platformFee: PlatformFee;
  platformLeagueCategories: Array<League>;
  platformSpecificUsers: UsersResult;
  platformUsers: Scalars['JSON']['output'];
  platforms: PlatformsResult;
  purchasedLicense: PurchasedLicense;
  purchasedLicenses: Array<PurchasedLicense>;
  rankingCategoryPoint: RankingCategoryPoint;
  rankingCategoryPoints: Array<RankingCategoryPoint>;
  rankingOfOrganization: Scalars['JSON']['output'];
  rankingPoint: RankingPoint;
  rankingPointCategories: Array<RankingPointCategory>;
  rankingPointCategory: RankingPointCategory;
  rankingPointRule: RankingPointRule;
  rankingPointRules: Array<RankingPointRule>;
  rankingPoints: Array<RankingPoint>;
  rankingTournamentCategories: Array<RankingTournamentCategory>;
  rankingTournamentCategory: RankingTournamentCategory;
  registrationCount: Scalars['JSON']['output'];
  registrationsCountByDate: Scalars['JSON']['output'];
  resourceService: ResourceService;
  resourceServices: Array<ResourceService>;
  role: Role;
  roles: Array<Role>;
  round: Round;
  rounds: Array<Round>;
  searchCoachByEmail: PlatformCoach;
  searchFederationByTitle: Array<Federation>;
  searchLeagues: Array<Scalars['JSON']['output']>;
  searchLeaguesByTitle: Array<League>;
  searchTournamentsByTitle: Array<Tournament>;
  sport: Sport;
  sportFishingEntriesMatric: SportFishingEntriesMatric;
  sportFishingEntriesMatrics: Array<SportFishingEntriesMatric>;
  sportFishingEntriesMatricsCount: CountSportFishingEntriesMetric;
  sportFishingEntriesMatricsForManager: Array<Scalars['JSON']['output']>;
  sportFishingMatric: SportFishingMatric;
  sportFishingMatrics: Array<Scalars['JSON']['output']>;
  sportFishingMetricContext: SportFishingMetricContext;
  sportFishingMetricContexts: Array<SportFishingMetricContext>;
  sportFishingResult: SportFishingResult;
  sportFishingResultEntries: Array<SportFishingResultEntry>;
  sportFishingResultEntry: SportFishingResultEntry;
  sportFishingResults: Array<Scalars['JSONObject']['output']>;
  sportFishingResultsForManager: Array<Scalars['JSONObject']['output']>;
  sportFishingResultsForSingleEntry: Scalars['JSONObject']['output'];
  sports: Array<Sport>;
  sportsWithTournamentCount: Array<SportWithTournamentCount>;
  stat: Stat;
  stats: Tournament;
  statsForOrganization: Scalars['JSONObject']['output'];
  subscription: Subscription;
  subscriptions: SubscriptionsResult;
  team: Team;
  teamDetails: Scalars['JSON']['output'];
  teamMember: TeamMember;
  teams: TeamResult;
  template: Template;
  templates: Array<Template>;
  thirdPartyLicense: ThirdPartyLicense;
  thirdPartyLicenses: Array<ThirdPartyLicense>;
  thirdPartyLicensesBySportId: Array<ThirdPartyLicense>;
  tournament: Tournament;
  tournamentAllMatches: Scalars['JSONObject']['output'];
  tournamentCategories: Array<TournamentCategory>;
  tournamentCategoriesWithPartnersCount: Array<Scalars['JSONObject']['output']>;
  tournamentCategoriesWithPartnersCountUpdated: Array<CategorySetting>;
  tournamentCategory: TournamentCategory;
  tournamentCategoryLicense: TournamentCategoryLicense;
  tournamentCategoryLicenses: Array<TournamentCategoryLicense>;
  tournamentCountries: Array<Tournament>;
  tournamentDetailById: Tournament;
  tournamentDiscount: TournamentDiscount;
  tournamentDiscounts: Array<TournamentDiscount>;
  tournamentDocument: TournamentDocument;
  tournamentDocuments: Array<TournamentDocument>;
  tournamentDrawCategories: Array<Scalars['JSONObject']['output']>;
  tournamentDrawsMatches: Array<Scalars['JSONObject']['output']>;
  tournamentFactSheet: TournamentFactSheet;
  tournamentFactSheets: Array<TournamentFactSheet>;
  tournamentGroupCategories: Array<Scalars['JSONObject']['output']>;
  tournamentMatches: Array<Scalars['JSONObject']['output']>;
  tournamentMatchesDates: Array<Scalars['JSONObject']['output']>;
  tournamentOrganizer: TournamentOrganizer;
  tournamentRanking: TournamentRanking;
  tournamentRankings: TournamentRankingsResult;
  tournamentRankingsEntries: Array<TournamentRankingsEntry>;
  tournamentRankingsEntry: TournamentRankingsEntry;
  tournamentRankingsMan: TournamentRankingsMan;
  tournamentRankingsMen: Array<TournamentRankingsMan>;
  tournamentRankingsWoman: TournamentRankingsWoman;
  tournamentRankingsWomen: Array<TournamentRankingsWoman>;
  tournamentReferee: TournamentReferee;
  tournamentRegistration: TournamentRegistration;
  tournamentRegistrationQuestion: TournamentRegistrationQuestion;
  tournamentRegistrationQuestions: Array<TournamentRegistrationQuestion>;
  tournamentRegistrations: Array<TournamentRegistration>;
  tournamentStats: Array<Tournament>;
  tournamentTeamMember: TournamentTeamMember;
  tournamentTeamMembers: Array<TournamentTeamMember>;
  tournamentTeamMembersWithCount: TournamentTeamMembersResult;
  tournamentTopFivePlayers: Array<Scalars['JSONObject']['output']>;
  tournamentsByUserId: Scalars['JSON']['output'];
  transactionHistory: TransactionHistory;
  updateTournamentsPlatformId: Array<Tournament>;
  updateTransactionHistoryCurrency: Scalars['String']['output'];
  updateUserInRequests: Array<TournamentTeamMember>;
  user: User;
  userAllLeagues: LeagueResult;
  userAllMatches: Array<Scalars['JSONObject']['output']>;
  userAllTournaments: Scalars['JSON']['output'];
  userCoach: UserCoach;
  userCoaches: Array<UserCoach>;
  userEntriesTeamLicensesCount: Scalars['JSON']['output'];
  userLeaguePoints: Array<Scalars['JSONObject']['output']>;
  userLicense: UserLicense;
  userLicenses: Array<UserLicense>;
  userParents: Array<UserParent>;
  userPartnerSearchCategories: Array<Scalars['JSONObject']['output']>;
  userPartnerSearches: Array<Scalars['JSONObject']['output']>;
  userPartnerSearchesUpdated: Array<PartnerSearch>;
  userPlan: UserPlan;
  userProfile: Scalars['JSON']['output'];
  userRole: Scalars['String']['output'];
  userRoles: Array<Role>;
  userSport: UserSport;
  userSports: Array<UserSport>;
  userThirdPartyLicenses: Scalars['JSON']['output'];
  userTournamentCategories: Array<Scalars['JSONObject']['output']>;
  userTournamentMatches: Scalars['JSONObject']['output'];
  userTournamentRegistrations: Array<TournamentRegistration>;
  userTournaments: Array<Tournament>;
  userTournamentsResult: TournamentsResult;
  users: UsersResult;
  usersCount: Scalars['JSON']['output'];
  validLicensesForUsers: Array<License>;
  validTeamMembers: Array<Scalars['JSONObject']['output']>;
  validateUserU10License: Scalars['JSON']['output'];
};


export type QueryCsvGenerationForPickleballGroupsArgs = {
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCsvGenerationForPickleballOopArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCsvGenerationForPickleballOopFansPlayArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPdfGenerationForDrawArgs = {
  drawId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForGridArgs = {
  id: Scalars['String']['input'];
};


export type QueryPdfGenerationForGroupArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  pdfFormat?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForPickleballArgs = {
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForScoreCardArgs = {
  id: Scalars['String']['input'];
};


export type QueryTournamentAdditionalRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryActivePlayersOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryAdditionalQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdditionalQuestionsArgs = {
  filter?: InputMaybe<ListAdditionalQuestionInput>;
  tournamentId: Scalars['Int']['input'];
};


export type QueryAlbumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAllDashboardStatsArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDrawsArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryAllFederationNewsArgs = {
  filter?: InputMaybe<ListFederationNewsInput>;
};


export type QueryAllGroupMatchesArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllGroupsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllGroupsStandingsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLeagueMembersArgs = {
  filter?: InputMaybe<ListLeagueMemberInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLeagueNewsArgs = {
  filter?: InputMaybe<ListLeagueNewsInput>;
};


export type QueryAllLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryAllLeaguesForManagerArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryAllLeaguesNamesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryAllLeaguesWithCountArgs = {
  federationId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAllNewsArgs = {
  filter?: InputMaybe<ListNewsInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStatsDataArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStatsGraphDataArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllStatsTransactionDataArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTournamentCategoriesArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentCategoriesListArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentCategoriesUpdatedArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentNamesArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentWithMatchesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentsListArgs = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  categoryGroup?: InputMaybe<Scalars['Int']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isLast7or30Days?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTransactionHistoryArgs = {
  filter?: InputMaybe<ListTransactionHistory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentTypes?: InputMaybe<Array<TransactionType>>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAlltournamentArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAthleteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAthleteAchievementsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAthleteTournamentStatsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  isThisYear?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAthletesArgs = {
  filter?: InputMaybe<ListAthleteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBannerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBannersArgs = {
  filter?: InputMaybe<ListBannerInput>;
};


export type QueryBreakDownRankingOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryCalculateDrawPointsArgs = {
  categoryId: Scalars['Int']['input'];
  categorySettingId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  leagueId: Scalars['Int']['input'];
};


export type QueryCalculateEntryPointsArgs = {
  categoryId: Scalars['Int']['input'];
  leagueId: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type QueryCalculateGroupScoreArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculateLeaguePointsArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
};


export type QueryCalculateLiveStandingPointsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCalculatePaymentsArgs = {
  calculatePaymentInput: CalculatePaymentInput;
  categoryPaymentInput: Array<CategoryPaymentInput>;
};


export type QueryCalculateTeamTotaltResultArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculateTotaltFishingResultArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaptainTeamsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<ListCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategoryRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategorySettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategorySettingsArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCheckSubscriptionArgs = {
  platformId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryCheckUserAsParentOrCoachArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubArgs = {
  filter?: InputMaybe<ListClubInput>;
  id: Scalars['Int']['input'];
};


export type QueryClubAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubMembersArgs = {
  clubName?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListClubMembers>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubServiceResourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubServiceResourcesArgs = {
  filter?: InputMaybe<ListClubServiceResourceInput>;
};


export type QueryClubsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sport?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryClubsBySportIdsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryClubsServicesArgs = {
  filter?: InputMaybe<ListClubServiceInput>;
};


export type QueryCourtArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCourtsArgs = {
  filter?: InputMaybe<ListCourtInput>;
};


export type QueryCurrentSubscriptionDetailsArgs = {
  platformId: Scalars['Int']['input'];
};


export type QueryDisciplineArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisciplinesArgs = {
  filter?: InputMaybe<ListDisciplineInput>;
};


export type QueryDisplaySettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawEntriesArgs = {
  filter?: InputMaybe<ListDrawEntryInput>;
};


export type QueryDrawEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawsArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryDrawsDetailArgs = {
  filter?: InputMaybe<ListDrawInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEligibleTeamMembersArgs = {
  category?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListTeamMemberInput>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFactSheetsArgs = {
  filter?: InputMaybe<ListFactSheetInput>;
};


export type QueryFeaturedLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFeaturedTournamentsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFederationArgs = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationDataCountArgs = {
  filter?: InputMaybe<ListFederationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationDetailsArgs = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationWithPlatformsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationsArgs = {
  arrayOfPlatform?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<ListFederationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFetchGroupEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFetchOnboardingDetailsArgs = {
  organizationPlatformId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchTournamentsByDateArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFetchUserPlanArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryFindAllAlbumArgs = {
  filter?: InputMaybe<ListAlbumInput>;
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindAllTeamMembersArgs = {
  filter?: InputMaybe<ListTeamMemberInput>;
};


export type QueryFindAllTournamentCategoryGroupArgs = {
  filter?: InputMaybe<ListTournamentCategoryGroupInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindFederationArgs = {
  filter?: InputMaybe<ListFederationInput>;
};


export type QueryFindGroupMatchesWithRoundsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindPlatformAthletesArgs = {
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindTournamentsByDateArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFindUserRequestsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindUserTournamentRoleArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryGetAllStripeProductsArgs = {
  connectedAccountId: Scalars['String']['input'];
};


export type QueryGetClubCoachMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetClubMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetCurrentRankingsArgs = {
  age?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
  playerType?: InputMaybe<Scalars['String']['input']>;
  rankingType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFederationMetadataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetLeagueMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetNewsMetadataArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetPlatformCoachMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetPlatformMetadataArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlatformStatsArgs = {
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetPlayerFideRankingArgs = {
  fideId: Scalars['String']['input'];
};


export type QueryGetPlayerIdByNameArgs = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlayerRankingsByPlayerIdArgs = {
  playerId: Scalars['String']['input'];
};


export type QueryGetPlayerRankingsByTennisIdArgs = {
  citizenship: Scalars['String']['input'];
  tennisId: Scalars['String']['input'];
};


export type QueryGetPlayerResultsArgs = {
  discipline?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlayerResultsByPlayerIdArgs = {
  discipline?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRatingByDuprIdArgs = {
  duprId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStripePlanArgs = {
  planId: Scalars['String']['input'];
};


export type QueryGetStripeProductArgs = {
  connectedAccountId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetTeamMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetTournamentMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetUserCountArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserFcmTokenArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetUserMatchesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListMatchInput>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryGetUserMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetUserPartnersArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserStatsArgs = {
  filters?: InputMaybe<ListTournamentInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupEntriesArgs = {
  filter?: InputMaybe<ListGroupEntryInput>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGroupEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupMatchesArgs = {
  filter?: InputMaybe<ListGroupMatchInput>;
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<ListGroupInput>;
};


export type QueryGroupsAndDrawsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryHomePageLeagueRankingArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingMembersArgs = {
  filter?: InputMaybe<CreateLandingMemberInput>;
};


export type QueryLandingPotmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingPotmsArgs = {
  filter?: InputMaybe<CreateLandingPotmInput>;
};


export type QueryLandingRoadmapArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingRoadmapsArgs = {
  filter?: InputMaybe<CreateLandingRoadmapInput>;
};


export type QueryLandingSliderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingSlidersArgs = {
  filter?: InputMaybe<CreateLandingSliderInput>;
};


export type QueryLandingsArgs = {
  filter?: InputMaybe<CreateLandingInput>;
};


export type QueryLatestLeagueRankingArgs = {
  filter?: InputMaybe<ListLeagueRankingInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueArgs = {
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryLeagueAthletesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeagueCategoriesArgs = {
  filter?: InputMaybe<ListLeagueCategoryInput>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueDocumentsArgs = {
  filter?: InputMaybe<ListLeagueDocumentInput>;
};


export type QueryLeagueForRankingsArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueGeneralTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueLatestWinnersArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueMemberRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueMembersArgs = {
  filter?: InputMaybe<ListLeagueMemberInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueOwnerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeaguePageLeagueRankingArgs = {
  leagueId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueRankingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueRankingsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeagueRankingsCustomArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  isPage1?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeagueRankingsDateArgs = {
  filter?: InputMaybe<ListLeagueRankingInput>;
};


export type QueryLeagueStatsArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryLeagueTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueTournamentsArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeaguesArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryLeaguesForDashboardArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryLeaguesSortedByActiveTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeaguesWithCountArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseStatsArgs = {
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLicensesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLicenseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLiveStandingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiveStandingsArgs = {
  filter?: InputMaybe<ListLiveStandingsInput>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLiveStandingsEntriesArgs = {
  filter?: InputMaybe<ListLiveStandingsEntryInput>;
};


export type QueryLiveStandingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMaintenanceArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchesArgs = {
  filter?: InputMaybe<ListMatchesScoreInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchesOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryMatchesScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMediaArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMemberClubsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMobileVersionArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMyCareerArgs = {
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOnboardingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformByFieldsArgs = {
  platformId: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformMembersArgs = {
  filter?: InputMaybe<ListOrganizationPlatformMembersInput>;
};


export type QueryOrganizationPlatformsArgs = {
  filter?: InputMaybe<ListOrganizationPlatformsInput>;
};


export type QueryPairingArgs = {
  filter?: InputMaybe<ListPairingInput>;
  id: Scalars['Int']['input'];
};


export type QueryPairingEntriesArgs = {
  filter?: InputMaybe<ListPairingEntryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPairingEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPairingResultsArgs = {
  filter?: InputMaybe<ListPairingInput>;
  id: Scalars['Int']['input'];
};


export type QueryPairingsArgs = {
  filter?: InputMaybe<ListPairingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchRequestsArgs = {
  filter?: InputMaybe<ListPartnerSearchRequestInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerSearchesArgs = {
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnersArgs = {
  filter?: InputMaybe<ListPartnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPdfGenerationForPairingArgs = {
  id: Scalars['String']['input'];
  pairingId?: InputMaybe<Scalars['String']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlansArgs = {
  filter?: InputMaybe<ListPlanInput>;
};


export type QueryPlateformSportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformClubsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformCoachesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListCoachInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryPlatformDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformDocumentsArgs = {
  filter?: InputMaybe<ListPlatformDocumentInput>;
};


export type QueryPlatformFeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformLeagueCategoriesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryPlatformSpecificUsersArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPlatformUsersArgs = {
  ageFrom?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['String']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<ListLeagueInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nation?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryPlatformsArgs = {
  filter?: InputMaybe<ListPlatformInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasedLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchasedLicensesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  getUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRankingCategoryPointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingCategoryPointsArgs = {
  filter?: InputMaybe<ListRankingCatgoryPointsInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRankingOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryRankingPointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointRulesArgs = {
  filter?: InputMaybe<ListRankingPointRuleInput>;
};


export type QueryRankingPointsArgs = {
  filter?: InputMaybe<ListRankingPointsInput>;
  tournamentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRankingTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRegistrationCountArgs = {
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryRegistrationsCountByDateArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceServiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryResourceServicesArgs = {
  filter?: InputMaybe<ListResourceServiceInput>;
};


export type QueryRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoundArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySearchCoachByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QuerySearchFederationByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchLeaguesArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchLeaguesByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchTournamentsByTitleArgs = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingEntriesMatricArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingEntriesMatricsArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
};


export type QuerySportFishingEntriesMatricsCountArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
};


export type QuerySportFishingEntriesMatricsForManagerArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingMatricArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingMatricsArgs = {
  filter?: InputMaybe<ListSportFishingMatricInput>;
};


export type QuerySportFishingMetricContextArgs = {
  id: Scalars['Float']['input'];
};


export type QuerySportFishingResultArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingResultEntriesArgs = {
  filter?: InputMaybe<ListSportFishingResultEntryInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingResultEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingResultsArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingResultsForManagerArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
};


export type QuerySportFishingResultsForSingleEntryArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySportsArgs = {
  filter?: InputMaybe<ListSportInput>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySportsWithTournamentCountArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStatsArgs = {
  federationId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryStatsForOrganizationArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
};


export type QueryTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamsArgs = {
  filter?: InputMaybe<ListTeamInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryThirdPartyLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryThirdPartyLicensesArgs = {
  filter?: InputMaybe<ListThirdPartyLicenseInput>;
};


export type QueryThirdPartyLicensesBySportIdArgs = {
  filter?: InputMaybe<ListThirdPartyLicenseInput>;
};


export type QueryTournamentArgs = {
  id: Scalars['ID']['input'];
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTournamentAllMatchesArgs = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  matchConflicts?: InputMaybe<Array<MatchesConflicts>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentCategoriesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderField?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoriesWithPartnersCountArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoriesWithPartnersCountUpdatedArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentCategoryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentCountriesArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentDetailByIdArgs = {
  id: Scalars['Int']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentDiscountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentDocumentsArgs = {
  filter?: InputMaybe<ListTournamentDocumentInput>;
};


export type QueryTournamentDrawCategoriesArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryTournamentDrawsMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListDrawEntryInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentFactSheetsArgs = {
  filter?: InputMaybe<ListTournamentFactSheetInput>;
};


export type QueryTournamentGroupCategoriesArgs = {
  filter?: InputMaybe<ListGroupInput>;
};


export type QueryTournamentMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentMatchesDatesArgs = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryTournamentOrganizerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsArgs = {
  filter?: InputMaybe<ListTournamentRankingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentRankingsEntriesArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentRankingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsManArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsWomanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationsArgs = {
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentStatsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
};


export type QueryTournamentTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentTeamMembersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentTeamMembersWithCountArgs = {
  endCreatedAt?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startCreatedAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusArray?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTournamentTopFivePlayersArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTournamentsByUserIdArgs = {
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUpdateUserInRequestsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  originalEmail?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  query: FindUserInput;
};


export type QueryUserAllLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAllMatchesArgs = {
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAllTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  showAllEntries?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserEntriesTeamLicensesCountArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserLeaguePointsArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  rankingId: Scalars['Int']['input'];
};


export type QueryUserLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserLicensesArgs = {
  filter?: InputMaybe<ListUsersLicenseInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryUserParentsArgs = {
  filter?: InputMaybe<ListUserParentInput>;
};


export type QueryUserPartnerSearchCategoriesArgs = {
  email: Scalars['String']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
};


export type QueryUserPartnerSearchesArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPartnerSearchesUpdatedArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserProfileArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserRoleArgs = {
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryUserSportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserThirdPartyLicensesArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentCategoriesArgs = {
  email: Scalars['String']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
};


export type QueryUserTournamentMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentRegistrationsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentsResultArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  showAllEntries?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersCountArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidLicensesForUsersArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLicenseInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidTeamMembersArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTeamInput>;
  id: Scalars['Int']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateUserU10LicenseArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RankingCategoryPoint = {
  __typename?: 'RankingCategoryPoint';
  bracketType?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  numPlaces?: Maybe<Scalars['Float']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  segment?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Float']['output']>;
};

export type RankingPoint = {
  __typename?: 'RankingPoint';
  createdAt: Scalars['DateTime']['output'];
  entries?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  rankingCategoryPoints?: Maybe<Array<RankingCategoryPoint>>;
  rankingPointRules?: Maybe<Array<RankingPointRule>>;
  tournamentCategory?: Maybe<Array<RankingPointCategory>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RankingPointCategory = {
  __typename?: 'RankingPointCategory';
  id: Scalars['Float']['output'];
  rankingPoint?: Maybe<RankingPoint>;
  tournamentCategory?: Maybe<TournamentCategory>;
};

export type RankingPointRule = {
  __typename?: 'RankingPointRule';
  coefficient?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  numberOfEntries?: Maybe<Scalars['String']['output']>;
  numberOfPlayers?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  sector?: Maybe<Scalars['String']['output']>;
  skillLevel?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<TournamentCategory>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RankingTournamentCategory = {
  __typename?: 'RankingTournamentCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The different segments of registration that can be updated */
export enum RegistrationSegment {
  DuprRankings = 'DUPR_RANKINGS',
  Rankings = 'RANKINGS',
  Seeding = 'SEEDING',
  Segment = 'SEGMENT'
}

export type RemoveTournamentCategoriesInput = {
  tournamentCategoryGroupId: Scalars['Int']['input'];
  tournamentCategoryIds: Array<Scalars['Int']['input']>;
};

export type ResourceService = {
  __typename?: 'ResourceService';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  service?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Sport>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponseType = {
  __typename?: 'ResponseType';
  activePeriod: Scalars['String']['output'];
  addedBy?: Maybe<User>;
  additionalQuestions?: Maybe<Array<LicenseQuestion>>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  licenseStatus: LicenseStatus;
  message: Scalars['String']['output'];
  noOfLicense?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Round = {
  __typename?: 'Round';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  matches?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Possible type of a service */
export enum ServiceType {
  Booking = 'BOOKING',
  Entry = 'ENTRY',
  License = 'LICENSE'
}

export type SnsSubscription = {
  __typename?: 'SnsSubscription';
  createdAt: Scalars['DateTime']['output'];
  deviceType: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type Sport = {
  __typename?: 'Sport';
  abbreviation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<Array<Discipline>>;
  displayDraws?: Maybe<Scalars['Boolean']['output']>;
  displayGroups?: Maybe<Scalars['Boolean']['output']>;
  displayListResults?: Maybe<Scalars['Boolean']['output']>;
  displayLiveStandings?: Maybe<Scalars['Boolean']['output']>;
  displayOrderPlay?: Maybe<Scalars['Boolean']['output']>;
  displayPendingResults?: Maybe<Scalars['Boolean']['output']>;
  displaySetting?: Maybe<Array<DisplaySetting>>;
  displayTournamentResults?: Maybe<Scalars['Boolean']['output']>;
  enableCourts?: Maybe<Scalars['Boolean']['output']>;
  enableDiscipline?: Maybe<Scalars['Boolean']['output']>;
  enableStages?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDisplayAthleteChessTitle?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  isEnablePairingStandings?: Maybe<Scalars['Boolean']['output']>;
  isEnablePairings?: Maybe<Scalars['Boolean']['output']>;
  isEnableRounds?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<PlateformSport>>;
  resourceTitle?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sportType?: Maybe<Scalars['String']['output']>;
  textBox?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingEntriesMatric = {
  __typename?: 'SportFishingEntriesMatric';
  categoryId?: Maybe<CategorySetting>;
  confirmAutomatically?: Maybe<Scalars['Boolean']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  id: Scalars['Float']['output'];
  matricResults?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['JSON']['output']>;
  metricContext?: Maybe<SportFishingMetricContext>;
  points?: Maybe<Scalars['Float']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<User>;
  result_counted?: Maybe<Scalars['String']['output']>;
  result_entered?: Maybe<Scalars['String']['output']>;
  sportFishingMatric?: Maybe<SportFishingMatric>;
  sportFishingResult?: Maybe<SportFishingResult>;
  sportFishingResultEntry?: Maybe<SportFishingResultEntry>;
  stage?: Maybe<Court>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingMatric = {
  __typename?: 'SportFishingMatric';
  categoryId?: Maybe<CategorySetting>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disableResultSubmissionByParticipant?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  matricResults?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['String']['output']>;
  metricContext?: Maybe<Array<SportFishingMetricContext>>;
  sportFishingResult?: Maybe<SportFishingResult>;
  stage?: Maybe<Court>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingMetricContext = {
  __typename?: 'SportFishingMetricContext';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  matricsEntry: Array<SportFishingEntriesMatric>;
  metric: SportFishingMatric;
  stage: Court;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type SportFishingResult = {
  __typename?: 'SportFishingResult';
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  entries?: Maybe<Array<SportFishingResultEntry>>;
  id: Scalars['Float']['output'];
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matrics?: Maybe<Array<SportFishingMatric>>;
  segment?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Court>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingResultEntry = {
  __typename?: 'SportFishingResultEntry';
  categoryId?: Maybe<CategorySetting>;
  confirmAutomatically?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  location?: Maybe<Scalars['String']['output']>;
  matrics?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<SportFishingMatric>;
  points?: Maybe<Scalars['Float']['output']>;
  pointsRatio?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['Float']['output']>;
  setRatio?: Maybe<Scalars['Float']['output']>;
  sportFishingResult?: Maybe<SportFishingResult>;
  stage?: Maybe<Court>;
  status?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SportWithTournamentCount = {
  __typename?: 'SportWithTournamentCount';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  tournamentCount: Scalars['Int']['output'];
};

export type Stat = {
  __typename?: 'Stat';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type StripePayments = {
  __typename?: 'StripePayments';
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  livemode?: Maybe<Scalars['Boolean']['output']>;
  paymentIntent?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  default_price?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency: Scalars['String']['output'];
  federationId: Federation;
  id: Scalars['Float']['output'];
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Platform>;
  sports?: Maybe<Array<Sport>>;
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
};

export type SubscriptionFilter = {
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeTo?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionFilters = {
  __typename?: 'SubscriptionFilters';
  organizations?: Maybe<Array<ModifiedFedaration>>;
  packages?: Maybe<Array<StripeProduct>>;
  paymentStatus?: Maybe<Array<Scalars['String']['output']>>;
  sort: Array<Scalars['String']['output']>;
  sports?: Maybe<Array<ModifiedSport>>;
};

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  organizationDetails?: Maybe<Array<FederationSummary>>;
  subscriptions: Array<Subscription>;
  total: Scalars['Int']['output'];
};

export type Team = {
  __typename?: 'Team';
  club?: Maybe<Club>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<TeamMember>>;
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  member?: Maybe<User>;
  role?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamResult = {
  __typename?: 'TeamResult';
  teams: Array<Team>;
  total: Scalars['Int']['output'];
};

export type Template = {
  __typename?: 'Template';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  template?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ThirdPartyLicense = {
  __typename?: 'ThirdPartyLicense';
  endPointLink?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isMakeLicenceMandatory?: Maybe<Scalars['Boolean']['output']>;
  isRequiredInUserProfile?: Maybe<Scalars['Boolean']['output']>;
  isRequiredInUserRegistration?: Maybe<Scalars['Boolean']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Array<Sport>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Tournament = {
  __typename?: 'Tournament';
  Album?: Maybe<Array<Album>>;
  activeTournaments?: Maybe<Scalars['Float']['output']>;
  additionalQuestion?: Maybe<Array<AdditionalQuestion>>;
  additionalQuestion2?: Maybe<Scalars['String']['output']>;
  additionalReferee?: Maybe<Array<TournamentAdditionalReferee>>;
  address?: Maybe<Scalars['String']['output']>;
  /** Tournament location coordinates with latitude and longitude */
  addressCoordinates?: Maybe<Scalars['JSON']['output']>;
  allTournaments?: Maybe<Scalars['Float']['output']>;
  approvedEntries?: Maybe<Scalars['Boolean']['output']>;
  athletes?: Maybe<Scalars['Float']['output']>;
  autoConfirmEntries?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  closeRegistration?: Maybe<Scalars['Boolean']['output']>;
  club?: Maybe<Club>;
  contactUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courts?: Maybe<Array<Court>>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  customInfoMessage?: Maybe<Scalars['String']['output']>;
  customSuccessMessage?: Maybe<Scalars['String']['output']>;
  /** Tournament dates to hide from schedule */
  datesToHide?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<TournamentDiscount>>;
  documents?: Maybe<Array<TournamentDocument>>;
  draws?: Maybe<Array<Draw>>;
  enableLiveScoring?: Maybe<Scalars['Boolean']['output']>;
  enableLiveStream?: Maybe<Scalars['Boolean']['output']>;
  enablePracticeCourtsBooking?: Maybe<Scalars['Boolean']['output']>;
  enableTransferBooking?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  entryDeadline?: Maybe<Scalars['DateTime']['output']>;
  entryFee?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facts?: Maybe<Array<TournamentFactSheet>>;
  fideRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Float']['output'];
  isDuprRatingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDuprRequired?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isHideEntries?: Maybe<Scalars['Boolean']['output']>;
  isHideFromCalendar?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPartnerFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPlatformFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingStripeFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingTournatedFee?: Maybe<Scalars['Boolean']['output']>;
  isOrganizerRegEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayForMyselfEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprEntriesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprRequired?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<LeagueTournament>;
  license?: Maybe<Scalars['String']['output']>;
  listAndResultShowIndividualTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowPointsTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowTeamsTab?: Maybe<Scalars['Boolean']['output']>;
  liveStandings?: Maybe<Array<LiveStanding>>;
  localRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  loggedInUser?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  makePrivate?: Maybe<Scalars['Boolean']['output']>;
  notificationsAddress?: Maybe<Scalars['String']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  onsiteEntryFee?: Maybe<Scalars['Float']['output']>;
  organizer?: Maybe<LeagueMember>;
  pairings?: Maybe<Array<Pairing>>;
  partnerSearch?: Maybe<Scalars['Boolean']['output']>;
  passedTournaments?: Maybe<Scalars['Float']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  poster?: Maybe<Scalars['String']['output']>;
  rankingsReleaseDate?: Maybe<Scalars['String']['output']>;
  referee?: Maybe<TournamentReferee>;
  registerLink?: Maybe<Scalars['String']['output']>;
  registeredUsersInTournament?: Maybe<Scalars['Boolean']['output']>;
  registrationRequestCount?: Maybe<Scalars['Float']['output']>;
  registrationRequests?: Maybe<Array<TournamentRegistration>>;
  registrationStartDate?: Maybe<Scalars['DateTime']['output']>;
  regulations?: Maybe<Scalars['String']['output']>;
  resourceTitle?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  showOOP?: Maybe<Scalars['Boolean']['output']>;
  showTournamentChessManagerCalendar?: Maybe<Scalars['Boolean']['output']>;
  sortRequestBy: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  timeControl?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tour?: Maybe<Scalars['String']['output']>;
  tournamentAddress?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<Array<CategorySetting>>;
  tournamentDirector?: Maybe<Scalars['String']['output']>;
  tournamentRankings?: Maybe<Array<TournamentRanking>>;
  type?: Maybe<Scalars['String']['output']>;
  upcomingTournaments?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  withdrawlDeadline?: Maybe<Scalars['DateTime']['output']>;
};

export type TournamentAdditionalReferee = {
  __typename?: 'TournamentAdditionalReferee';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  referee?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentCategory = {
  __typename?: 'TournamentCategory';
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  ageLimit?: Maybe<Scalars['Float']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  ageType?: Maybe<Scalars['String']['output']>;
  askSkillLevel?: Maybe<Scalars['Boolean']['output']>;
  captainRequired?: Maybe<Scalars['Boolean']['output']>;
  categoryEntries?: Maybe<Scalars['String']['output']>;
  categoryMen?: Maybe<Category>;
  categoryWomen?: Maybe<Category>;
  club?: Maybe<Club>;
  clubChampionship?: Maybe<Scalars['Boolean']['output']>;
  clubs?: Maybe<Array<Club>>;
  countIndividualTotal?: Maybe<Scalars['Boolean']['output']>;
  countPointOnMatchResult?: Maybe<Scalars['Boolean']['output']>;
  countTeamTotal?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<Discipline>;
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  enableMetrics?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  gender: Scalars['String']['output'];
  id?: Maybe<Scalars['Float']['output']>;
  identifyTeamMember?: Maybe<Scalars['Boolean']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  isClubRegistrationRequired?: Maybe<Scalars['Boolean']['output']>;
  isClubSelection?: Maybe<Scalars['Boolean']['output']>;
  isDisplayBirthYear?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isDisplayRank?: Maybe<Scalars['Boolean']['output']>;
  isMixedDoubles?: Maybe<Scalars['Boolean']['output']>;
  isSpecificClubRequired?: Maybe<Scalars['Boolean']['output']>;
  isTeamSelection?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<LeagueTournamentCategory>;
  license?: Maybe<Array<TournamentCategoryLicense>>;
  maxAthletesToCount?: Maybe<Scalars['Float']['output']>;
  maxDUPRSkillLevel?: Maybe<Scalars['Float']['output']>;
  maxMembers?: Maybe<Scalars['Float']['output']>;
  maxReservists?: Maybe<Scalars['Float']['output']>;
  minAthletesToCount?: Maybe<Scalars['Float']['output']>;
  minDUPRSkillLevel?: Maybe<Scalars['Float']['output']>;
  minMembers?: Maybe<Scalars['Float']['output']>;
  minReservists?: Maybe<Scalars['Float']['output']>;
  moveToSingles?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nationalTournament?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  reservistsRequired?: Maybe<Scalars['Boolean']['output']>;
  singleCategory?: Maybe<TournamentCategory>;
  skills?: Maybe<Scalars['String']['output']>;
  skillsLevel?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['Float']['output']>;
  thirdPartyLicense?: Maybe<ThirdPartyLicense>;
  timeControl?: Maybe<Scalars['String']['output']>;
  tournamentCategoryGroups?: Maybe<TournamentCategoryGroup>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wprMaxCompetitionRating?: Maybe<Scalars['Float']['output']>;
  wprMinCompetitionRating?: Maybe<Scalars['Float']['output']>;
  wprRequiredStatusRating?: Maybe<Scalars['String']['output']>;
};

export type TournamentCategoryGroup = {
  __typename?: 'TournamentCategoryGroup';
  id: Scalars['Float']['output'];
  league: League;
  name: Scalars['String']['output'];
  tournamentCategories: Array<TournamentCategory>;
};

export type TournamentCategoryLicense = {
  __typename?: 'TournamentCategoryLicense';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  license?: Maybe<License>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentDiscount = {
  __typename?: 'TournamentDiscount';
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  numberOfCategories?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentDocument = {
  __typename?: 'TournamentDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentFactSheet = {
  __typename?: 'TournamentFactSheet';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  factSheet?: Maybe<FactSheet>;
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentName = {
  __typename?: 'TournamentName';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TournamentOrganizer = {
  __typename?: 'TournamentOrganizer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type TournamentRanking = {
  __typename?: 'TournamentRanking';
  createdAt: Scalars['DateTime']['output'];
  draw?: Maybe<Draw>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  liveStanding?: Maybe<LiveStanding>;
  name?: Maybe<Scalars['String']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  rankings?: Maybe<Array<TournamentRankingsEntry>>;
  sportFishingResult?: Maybe<Scalars['Boolean']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsEntry = {
  __typename?: 'TournamentRankingsEntry';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  place?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<TournamentRanking>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsMan = {
  __typename?: 'TournamentRankingsMan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsResult = {
  __typename?: 'TournamentRankingsResult';
  total: Scalars['Int']['output'];
  tournamentRankings: Array<TournamentRanking>;
};

export type TournamentRankingsWoman = {
  __typename?: 'TournamentRankingsWoman';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentReferee = {
  __typename?: 'TournamentReferee';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  referee?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRegistration = {
  __typename?: 'TournamentRegistration';
  additionalFee?: Maybe<Scalars['Float']['output']>;
  additionalQuestions?: Maybe<Array<TournamentRegistrationQuestion>>;
  additionalSegment?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  assignedSegment?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  payForMyself?: Maybe<Scalars['Boolean']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  rankType?: Maybe<Scalars['String']['output']>;
  registrationRequest?: Maybe<Scalars['Float']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  totalRank?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<TournamentTeamMember>>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
};

export type TournamentRegistrationQuestion = {
  __typename?: 'TournamentRegistrationQuestion';
  amount?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fieldType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  question?: Maybe<AdditionalQuestion>;
  registrationRequest?: Maybe<TournamentRegistration>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type TournamentTeamMember = {
  __typename?: 'TournamentTeamMember';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  blitzElo?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  duprRating?: Maybe<Scalars['Float']['output']>;
  fideTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rapidElo?: Maybe<Scalars['String']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  standardElo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
};

export type TournamentTeamMembersResult = {
  __typename?: 'TournamentTeamMembersResult';
  total: Scalars['Int']['output'];
  tournamentTeamMembers: Array<TournamentTeamMember>;
};

export type TournamentsResult = {
  __typename?: 'TournamentsResult';
  total: Scalars['Int']['output'];
  tournaments: Array<Tournament>;
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  amount: Scalars['Float']['output'];
  athletes?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deductedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  organization?: Maybe<Federation>;
  paidAmount: Scalars['Float']['output'];
  partnerFee?: Maybe<Scalars['Float']['output']>;
  paymentStatus: Scalars['String']['output'];
  platform?: Maybe<Platform>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  productType: Scalars['String']['output'];
  tournament?: Maybe<Tournament>;
  tournamentRegistration?: Maybe<TournamentRegistration>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  transactionType: Scalars['String']['output'];
  user: User;
};

/** Possible types of transaction */
export enum TransactionType {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Free = 'FREE',
  OnlineTransfer = 'ONLINE_TRANSFER'
}

export type UpdateAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryRuleInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  licenseSubtypes?: InputMaybe<Scalars['String']['input']>;
  numberOfTournaments?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCategorySettingInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCategoryTournamentInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClubAdministratorInput = {
  administrator?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateClubCoachInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  coach?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator?: InputMaybe<Scalars['Int']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubMemberInput = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubNewsInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubsServiceInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDisciplineInput = {
  disciplines?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisplaySettingInput = {
  id: Scalars['Int']['input'];
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  looserId?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  qualWinner?: InputMaybe<Scalars['Boolean']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['String']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawScoreInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateFactSheetInput = {
  factSheets?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFederationInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federationEmail?: InputMaybe<Scalars['String']['input']>;
  federationId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFederationLeagueInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFederationNewsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateImageInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateLandingInput = {
  id: Scalars['Int']['input'];
  landingAbbr?: InputMaybe<Scalars['String']['input']>;
  landingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  landingCountry?: InputMaybe<Scalars['String']['input']>;
  landingCustomPlatform?: InputMaybe<Scalars['String']['input']>;
  landingHeadline?: InputMaybe<Scalars['String']['input']>;
  landingHeroLayout?: InputMaybe<Scalars['String']['input']>;
  landingLang?: InputMaybe<Scalars['String']['input']>;
  landingLayout?: InputMaybe<Scalars['String']['input']>;
  landingLocations?: InputMaybe<Scalars['String']['input']>;
  landingLogo?: InputMaybe<Scalars['String']['input']>;
  landingLogoDark?: InputMaybe<Scalars['String']['input']>;
  landingOrganizations?: InputMaybe<Scalars['String']['input']>;
  landingPrimary?: InputMaybe<Scalars['String']['input']>;
  landingPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSubtitle?: InputMaybe<Scalars['String']['input']>;
  landingSupportedSports?: InputMaybe<Scalars['String']['input']>;
  landingTeamPages?: InputMaybe<Scalars['String']['input']>;
  landingTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLandingMemberInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  show_on_pages?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLandingPotmInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  last_updated?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingRoadmapInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  item1?: InputMaybe<Scalars['String']['input']>;
  item2?: InputMaybe<Scalars['String']['input']>;
  item3?: InputMaybe<Scalars['String']['input']>;
  item4?: InputMaybe<Scalars['String']['input']>;
  item5?: InputMaybe<Scalars['String']['input']>;
  item6?: InputMaybe<Scalars['String']['input']>;
  item7?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingSliderInput = {
  button?: InputMaybe<Scalars['String']['input']>;
  date_added?: InputMaybe<Scalars['String']['input']>;
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLeagueCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeagueMemberInput = {
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  member?: InputMaybe<Scalars['Int']['input']>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateLeagueMemberRoleInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueMember?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueNewsInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueTournamentCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueTournamentInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLicenseLeagueInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLicenseQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLiveStandingInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchesScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  groupEntry?: InputMaybe<Scalars['Int']['input']>;
  groupEntryPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMediaInput = {
  album?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  photoCaption?: InputMaybe<Scalars['String']['input']>;
  photoLink?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNewsInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postText?: InputMaybe<Scalars['String']['input']>;
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOnboardingInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateOrganizationPlatformInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOrganizationPlatformMemberInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlateformSportInput = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePlatformCoachInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  displayOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalender?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformDocuments?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePlatformFeeInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  feeType?: InputMaybe<FeeType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMonetization?: InputMaybe<Scalars['Boolean']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinFee?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  rangeEnd?: InputMaybe<Scalars['Float']['input']>;
  rangeStart?: InputMaybe<Scalars['Float']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinFee?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName?: InputMaybe<Scalars['String']['input']>;
  signeeRole?: InputMaybe<Scalars['String']['input']>;
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePurchasedLicenseInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  promo?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
};

export type UpdateRankingCategoryPointInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  categoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRankingPointCategoryInput = {
  id: Scalars['Int']['input'];
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRankingPointInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRankingTournamentCategoryInput = {
  id: Scalars['Int']['input'];
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateResourceServiceInput = {
  id: Scalars['Int']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoundInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  matches?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  existingMedia?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  paymentMethod?: InputMaybe<Payment_Method>;
  paymentStatus?: InputMaybe<Payment_Status>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTeamInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamMemberInput = {
  id: Scalars['Int']['input'];
  member?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTemplateInput = {
  id: Scalars['Int']['input'];
  template?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentAdditionalRefereeInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentCategoryGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryMenId?: InputMaybe<Scalars['Float']['input']>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  categoryWomenId?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentCategoryLicenseInput = {
  id: Scalars['Int']['input'];
  license?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentDiscountInput = {
  discount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  numberOfCategories?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  refereeId?: InputMaybe<Scalars['Float']['input']>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTournamentOrganizerInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsManInput = {
  id: Scalars['Int']['input'];
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsWomanInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRefereeInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentRegistrationQuestionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  question?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentTeamMemberInput = {
  amountPaid?: InputMaybe<Scalars['Float']['input']>;
  blitzElo?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  fideTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rapidElo?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  standardElo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransactionHistoryInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserCoachInput = {
  coaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<Scalars['String']['input']>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  player?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserLicenseInput = {
  id: Scalars['Int']['input'];
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserParentInput = {
  id: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserPlanInput = {
  id: Scalars['Int']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserSportInput = {
  id: Scalars['Int']['input'];
  sport?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  LVID?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  additionalUserRole?: Maybe<Scalars['String']['output']>;
  allow_online_payments?: Maybe<Scalars['String']['output']>;
  appleId?: Maybe<Scalars['String']['output']>;
  atpId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  bonusPoints?: Maybe<Scalars['String']['output']>;
  bonusU12?: Maybe<Scalars['String']['output']>;
  bonusU14?: Maybe<Scalars['String']['output']>;
  bonusU16?: Maybe<Scalars['String']['output']>;
  bt_country?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club_access?: Maybe<Scalars['Boolean']['output']>;
  coach_access?: Maybe<Scalars['Boolean']['output']>;
  confirm_code?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  duprId?: Maybe<Scalars['String']['output']>;
  duprRating?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_confirmed: Scalars['String']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Scalars['String']['output']>;
  fft_licence?: Maybe<Scalars['String']['output']>;
  fideId?: Maybe<Scalars['String']['output']>;
  friends?: Maybe<Array<User>>;
  gender?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  gtw_points?: Maybe<Scalars['Float']['output']>;
  has_fisher_id?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  ipinId?: Maybe<Scalars['String']['output']>;
  isAuthenticationRequired?: Maybe<Scalars['Boolean']['output']>;
  isLeagueManager?: Maybe<Scalars['Boolean']['output']>;
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  is_verified?: Maybe<Scalars['String']['output']>;
  israel_national_id: Scalars['String']['output'];
  itf_points?: Maybe<Scalars['Float']['output']>;
  joined?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  ltsU10Id?: Maybe<Scalars['String']['output']>;
  member_of_plateforms?: Maybe<Array<OrganizationPlatformMember>>;
  middle_name?: Maybe<Scalars['String']['output']>;
  middle_name_passport?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  national_fisher_id?: Maybe<Scalars['String']['output']>;
  new_terms?: Maybe<Scalars['String']['output']>;
  no_fisher_id_doc?: Maybe<Scalars['String']['output']>;
  no_fisher_id_reason?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['String']['output']>;
  oldEmail?: Maybe<Scalars['String']['output']>;
  organization_abbr?: Maybe<Scalars['String']['output']>;
  organization_allow_op?: Maybe<Scalars['String']['output']>;
  organization_avatar?: Maybe<Scalars['String']['output']>;
  organization_email?: Maybe<Scalars['String']['output']>;
  organization_full_name?: Maybe<Scalars['String']['output']>;
  organization_phone?: Maybe<Scalars['String']['output']>;
  organization_submitted?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<Scalars['String']['output']>;
  otherPoints?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otpExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  parent_access?: Maybe<Scalars['Boolean']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pdlId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<UserPlan>>;
  player?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  quiz?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  resetRequired?: Maybe<Scalars['Boolean']['output']>;
  reset_password?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  show_age?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripe_payments?: Maybe<Array<StripePayments>>;
  stripe_private_key?: Maybe<Scalars['String']['output']>;
  stripe_public_key?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  teId?: Maybe<Scalars['String']['output']>;
  teU12Id?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiresIn?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user_address?: Maybe<Scalars['String']['output']>;
  user_app_sport?: Maybe<Scalars['String']['output']>;
  user_at_level?: Maybe<Scalars['String']['output']>;
  user_club_id?: Maybe<Club>;
  user_club_text?: Maybe<Scalars['String']['output']>;
  user_coach?: Maybe<Array<UserCoach>>;
  user_device_token?: Maybe<Scalars['String']['output']>;
  user_device_type?: Maybe<Scalars['String']['output']>;
  user_ip?: Maybe<Scalars['String']['output']>;
  user_join_club?: Maybe<Scalars['String']['output']>;
  user_join_reason?: Maybe<Scalars['String']['output']>;
  user_national_id?: Maybe<Scalars['String']['output']>;
  user_national_med?: Maybe<Scalars['String']['output']>;
  user_parents?: Maybe<Array<UserParent>>;
  user_poster?: Maybe<Scalars['String']['output']>;
  user_social_token?: Maybe<Scalars['String']['output']>;
  user_social_type?: Maybe<Scalars['String']['output']>;
  user_sport?: Maybe<Scalars['String']['output']>;
  user_sports?: Maybe<Array<UserSport>>;
  user_status?: Maybe<Scalars['String']['output']>;
  visitedNewOnboarding?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['String']['output']>;
  wprStatusRating?: Maybe<Scalars['String']['output']>;
  wprUserId?: Maybe<Scalars['String']['output']>;
  wtaId?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type UserCoach = {
  __typename?: 'UserCoach';
  coaches?: Maybe<Array<PlatformCoach>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserLicense = {
  __typename?: 'UserLicense';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  license?: Maybe<License>;
  promo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserLogout = {
  __typename?: 'UserLogout';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UserParent = {
  __typename?: 'UserParent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  parent?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserPlan = {
  __typename?: 'UserPlan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserSport = {
  __typename?: 'UserSport';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  sport?: Maybe<Sport>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  total: Scalars['Int']['output'];
  users: Array<User>;
};

export type CreateTournamentRegistrationMutationVariables = Exact<{
  type: Scalars['String']['input'];
  tournament: Scalars['Int']['input'];
  user?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  request: Scalars['String']['input'];
  termsAndConditions: Scalars['Boolean']['input'];
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input']>;
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  categoryId: Scalars['Int']['input'];
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTournamentRegistrationMutation = { __typename?: 'Mutation', createTournamentRegistration: { __typename?: 'TournamentRegistration', id: number, status?: string | null, additionalFee?: number | null, tournament?: { __typename?: 'Tournament', club?: { __typename?: 'Club', id: number } | null } | null } };

export type CreateTournamentRegistrationsMutationVariables = Exact<{
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  createTournamentRegistrationInputs?: InputMaybe<Array<CreateTournamentRegistrationInput> | CreateTournamentRegistrationInput>;
}>;


export type CreateTournamentRegistrationsMutation = { __typename?: 'Mutation', createTournamentRegistrations: Array<{ __typename?: 'TournamentRegistration', id: number, status?: string | null, additionalFee?: number | null, tournament?: { __typename?: 'Tournament', club?: { __typename?: 'Club', id: number } | null } | null }> };

export type CreateClubMemberMutationVariables = Exact<{
  createClubMemberInput: CreateClubMemberInput;
}>;


export type CreateClubMemberMutation = { __typename?: 'Mutation', createClubMember: { __typename?: 'ClubMember', id: number } };

export type AddFriendMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  friendId: Scalars['Int']['input'];
}>;


export type AddFriendMutation = { __typename?: 'Mutation', addFriend: { __typename?: 'User', id?: number | null, friends?: Array<{ __typename?: 'User', id?: number | null }> | null } };

export type CreateTeamMemberMutationVariables = Exact<{
  team: Scalars['Int']['input'];
  member: Scalars['Int']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'TeamMember', id: number } };

export type CreateLicensePaymentMutationVariables = Exact<{
  amount?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  leagueTitle?: InputMaybe<Scalars['String']['input']>;
  licenseTitle?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  successUrl: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  purchasedLicenseId: Scalars['Int']['input'];
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  alreayExist?: InputMaybe<Scalars['Boolean']['input']>;
  yearsToAdd?: InputMaybe<Scalars['Int']['input']>;
  licenseId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateLicensePaymentMutation = { __typename?: 'Mutation', createLicensePayment: any };

export type CreateFederationMutationVariables = Exact<{
  federationEmail: Scalars['String']['input'];
  role: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  organizationAbbreviation: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['Upload']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateFederationMutation = { __typename?: 'Mutation', createFederation: { __typename?: 'FederationUserToken', accessToken: string, federation: { __typename?: 'Federation', id: number } } };

export type CreatePartnerRequestMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['Int']['input'];
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  partner: Scalars['Int']['input'];
}>;


export type CreatePartnerRequestMutation = { __typename?: 'Mutation', createPartnerRequest: any };

export type CreatePartnerSearchMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePartnerSearchMutation = { __typename?: 'Mutation', createPartnerSearch: { __typename?: 'PartnerSearch', id: number } };

export type CreatePlatformMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  title: Scalars['String']['input'];
  platformType: Scalars['String']['input'];
  country: Scalars['String']['input'];
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  signeeFullName: Scalars['String']['input'];
  signeeRole: Scalars['String']['input'];
}>;


export type CreatePlatformMutation = { __typename?: 'Mutation', createPlatform: { __typename?: 'Platform', id: number, title?: string | null, currency?: string | null, description?: string | null } };

export type CreatePlateformSportMutationVariables = Exact<{
  sport: Scalars['Int']['input'];
  platform: Scalars['Int']['input'];
}>;


export type CreatePlateformSportMutation = { __typename?: 'Mutation', createPlateformSport: { __typename?: 'PlateformSport', id: number } };

export type CreateSportFishingEntriesMatricMutationVariables = Exact<{
  tournament: Scalars['Int']['input'];
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
}>;


export type CreateSportFishingEntriesMatricMutation = { __typename?: 'Mutation', createSportFishingEntriesMatric: { __typename?: 'SportFishingEntriesMatric', points?: number | null, media?: any | null } };

export type CreateStripeSessionMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateStripeSessionMutation = { __typename?: 'Mutation', createStripeSession: any };

export type CreateTeamMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: number, title?: string | null, status?: string | null, country?: string | null } };

export type CreateTeamRegMutationVariables = Exact<{
  tournament?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateTeamRegMutation = { __typename?: 'Mutation', createTeamRegistrationRequest: { __typename?: 'TournamentRegistration', id: number, status?: string | null } };

export type CreateTournamentRegistrationPaymentMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  entryFee?: InputMaybe<Scalars['Float']['input']>;
  platformProcessingFee: Scalars['Float']['input'];
  successUrl?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  registrationRequestIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  VATFee: Scalars['Float']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  totalTournatedServiceFee: Scalars['Float']['input'];
  totalPartnerServiceFee: Scalars['Float']['input'];
}>;


export type CreateTournamentRegistrationPaymentMutation = { __typename?: 'Mutation', createTournamentRegistrationPayment: any };

export type CreateUserCoachMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  coaches?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateUserCoachMutation = { __typename?: 'Mutation', createUserCoach: { __typename?: 'UserCoach', id: number } };

export type CreateUserParentMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  parent: Scalars['Int']['input'];
}>;


export type CreateUserParentMutation = { __typename?: 'Mutation', createUserParent: { __typename?: 'UserParent', id: number } };

export type CreateUserPlanMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  plan: Scalars['String']['input'];
}>;


export type CreateUserPlanMutation = { __typename?: 'Mutation', createUserPlan: { __typename?: 'UserPlan', id: number, plan?: string | null, user?: { __typename?: 'User', id?: number | null } | null } };

export type CreateUserSportMutationVariables = Exact<{
  user?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateUserSportMutation = { __typename?: 'Mutation', createUserSport: { __typename?: 'UserSport', id: number } };

export type UpdatePartnerSearchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdatePartnerSearchMutation = { __typename?: 'Mutation', updatePartnerSearch: { __typename?: 'PartnerSearch', id: number } };

export type RemovePlateformSportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemovePlateformSportMutation = { __typename?: 'Mutation', removePlateformSport: { __typename?: 'PlateformSport', createdAt: any } };

export type RemoveTeamMemberMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: { __typename?: 'TeamMember', role?: string | null } };

export type RemoveUserSportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveUserSportMutation = { __typename?: 'Mutation', removeUserSport: { __typename?: 'UserSport', sport?: { __typename?: 'Sport', id: number } | null } };

export type ForgetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ForgetPasswordMutation = { __typename?: 'Mutation', forgetPassword: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'User', email?: string | null, accessToken?: string | null, name?: string | null, surname?: string | null, role?: string | null, gender?: string | null, dob?: string | null, id?: number | null, nation?: string | null, avatar?: string | null, phone?: string | null, street?: string | null, city?: string | null, facebook?: string | null, instagram?: string | null, website?: string | null, gtw_points?: number | null, preferred_language?: string | null, coach_access?: boolean | null, club_access?: boolean | null, parent_access?: boolean | null, about?: string | null, createdAt: any, user_address?: string | null, linkedIn?: string | null, youtube?: string | null, tiktok?: string | null, citizenship?: string | null, ipinId?: string | null, fideId?: string | null, ltsU10Id?: string | null, duprId?: string | null, pdlId?: string | null, teId?: string | null, atpId?: string | null, wtaId?: string | null, additionalUserRole?: string | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null, user_club_id?: { __typename?: 'Club', id: number, clubName?: string | null } | null, user_parents?: Array<{ __typename?: 'UserParent', id: number, parent?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null } | null }> | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null, plans?: Array<{ __typename?: 'UserPlan', id: number, plan?: string | null }> | null, stripe_payments?: Array<{ __typename?: 'StripePayments', productId?: string | null, status?: string | null }> | null } };

export type CreateUserLicenseMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  license: Scalars['Int']['input'];
  promo: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  payment_status?: InputMaybe<LicensePaymentStatus>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserLicenseMutation = { __typename?: 'Mutation', createPurchasedLicense: { __typename?: 'ResponseType', id: number, promo?: string | null, message: string } };

export type SignUpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  password: Scalars['String']['input'];
  user_sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  role: Scalars['String']['input'];
  nation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'User', email?: string | null, accessToken?: string | null, name?: string | null, surname?: string | null, role?: string | null, gender?: string | null, dob?: string | null, id?: number | null, nation?: string | null, avatar?: string | null, phone?: string | null, street?: string | null, city?: string | null, facebook?: string | null, instagram?: string | null, website?: string | null, gtw_points?: number | null, preferred_language?: string | null, about?: string | null, createdAt: any, user_address?: string | null, linkedIn?: string | null, youtube?: string | null, tiktok?: string | null, citizenship?: string | null, fideId?: string | null, ltsU10Id?: string | null, duprId?: string | null, ipinId?: string | null, teId?: string | null, atpId?: string | null, wtaId?: string | null, pdlId?: string | null, additionalUserRole?: string | null, wprUserId?: string | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null } };

export type RemoveClubMemberMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveClubMemberMutation = { __typename?: 'Mutation', removeClubMember: { __typename?: 'ClubMember', id: number } };

export type RemoveFriendMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  friendId: Scalars['Int']['input'];
}>;


export type RemoveFriendMutation = { __typename?: 'Mutation', removeFriend: { __typename?: 'User', id?: number | null, friends?: Array<{ __typename?: 'User', id?: number | null }> | null } };

export type RemovePartnerSearchMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemovePartnerSearchMutation = { __typename?: 'Mutation', removePartnerSearch: { __typename?: 'PartnerSearch', id: number } };

export type RemoveUserCoachMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveUserCoachMutation = { __typename?: 'Mutation', removeUserCoach: { __typename?: 'UserCoach', user?: { __typename?: 'User', id?: number | null } | null } };

export type RemoveUserParentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveUserParentMutation = { __typename?: 'Mutation', removeUserParent: { __typename?: 'UserParent', user?: { __typename?: 'User', id?: number | null } | null } };

export type RenewUserLicenseMutationVariables = Exact<{
  user: Scalars['Int']['input'];
  license: Scalars['Int']['input'];
  promo: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  payment_status?: InputMaybe<LicensePaymentStatus>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']> | Scalars['JSONObject']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenewUserLicenseMutation = { __typename?: 'Mutation', renewUserLicense: { __typename?: 'ResponseType', id: number, promo?: string | null, message: string } };

export type UpdateUserpasswordMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserpasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id?: number | null, name?: string | null, password?: string | null, email?: string | null } };

export type UpdateClubMemberMutationVariables = Exact<{
  updateClubMemberInput: UpdateClubMemberInput;
}>;


export type UpdateClubMemberMutation = { __typename?: 'Mutation', updateClubMember: { __typename?: 'ClubMember', id: number } };

export type UpdateTeamMemberMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTeamMemberMutation = { __typename?: 'Mutation', updateTeamMember: { __typename?: 'TeamMember', id: number } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: number, title?: string | null, status?: string | null, country?: string | null, image?: string | null } };

export type UpdateUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', email?: string | null, accessToken?: string | null, name?: string | null, surname?: string | null, role?: string | null, gender?: string | null, dob?: string | null, id?: number | null, nation?: string | null, avatar?: string | null, phone?: string | null, street?: string | null, city?: string | null, facebook?: string | null, instagram?: string | null, website?: string | null, gtw_points?: number | null, preferred_language?: string | null, coach_access?: boolean | null, club_access?: boolean | null, parent_access?: boolean | null, about?: string | null, createdAt: any, user_address?: string | null, linkedIn?: string | null, youtube?: string | null, tiktok?: string | null, citizenship?: string | null, ipinId?: string | null, fideId?: string | null, teId?: string | null, atpId?: string | null, wtaId?: string | null, ltsU10Id?: string | null, duprId?: string | null, wprUserId?: string | null, pdlId?: string | null, additionalUserRole?: string | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null, user_parents?: Array<{ __typename?: 'UserParent', id: number, parent?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null } | null }> | null, user_club_id?: { __typename?: 'Club', id: number, clubName?: string | null } | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null, plans?: Array<{ __typename?: 'UserPlan', id: number, plan?: string | null }> | null, stripe_payments?: Array<{ __typename?: 'StripePayments', productId?: string | null, status?: string | null }> | null } };

export type CheckUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  tournament: Scalars['Int']['input'];
  category: Scalars['Int']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckUserMutation = { __typename?: 'Mutation', checkValidations2: any };

export type CheckValidationsToBeDepriciatedMutationVariables = Exact<{
  email: Scalars['String']['input'];
  tournament: Scalars['Int']['input'];
  category: Scalars['Int']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckValidationsToBeDepriciatedMutation = { __typename?: 'Mutation', checkValidationsToBeDepriciated: any };

export type WithdrawMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type WithdrawMutation = { __typename?: 'Mutation', withdrawRegistrations: { __typename?: 'TournamentRegistration', id: number, status?: string | null } };

export type CsvGenerationForPickleballOopQueryVariables = Exact<{
  id: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
}>;


export type CsvGenerationForPickleballOopQuery = { __typename?: 'Query', CsvGenerationForPickleballOOP: string };

export type AlbumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AlbumQuery = { __typename?: 'Query', album: { __typename?: 'Album', id: number, title?: string | null, thumbnail?: string | null, isSpecificTournament?: boolean | null, albumCustomEvent?: string | null, date?: string | null, albumTags?: string | null, media?: Array<{ __typename?: 'Media', id: number, photoLink?: string | null, photoCaption?: string | null, date?: string | null }> | null, league?: { __typename?: 'League', id: number, title?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null } };

export type GetGroupsDataQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGroupsDataQuery = { __typename?: 'Query', allGroups: { __typename?: 'GroupResult', total: number, groups: Array<{ __typename?: 'Group', id: number, name?: string | null, segment?: string | null, displayPlayOrder?: boolean | null, displayMatches?: boolean | null, participantsAddScore?: boolean | null, hide?: boolean | null, comment?: string | null, isDelete?: boolean | null, groupType?: string | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', id?: number | null, name: string, type: string, identifyTeamMember?: boolean | null } | null } | null, entries?: Array<{ __typename?: 'GroupEntry', id: number, place?: number | null, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null }> | null }> } };

export type AllGroupsStandingsQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllGroupsStandingsQuery = { __typename?: 'Query', allGroupsStandings: { __typename?: 'GroupResult', total: number, groups: Array<{ __typename?: 'Group', id: number, name?: string | null, segment?: string | null, displayPlayOrder?: boolean | null, displayMatches?: boolean | null, participantsAddScore?: boolean | null, hide?: boolean | null, comment?: string | null, isDelete?: boolean | null, groupType?: string | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', id?: number | null, name: string, type: string, identifyTeamMember?: boolean | null } | null } | null, entries?: Array<{ __typename?: 'GroupEntry', id: number, place?: number | null, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null }> | null }> } };

export type AllGroupMatchesQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllGroupMatchesQuery = { __typename?: 'Query', allGroupMatches: { __typename?: 'GroupResult', groups: Array<{ __typename?: 'Group', id: number, name?: string | null, segment?: string | null, matches?: Array<{ __typename?: 'GroupMatch', isDelete?: boolean | null, id: number, date?: any | null, time?: string | null, round?: number | null, status?: string | null, matchStatus?: string | null, scoreType?: string | null, score?: Array<{ __typename?: 'MatchScore', round?: number | null, score?: number | null, roundFormat?: string | null, entry?: { __typename?: 'GroupEntry', id: number } | null }> | null, court?: { __typename?: 'Court', name?: string | null, id: number } | null, winner?: { __typename?: 'GroupEntry', id: number } | null, winnerPartner?: { __typename?: 'GroupEntry', id: number } | null, entry1?: { __typename?: 'GroupEntry', id: number, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null } | null, entry1partner?: { __typename?: 'GroupEntry', id: number, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null } | null, entry2?: { __typename?: 'GroupEntry', id: number, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null } | null, entry2partner?: { __typename?: 'GroupEntry', id: number, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, seed?: number | null, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, nation?: string | null } | null }> | null } | null } | null }> | null }> } };

export type AllNewsQueryVariables = Exact<{
  filter?: InputMaybe<ListNewsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllNewsQuery = { __typename?: 'Query', allNews: { __typename?: 'NewsResult', total: number, news: Array<{ __typename?: 'News', id: number, title?: string | null, slug?: string | null, image?: string | null, postText?: string | null, date?: any | null, author?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null } | null, federationNews?: Array<{ __typename?: 'FederationNews', id: number, news?: { __typename?: 'News', id: number, title?: string | null } | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null } | null }> | null }> } };

export type AllTournamentCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ListCategorySettingInput>;
}>;


export type AllTournamentCategoriesQuery = { __typename?: 'Query', allTournamentCategories: Array<any> };

export type TournamentCategoriesWithPartnersCountQueryVariables = Exact<{
  filter?: InputMaybe<ListCategorySettingInput>;
}>;


export type TournamentCategoriesWithPartnersCountQuery = { __typename?: 'Query', tournamentCategoriesWithPartnersCount: Array<any> };

export type AllTournamentsListQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  isLast7or30Days?: InputMaybe<Scalars['Boolean']['input']>;
  categoryGroup?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllTournamentsListQuery = { __typename?: 'Query', allTournamentsList: any };

export type CalculateLeaguePointsQueryVariables = Exact<{
  filter: ListTournamentRankingsEntryInput;
}>;


export type CalculateLeaguePointsQuery = { __typename?: 'Query', calculateLeaguePoints: Array<any> };

export type CalculateGroupScoreQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupInput>;
}>;


export type CalculateGroupScoreQuery = { __typename?: 'Query', calculateGroupScore: Array<any> };

export type CalculateTeamTotaltResultQueryVariables = Exact<{
  filter?: InputMaybe<ListSportFishingResultInput>;
}>;


export type CalculateTeamTotaltResultQuery = { __typename?: 'Query', calculateTeamTotaltResult: any };

export type CalculateTotaltFishingResultQueryVariables = Exact<{
  filter?: InputMaybe<ListSportFishingResultInput>;
}>;


export type CalculateTotaltFishingResultQuery = { __typename?: 'Query', calculateTotaltFishingResult: Array<any> };

export type MyCareerQueryVariables = Exact<{
  user?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyCareerQuery = { __typename?: 'Query', myCareer: any };

export type CheckUserAsParentOrCoachQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CheckUserAsParentOrCoachQuery = { __typename?: 'Query', checkUserAsParentOrCoach: any };

export type CheckUserRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUserRoleQuery = { __typename?: 'Query', checkUserRole: any };

export type ClubQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<ListClubInput>;
}>;


export type ClubQuery = { __typename?: 'Query', club: { __typename?: 'Club', country?: string | null, id: number, clubName?: string | null, logo?: string | null, city?: string | null, address?: string | null, contactEmail?: string | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, description?: string | null, linkedin?: string | null, website?: string | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null } | null, teams?: Array<{ __typename?: 'Team', id: number, title?: string | null, country?: string | null, members?: Array<{ __typename?: 'TeamMember', id: number, member?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, role?: string | null, nation?: string | null, avatar?: string | null } | null }> | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null } | null }> | null, members?: Array<{ __typename?: 'ClubMember', id: number, status: string, approvedAt?: any | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, role?: string | null, nation?: string | null, phone?: string | null, avatar?: string | null } | null }> | null, federation?: { __typename?: 'Federation', id: number } | null, platform?: { __typename?: 'Platform', id: number } | null } };

export type ClubDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ClubDetailsQuery = { __typename?: 'Query', clubDetails: any };

export type ClubsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sport?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListClubInput>;
}>;


export type ClubsQuery = { __typename?: 'Query', clubs: any };

export type PlatformCoachQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PlatformCoachQuery = { __typename?: 'Query', platformCoach: { __typename?: 'PlatformCoach', id: number, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, phone?: string | null, name?: string | null, surname?: string | null, citizenship?: string | null, nation?: string | null, avatar?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, avatar?: string | null, citizenship?: string | null, role?: string | null } | null }> | null, sport?: { __typename?: 'Sport', id: number, icon?: string | null } | null } };

export type PdfGenerationForPickleballQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PdfGenerationForPickleballQuery = { __typename?: 'Query', PdfGenerationForPickleball: string };

export type CsvGenerationForPickleballGroupsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CsvGenerationForPickleballGroupsQuery = { __typename?: 'Query', CsvGenerationForPickleballGroups: string };

export type PdfGenerationForDrawQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfGenerationForDrawQuery = { __typename?: 'Query', PdfGenerationForDraw: string };

export type PdfGenerationForGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  pdfFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfGenerationForGroupQuery = { __typename?: 'Query', PdfGenerationForGroup: string };

export type PdfGenerationForGridQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PdfGenerationForGridQuery = { __typename?: 'Query', PdfGenerationForGrid: string };

export type PdfGenerationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PdfGenerationQuery = { __typename?: 'Query', PdfGeneration: string };

export type FeaturedLeaguesQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueInput>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type FeaturedLeaguesQuery = { __typename?: 'Query', featuredLeagues: any };

export type FeaturedTournamentsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FeaturedTournamentsQuery = { __typename?: 'Query', featuredTournaments: Array<{ __typename?: 'Tournament', id: number, title?: string | null, tour?: string | null, address?: string | null, startDate?: any | null, endDate?: any | null, entryDeadline?: any | null, createdAt: any, country?: string | null, city?: string | null, logo?: string | null, coverPhoto?: string | null, closeRegistration?: boolean | null, paymentMethod?: string | null, status?: string | null, poster?: string | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', logo?: string | null, id: number, title?: string | null, enableLicense?: boolean | null, abbreviation?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationType?: string | null, organizationAbbreviation?: string | null, logo?: string | null } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', isRegistered?: boolean | null, id: number, fee?: number | null, currency?: string | null, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null } | null }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', name?: string | null, id?: number | null, surname?: string | null, avatar?: string | null } | null } | null, referee?: { __typename?: 'TournamentReferee', referee?: { __typename?: 'User', name?: string | null } | null } | null, registrationRequests?: Array<{ __typename?: 'TournamentRegistration', id: number }> | null }> };

export type SearchCoachByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SearchCoachByEmailQuery = { __typename?: 'Query', searchCoachByEmail: { __typename?: 'PlatformCoach', id: number, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null, fideId?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, avatar?: string | null } | null }> | null } };

export type FindTournamentsByDateQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindTournamentsByDateQuery = { __typename?: 'Query', findTournamentsByDate: any };

export type AllAthletesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ListUsersInput>;
}>;


export type AllAthletesQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', users: Array<{ __typename?: 'User', id?: number | null, name?: string | null, email?: string | null, nation?: string | null, gender?: string | null, role?: string | null, surname?: string | null }> } };

export type DisciplinesQueryVariables = Exact<{
  filter?: InputMaybe<ListDisciplineInput>;
}>;


export type DisciplinesQuery = { __typename?: 'Query', disciplines: Array<{ __typename?: 'Discipline', id: number, title?: string | null, icon?: string | null, resultType?: string | null, sport?: { __typename?: 'Sport', id: number, enableDiscipline?: boolean | null, title?: string | null } | null }> };

export type FederationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListFederationInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FederationsQuery = { __typename?: 'Query', federations: { __typename?: 'FederationResult', total: number, federations: Array<{ __typename?: 'Federation', id: number, organizationName?: string | null, organizationType?: string | null, logo?: string | null, platforms?: Array<{ __typename?: 'OrganizationPlatform', platform?: { __typename?: 'Platform', sports?: Array<{ __typename?: 'PlateformSport', sport?: { __typename?: 'Sport', title?: string | null, icon?: string | null } | null }> | null } | null }> | null, user?: { __typename?: 'User', email?: string | null, nation?: string | null } | null, leagues?: Array<{ __typename?: 'LeagueOwner', league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null } | null }> | null }> } };

export type AllLeagueNewsQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueNewsInput>;
}>;


export type AllLeagueNewsQuery = { __typename?: 'Query', allLeagueNews: Array<{ __typename?: 'LeagueNews', id: number, news?: { __typename?: 'News', id: number, title?: string | null, image?: string | null, slug?: string | null, postText?: string | null, date?: any | null, author?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null } | null } | null }> };

export type UserLicensesQueryVariables = Exact<{
  filter?: InputMaybe<ListPurchasedLicensesInput>;
}>;


export type UserLicensesQuery = { __typename?: 'Query', purchasedLicenses: Array<{ __typename?: 'PurchasedLicense', id: number, promo?: string | null, createdAt: any, payment_status?: string | null, paid?: number | null, currency?: string | null, activePeriod: string, licenseStatus: LicenseStatus, league?: { __typename?: 'League', id: number, title?: string | null } | null, license?: { __typename?: 'License', title?: string | null, id: number, fee?: number | null, currency?: string | null, duration?: string | null, startDate?: any | null, endDate?: any | null, status?: string | null, leagues?: Array<{ __typename?: 'LicenseLeague', id: number, league?: { __typename?: 'League', id: number } | null }> | null } | null }> };

export type SportsQueryVariables = Exact<{
  filter: ListSportInput;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SportsQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> };

export type GetAllStripeProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStripeProductsQuery = { __typename?: 'Query', getAllStripeProducts: Array<any> };

export type TeamMembersQueryVariables = Exact<{
  filter?: InputMaybe<ListTeamMemberInput>;
}>;


export type TeamMembersQuery = { __typename?: 'Query', findAllTeamMembers: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, updatedAt: any, team?: { __typename?: 'Team', id: number, title?: string | null } | null, member?: { __typename?: 'User', id?: number | null, email?: string | null, gender?: string | null, surname?: string | null, name?: string | null, role?: string | null, avatar?: string | null, dob?: string | null, country?: string | null } | null }> };

export type PartnersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPartnerInput>;
}>;


export type PartnersQuery = { __typename?: 'Query', partners: Array<{ __typename?: 'Partner', id: number, title?: string | null, image?: string | null, link?: string | null, activeTo?: any | null, activeFrom?: any | null }> };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<ListUsersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', total: number, users: Array<{ __typename?: 'User', name?: string | null, surname?: string | null, email?: string | null, phone?: string | null, nation?: string | null, gender?: string | null, city?: string | null, street?: string | null, user_club_text?: string | null, role?: string | null, password?: string | null, dob?: string | null, avatar?: string | null, id?: number | null }> } };

export type AthletesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ListAthleteInput>;
}>;


export type AthletesQuery = { __typename?: 'Query', athletes: Array<{ __typename?: 'Athlete', id: number, athlete?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, phone?: string | null, nation?: string | null, gender?: string | null, city?: string | null, user_address?: string | null, user_join_club?: string | null, national_fisher_id?: string | null, role?: string | null, password?: string | null, dob?: string | null, avatar?: string | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null } | null }> };

export type BannersQueryVariables = Exact<{
  filter: ListBannerInput;
}>;


export type BannersQuery = { __typename?: 'Query', banners: Array<{ __typename?: 'Banner', id: number, headLine?: string | null, subHeadLine?: string | null, buttonText?: string | null, buttonLink?: string | null, images?: string | null, primaryColor?: string | null, status?: string | null, role?: string | null, sports?: Array<{ __typename?: 'Sport', id: number }> | null }> };

export type CaptainsTeamQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CaptainsTeamQuery = { __typename?: 'Query', captainTeams: Array<{ __typename?: 'Team', id: number, title?: string | null, image?: string | null, members?: Array<{ __typename?: 'TeamMember', role?: string | null, member?: { __typename?: 'User', id?: number | null, email?: string | null } | null, team?: { __typename?: 'Team', title?: string | null } | null }> | null }> };

export type PlatformCoachesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  filter?: InputMaybe<ListCoachInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlatformCoachesQuery = { __typename?: 'Query', platformCoaches: { __typename?: 'PlatformCoachResult', total: number, platformCoaches: Array<{ __typename?: 'PlatformCoach', id: number, userRole?: string | null, category?: string | null, status?: string | null, platform?: { __typename?: 'Platform', id: number, title?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, nation?: string | null, city?: string | null, avatar?: string | null, citizenship?: string | null } | null, sport?: { __typename?: 'Sport', id: number, icon?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null } | null }> | null, clubs?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, city?: string | null, country?: string | null, logo?: string | null, tournaments?: Array<{ __typename?: 'Tournament', id: number }> | null, clubServices?: Array<{ __typename?: 'ClubService', id: number, services?: { __typename?: 'ResourceService', sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null } | null } | null }> | null, federation?: { __typename?: 'Federation', id: number } | null, members?: Array<{ __typename?: 'ClubMember', id: number, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null } | null }> | null }> | null }> } };

export type PlatformDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<ListPlatformDocumentInput>;
}>;


export type PlatformDocumentsQuery = { __typename?: 'Query', platformDocuments: Array<{ __typename?: 'PlatformDocument', id: number, document?: string | null, isLeaguePage?: boolean | null, isTournamentCalender?: boolean | null, isRankings?: boolean | null, name?: string | null }> };

export type DrawsQueryVariables = Exact<{
  filter?: InputMaybe<ListDrawInput>;
}>;


export type DrawsQuery = { __typename?: 'Query', draws: Array<any> };

export type EligibleTeamMembersQueryVariables = Exact<{
  category?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListTeamMemberInput>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
}>;


export type EligibleTeamMembersQuery = { __typename?: 'Query', eligibleTeamMembers: Array<{ __typename?: 'TeamMember', id: number, member?: { __typename?: 'User', email?: string | null, gender?: string | null, name?: string | null, role?: string | null, dob?: string | null } | null, team?: { __typename?: 'Team', id: number } | null }> };

export type RegistrationCountQueryVariables = Exact<{
  tournament?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationCountQuery = { __typename?: 'Query', registrationCount: any };

export type FindFederationQueryVariables = Exact<{
  filter?: InputMaybe<ListFederationInput>;
}>;


export type FindFederationQuery = { __typename?: 'Query', findFederation: { __typename?: 'Federation', id: number } };

export type FederationbyidQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FederationbyidQuery = { __typename?: 'Query', federation: { __typename?: 'Federation', logo?: string | null, organizationAbbreviation?: string | null, organizationName?: string | null, organizationType?: string | null, user?: { __typename?: 'User', surname?: string | null, email?: string | null, phone?: string | null } | null, leagues?: Array<{ __typename?: 'LeagueOwner', id: number, league?: { __typename?: 'League', id: number } | null }> | null } };

export type FederationDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FederationDetailsQuery = { __typename?: 'Query', federationDetails: any };

export type FindAllAlbumQueryVariables = Exact<{
  filter?: InputMaybe<ListAlbumInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindAllAlbumQuery = { __typename?: 'Query', findAllAlbum: { __typename?: 'Albums', total: number, albums: Array<{ __typename?: 'Album', id: number, title?: string | null, thumbnail?: string | null, isSpecificTournament?: boolean | null, albumCustomEvent?: string | null, albumTags?: string | null, date?: string | null, createdAt: any, media?: Array<{ __typename?: 'Media', id: number, photoLink?: string | null, photoCaption?: string | null }> | null, league?: { __typename?: 'League', id: number, title?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null }> } };

export type UserleaguesQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueInput>;
}>;


export type UserleaguesQuery = { __typename?: 'Query', leagues: Array<{ __typename?: 'League', title?: string | null, enableLicense?: boolean | null, id: number, type?: string | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number } | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null, athlete?: Array<{ __typename?: 'Athlete', id: number }> | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null } | null } | null } | null }> };

export type GetLeagueByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLeagueByIdQuery = { __typename?: 'Query', league: { __typename?: 'League', title?: string | null, enableLicense?: boolean | null, enableRankings?: boolean | null, id: number, type?: string | null, status?: string | null, country?: string | null, email?: string | null, website?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null } | null, leagueCategory?: Array<{ __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null } | null }> | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null, athlete?: Array<{ __typename?: 'Athlete', id: number }> | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, logo?: string | null, contactPhone?: string | null, contactEmail?: string | null, website?: string | null, user?: { __typename?: 'User', id?: number | null } | null } | null } | null, members?: Array<{ __typename?: 'LeagueMember', id: number, role?: Array<{ __typename?: 'LeagueMemberRole', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null } | null, role?: { __typename?: 'Role', id: number, name?: string | null } | null }> | null, member?: { __typename?: 'User', email?: string | null, id?: number | null, role?: string | null, name?: string | null } | null }> | null } };

export type LeagueRankingsDateQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueRankingInput>;
}>;


export type LeagueRankingsDateQuery = { __typename?: 'Query', leagueRankingsDate: Array<{ __typename?: 'LeagueRanking', date?: string | null }> };

export type LicensesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLicenseInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LicensesQuery = { __typename?: 'Query', licenses: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, fieldType?: string | null, fieldOptions?: string | null, askEachAthlete?: boolean | null }> | null }> };

export type LiveStandingsQueryVariables = Exact<{
  filter?: InputMaybe<ListLiveStandingsInput>;
}>;


export type LiveStandingsQuery = { __typename?: 'Query', liveStandings: Array<{ __typename?: 'LiveStanding', id: number, title?: string | null, segment?: string | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, id?: number | null, identifyTeamMember?: boolean | null } | null } | null, standings?: Array<{ __typename?: 'LiveStandingsEntry', id: number, place?: number | null, points?: number | null, pointsRatio?: number | null, setRatio?: number | null, entry?: { __typename?: 'GroupEntry', id: number, place?: number | null, group?: { __typename?: 'Group', name?: string | null } | null, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, segment?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, seed?: number | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null } | null }> | null } | null } | null }> | null }> };

export type CourtsQueryVariables = Exact<{
  filter?: InputMaybe<ListCourtInput>;
}>;


export type CourtsQuery = { __typename?: 'Query', courts: Array<{ __typename?: 'Court', id: number, name?: string | null, isPublish?: boolean | null }> };

export type GroupMatchesQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupMatchInput>;
}>;


export type GroupMatchesQuery = { __typename?: 'Query', groupMatches: Array<{ __typename?: 'GroupMatch', id: number, date?: any | null }> };

export type GetTournamentTeamMembersQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTournamentTeamMembersQuery = { __typename?: 'Query', tournamentTeamMembers: Array<{ __typename?: 'TournamentTeamMember', id: number, status?: string | null, isDelete?: boolean | null, registrationRequest?: { __typename?: 'TournamentRegistration', id: number, status?: string | null, type?: string | null, createdAt: any } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null, citizenship?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, withdrawlDeadline?: any | null, logo?: string | null, coverPhoto?: string | null, startDate?: any | null, country?: string | null, additionalQuestion?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null }> | null } | null, categoryId?: { __typename?: 'CategorySetting', id: number } | null }> };

export type TournamentRegistrationsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentRegistrationInput>;
}>;


export type TournamentRegistrationsQuery = { __typename?: 'Query', tournamentRegistrations: Array<{ __typename?: 'TournamentRegistration', id: number, status?: string | null, type?: string | null, additionalFee?: number | null, createdAt: any, payForMyself?: boolean | null, amount?: number | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, status?: string | null, paymentStatus?: string | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null } | null }> | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, withdrawlDeadline?: any | null, entryDeadline?: any | null, additionalQuestion?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null }> | null } | null, categoryId?: { __typename?: 'CategorySetting', id: number, fee?: number | null, onsiteFee?: number | null, onlinePayments?: string | null, currency?: string | null, category?: { __typename?: 'TournamentCategory', name: string, id?: number | null, type: string } | null } | null }> };

export type NewsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type NewsQuery = { __typename?: 'Query', news: { __typename?: 'News', id: number, title?: string | null, image?: string | null, postText?: string | null, category?: string | null, youtubeVideoLink?: string | null, date?: any | null, author?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null } | null, clubNews?: Array<{ __typename?: 'ClubNews', id: number, club?: { __typename?: 'Club', id: number, contactEmail?: string | null, clubName?: string | null } | null }> | null, leagueNews?: Array<{ __typename?: 'LeagueNews', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null }> | null, federationNews?: Array<{ __typename?: 'FederationNews', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null } | null, news?: { __typename?: 'News', id: number, title?: string | null } | null }> | null } };

export type TournamentAllMatchesQueryVariables = Exact<{
  viewType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TournamentAllMatchesQuery = { __typename?: 'Query', tournamentAllMatches: any };

export type UserParentsQueryVariables = Exact<{
  filter?: InputMaybe<ListUserParentInput>;
}>;


export type UserParentsQuery = { __typename?: 'Query', userParents: Array<{ __typename?: 'UserParent', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, avatar?: string | null } | null }> };

export type ParticipentsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParticipentsQuery = { __typename?: 'Query', tournamentRegistrations: Array<{ __typename?: 'TournamentRegistration', id: number, type?: string | null, status?: string | null, rankType?: string | null, assignedSegment?: string | null, additionalSegment?: string | null, seed?: number | null, team?: { __typename?: 'Team', title?: string | null, country?: string | null, image?: string | null } | null, categoryId?: { __typename?: 'CategorySetting', mdwc?: number | null, qwc?: number | null, qs?: number | null, id: number, category?: { __typename?: 'TournamentCategory', identifyTeamMember?: boolean | null } | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, fideTitle?: string | null, rank?: number | null, blitzElo?: string | null, standardElo?: string | null, rapidElo?: string | null, duprRating?: number | null, user?: { __typename?: 'User', rank?: number | null, id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null, citizenship?: string | null, city?: string | null, user_club_id?: { __typename?: 'Club', clubName?: string | null, city?: string | null } | null } | null }> | null }> };

export type CalculatePaymentsQueryVariables = Exact<{
  categoryPaymentInput: Array<CategoryPaymentInput> | CategoryPaymentInput;
  calculatePaymentInput: CalculatePaymentInput;
}>;


export type CalculatePaymentsQuery = { __typename?: 'Query', calculatePayments: any };

export type PlatformQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlatformQuery = { __typename?: 'Query', platform: { __typename?: 'PlatformWithSubscription', id: number, title?: string | null, country?: string | null, platformType?: string | null, primaryColor?: string | null, secondaryColor?: string | null, darkLogo?: string | null, lightLogo?: string | null, darkEmblem?: string | null, lightEmblem?: string | null, coverPhoto?: string | null, isEnablePrice?: boolean | null, language?: string | null, companyName?: string | null, companyEmail?: string | null, companyPhone?: number | null, landingLink?: string | null, isEnableMaintenance?: boolean | null, passcode?: string | null, maintenanceDescription?: string | null, maintenanceTitle?: string | null, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null }> | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null } };

export type GetPlayerRankingsByTennisIdQueryVariables = Exact<{
  tennisId: Scalars['String']['input'];
  citizenship: Scalars['String']['input'];
}>;


export type GetPlayerRankingsByTennisIdQuery = { __typename?: 'Query', getPlayerRankingsByTennisId: any };

export type GetPlayerFideRankingQueryVariables = Exact<{
  fideId: Scalars['String']['input'];
}>;


export type GetPlayerFideRankingQuery = { __typename?: 'Query', getPlayerFideRanking: any };

export type TournamentRankingsQueryVariables = Exact<{
  filter: ListTournamentRankingInput;
}>;


export type TournamentRankingsQuery = { __typename?: 'Query', tournamentRankings: { __typename?: 'TournamentRankingsResult', total: number, tournamentRankings: Array<{ __typename?: 'TournamentRanking', id: number, name?: string | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, id?: number | null, identifyTeamMember?: boolean | null } | null } | null, rankings?: Array<{ __typename?: 'TournamentRankingsEntry', id: number, place?: string | null, points?: number | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, id?: number | null } | null } | null, entry?: { __typename?: 'TournamentRegistration', id: number, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null } | null }> | null } | null }> | null }> } };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: number, name?: string | null }> };

export type TeamByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TeamByIdQuery = { __typename?: 'Query', team: { __typename?: 'Team', createdAt: any, id: number, title?: string | null, image?: string | null, country?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null, club?: { __typename?: 'Club', id: number, clubName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number } | null, members?: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, member?: { __typename?: 'User', email?: string | null, surname?: string | null, name?: string | null, id?: number | null, avatar?: string | null, nation?: string | null } | null, team?: { __typename?: 'Team', title?: string | null } | null }> | null } };

export type TeamsQueryVariables = Exact<{
  filter?: InputMaybe<ListTeamInput>;
}>;


export type TeamsQuery = { __typename?: 'Query', teams: { __typename?: 'TeamResult', total: number, teams: Array<{ __typename?: 'Team', id: number, title?: string | null, country?: string | null, status?: string | null, image?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null } | null, club?: { __typename?: 'Club', id: number, clubName?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null, members?: Array<{ __typename?: 'TeamMember', role?: string | null, member?: { __typename?: 'User', surname?: string | null, name?: string | null, email?: string | null, avatar?: string | null, id?: number | null } | null, team?: { __typename?: 'Team', title?: string | null } | null }> | null }> } };

export type ThirdPartyLicensesBySportIdQueryVariables = Exact<{
  filter?: InputMaybe<ListThirdPartyLicenseInput>;
}>;


export type ThirdPartyLicensesBySportIdQuery = { __typename?: 'Query', thirdPartyLicensesBySportId: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null }> | null }> };

export type TournamentCountriesQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
}>;


export type TournamentCountriesQuery = { __typename?: 'Query', tournamentCountries: Array<{ __typename?: 'Tournament', country?: string | null }> };

export type TournamentDetailByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TournamentDetailByIdQuery = { __typename?: 'Query', tournamentDetailById: { __typename?: 'Tournament', id: number, title?: string | null, isManagerPayingServiceFee?: boolean | null, isPayForMyselfEnabled?: boolean | null, events?: string | null, isDuprRatingEnabled?: boolean | null, isDuprRequired?: boolean | null, isWprRequired?: boolean | null, tour?: string | null, coverPhoto?: string | null, startDate?: any | null, endDate?: any | null, registrationStartDate?: any | null, entryDeadline?: any | null, description?: string | null, license?: string | null, timeZone?: string | null, termsAndConditions?: string | null, customInfoMessage?: string | null, customSuccessMessage?: string | null, closeRegistration?: boolean | null, partnerSearch?: boolean | null, country?: string | null, address?: string | null, city?: string | null, entryFee?: string | null, registerLink?: string | null, withdrawlDeadline?: any | null, currency?: string | null, createdAt: any, type?: string | null, regulations?: string | null, paymentMethod?: string | null, logo?: string | null, timeControl?: string | null, showOOP?: boolean | null, poster?: string | null, isHideEntries?: boolean | null, addressCoordinates?: any | null, Album?: Array<{ __typename?: 'Album', id: number, thumbnail?: string | null, albumTags?: string | null, albumCustomEvent?: string | null, date?: string | null, createdAt: any, title?: string | null, isSpecificTournament?: boolean | null, media?: Array<{ __typename?: 'Media', id: number }> | null }> | null, discounts?: Array<{ __typename?: 'TournamentDiscount', numberOfCategories?: number | null, discount?: number | null }> | null, club?: { __typename?: 'Club', id: number, logo?: string | null, clubName?: string | null } | null, tournamentRankings?: Array<{ __typename?: 'TournamentRanking', id: number }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, organizationLogo?: string | null, organizationPhone?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', email?: string | null, name?: string | null, id?: number | null, avatar?: string | null, surname?: string | null, instagram?: string | null, facebook?: string | null, phone?: string | null } | null } | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, enableLicense?: boolean | null, logo?: string | null, title?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, logo?: string | null } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null, resourceTitle?: string | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, displayGroups?: boolean | null, displayDraws?: boolean | null, enableStages?: boolean | null, enableCourts?: boolean | null, enableDiscipline?: boolean | null, isEnablePairings?: boolean | null, isEnablePairingStandings?: boolean | null, isDisplaySeeds?: boolean | null, isDisplaySegments?: boolean | null, isDisplayAthleteChessTitle?: boolean | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', status?: string | null, isRegistered?: boolean | null, paymentStatus?: string | null, onlinePayments?: string | null, id: number, fee?: number | null, onsiteFee?: number | null, currency?: string | null, method?: string | null, time?: number | null, timePerMove?: number | null, timeAfterMove?: number | null, extraTime?: number | null, pairing?: string | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, fieldType?: string | null, fieldOptions?: string | null, answer?: string | null, askEachAthlete?: boolean | null }> | null, category?: { __typename?: 'TournamentCategory', enableLicense?: boolean | null, isDisplayClub?: boolean | null, isDisplayCity?: boolean | null, timeControl?: string | null, name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null, license?: Array<{ __typename?: 'TournamentCategoryLicense', id: number, license?: { __typename?: 'License', id: number, title?: string | null } | null }> | null } | null }> | null, draws?: Array<{ __typename?: 'Draw', id: number }> | null, groups?: Array<{ __typename?: 'Group', id: number }> | null, pairings?: Array<{ __typename?: 'Pairing', id: number, hideStandings?: boolean | null }> | null, liveStandings?: Array<{ __typename?: 'LiveStanding', id: number }> | null, referee?: { __typename?: 'TournamentReferee', id: number, referee?: { __typename?: 'User', id?: number | null, name?: string | null } | null } | null, additionalReferee?: Array<{ __typename?: 'TournamentAdditionalReferee', id: number, referee?: { __typename?: 'User', id?: number | null, name?: string | null } | null }> | null, facts?: Array<{ __typename?: 'TournamentFactSheet', id: number, answer?: string | null, factSheet?: { __typename?: 'FactSheet', id: number, fieldTitle?: string | null, fieldType?: string | null, options?: string | null } | null }> | null } };

export type TournamentDrawCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ListDrawInput>;
}>;


export type TournamentDrawCategoriesQuery = { __typename?: 'Query', tournamentDrawCategories: Array<any> };

export type GetTournamentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['Float']['input']>;
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetTournamentByIdQuery = { __typename?: 'Query', tournament: { __typename?: 'Tournament', id: number, title?: string | null, tour?: string | null, coverPhoto?: string | null, startDate?: any | null, endDate?: any | null, entryDeadline?: any | null, description?: string | null, license?: string | null, timeZone?: string | null, termsAndConditions?: string | null, closeRegistration?: boolean | null, partnerSearch?: boolean | null, country?: string | null, address?: string | null, city?: string | null, entryFee?: string | null, registerLink?: string | null, withdrawlDeadline?: any | null, currency?: string | null, createdAt: any, type?: string | null, regulations?: string | null, paymentMethod?: string | null, logo?: string | null, timeControl?: string | null, showOOP?: boolean | null, poster?: string | null, club?: { __typename?: 'Club', id: number } | null, tournamentRankings?: Array<{ __typename?: 'TournamentRanking', id: number }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, organizationLogo?: string | null, organizationPhone?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', email?: string | null, name?: string | null, id?: number | null, avatar?: string | null, surname?: string | null, instagram?: string | null, facebook?: string | null, phone?: string | null } | null } | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, enableLicense?: boolean | null, title?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null, resourceTitle?: string | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, displayGroups?: boolean | null, displayDraws?: boolean | null, enableStages?: boolean | null, enableCourts?: boolean | null, enableDiscipline?: boolean | null, isEnablePairings?: boolean | null, isEnablePairingStandings?: boolean | null, isDisplaySeeds?: boolean | null, isDisplaySegments?: boolean | null, isDisplayAthleteChessTitle?: boolean | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', status?: string | null, isRegistered?: boolean | null, paymentStatus?: string | null, onlinePayments?: string | null, id: number, fee?: number | null, onsiteFee?: number | null, currency?: string | null, method?: string | null, time?: number | null, timePerMove?: number | null, timeAfterMove?: number | null, extraTime?: number | null, pairing?: string | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, fieldType?: string | null, fieldOptions?: string | null, answer?: string | null, askEachAthlete?: boolean | null }> | null, category?: { __typename?: 'TournamentCategory', isDisplayClub?: boolean | null, isDisplayCity?: boolean | null, timeControl?: string | null, name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null } | null }> | null, draws?: Array<{ __typename?: 'Draw', id: number }> | null, groups?: Array<{ __typename?: 'Group', id: number }> | null, liveStandings?: Array<{ __typename?: 'LiveStanding', id: number }> | null, facts?: Array<{ __typename?: 'TournamentFactSheet', id: number, answer?: string | null, factSheet?: { __typename?: 'FactSheet', id: number, fieldTitle?: string | null, fieldType?: string | null, options?: string | null } | null }> | null } };

export type UserTournamentMatchesQueryVariables = Exact<{
  user: Scalars['Int']['input'];
  filter?: InputMaybe<ListGroupMatchInput>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserTournamentMatchesQuery = { __typename?: 'Query', userTournamentMatches: any };

export type UserQueryVariables = Exact<{
  query: FindUserInput;
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, nation?: string | null, citizenship?: string | null, email?: string | null, fideId?: string | null, avatar?: string | null } };

export type GetUserByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user: { __typename?: 'User', email?: string | null, id?: number | null, name?: string | null, surname?: string | null, role?: string | null, gender?: string | null, dob?: string | null, nation?: string | null, avatar?: string | null, phone?: string | null, street?: string | null, city?: string | null, facebook?: string | null, instagram?: string | null, website?: string | null, gtw_points?: number | null, preferred_language?: string | null, coach_access?: boolean | null, club_access?: boolean | null, parent_access?: boolean | null, createdAt: any, linkedIn?: string | null, youtube?: string | null, tiktok?: string | null, citizenship?: string | null, user_address?: string | null, fideId?: string | null, ltsU10Id?: string | null, duprId?: string | null, pdlId?: string | null, ipinId?: string | null, teId?: string | null, atpId?: string | null, wtaId?: string | null, additionalUserRole?: string | null, friends?: Array<{ __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, email?: string | null, nation?: string | null, citizenship?: string | null }> | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null, user_parents?: Array<{ __typename?: 'UserParent', id: number, parent?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null } | null }> | null, user_club_id?: { __typename?: 'Club', id: number, clubName?: string | null } | null, plans?: Array<{ __typename?: 'UserPlan', id: number, plan?: string | null }> | null, stripe_payments?: Array<{ __typename?: 'StripePayments', productId?: string | null, status?: string | null }> | null } };

export type ClubMembersQueryVariables = Exact<{
  filter?: InputMaybe<ListClubMembers>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClubMembersQuery = { __typename?: 'Query', clubMembers: { __typename?: 'ClubMemberResult', total: number, clubMembers: Array<{ __typename?: 'ClubMember', id: number, status: string, createdAt: any, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, nation?: string | null, avatar?: string | null } | null, club?: { __typename?: 'Club', clubName?: string | null, id: number, clubMainAdministrator?: { __typename?: 'User', id?: number | null } | null } | null }> } };

export type TournamentTeamMembersWithCountQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startCreatedAt?: InputMaybe<Scalars['String']['input']>;
  endCreatedAt?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  statusArray?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TournamentTeamMembersWithCountQuery = { __typename?: 'Query', tournamentTeamMembersWithCount: { __typename?: 'TournamentTeamMembersResult', total: number, tournamentTeamMembers: Array<{ __typename?: 'TournamentTeamMember', id: number, status?: string | null, isDelete?: boolean | null, createdAt: any, registrationRequest?: { __typename?: 'TournamentRegistration', payForMyself?: boolean | null, id: number, status?: string | null, type?: string | null, additionalFee?: number | null, createdAt: any, paymentStatus: PaymentStatus, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null } | null }> | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, withdrawlDeadline?: any | null, entryDeadline?: any | null, logo?: string | null, coverPhoto?: string | null, startDate?: any | null, country?: string | null, additionalQuestion?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null }> | null } | null, categoryId?: { __typename?: 'CategorySetting', id: number, onsiteFee?: number | null, currency?: string | null, fee?: number | null, onlinePayments?: string | null, category?: { __typename?: 'TournamentCategory', id?: number | null, name: string, type: string } | null } | null }> } };

export type ValidLicensesForUsersQueryVariables = Exact<{
  filter?: InputMaybe<ListLicenseInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ValidLicensesForUsersQuery = { __typename?: 'Query', validLicensesForUsers: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, cantBuy?: boolean | null, errorMessage?: string | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, fieldType?: string | null, fieldOptions?: string | null, askEachAthlete?: boolean | null }> | null }> };

export type GroupsAndDrawsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupsAndDrawsQuery = { __typename?: 'Query', groupsAndDraws: any };

export type GetUserPartnersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
}>;


export type GetUserPartnersQuery = { __typename?: 'Query', getUserPartners: any };

export type GetUserPlanQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserPlanQuery = { __typename?: 'Query', fetchUserPlan: any };

export type UserTournamentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserTournamentsQuery = { __typename?: 'Query', userTournaments: Array<{ __typename?: 'Tournament', id: number, title?: string | null, tour?: string | null, address?: string | null, startDate?: any | null, endDate?: any | null, entryDeadline?: any | null, createdAt: any, country?: string | null, city?: string | null, coverPhoto?: string | null, paymentMethod?: string | null, closeRegistration?: boolean | null, logo?: string | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, enableLicense?: boolean | null, abbreviation?: string | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', id: number, status?: string | null, fee?: number | null, category?: { __typename?: 'TournamentCategory', name: string } | null }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', name?: string | null, id?: number | null, surname?: string | null, avatar?: string | null } | null } | null, referee?: { __typename?: 'TournamentReferee', referee?: { __typename?: 'User', name?: string | null } | null } | null, registrationRequests?: Array<{ __typename?: 'TournamentRegistration', id: number }> | null }> };

export type ValidTeamMembersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTeamInput>;
}>;


export type ValidTeamMembersQuery = { __typename?: 'Query', validTeamMembers: Array<any> };

export type OrganizationPlatformByFieldsQueryVariables = Exact<{
  platformId: Scalars['Int']['input'];
}>;


export type OrganizationPlatformByFieldsQuery = { __typename?: 'Query', organizationPlatformByFields: { __typename?: 'OrganizationSubscription', platform?: { __typename?: 'Platform', id: number, title?: string | null } | null } };

export type LeagueCategoriesQueryVariables = Exact<{
  filter: ListLeagueCategoryInput;
}>;


export type LeagueCategoriesQuery = { __typename?: 'Query', leagueCategories: Array<{ __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isDisplayClub?: boolean | null, isDisplayCity?: boolean | null, isDisplayBirthYear?: boolean | null, tournaments?: Array<{ __typename?: 'CategoryTournament', id: number }> | null, tournamentCatgories?: Array<{ __typename?: 'RankingTournamentCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, discipline?: { __typename?: 'Discipline', id: number } | null } | null, rankingCategory?: { __typename?: 'Category', name?: string | null } | null }> | null } | null }> };

export type LeagueLatestWinnersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
}>;


export type LeagueLatestWinnersQuery = { __typename?: 'Query', leagueLatestWinners: Array<{ __typename?: 'TournamentRankingsEntry', id: number, createdAt: any, updatedAt: any, points?: number | null, place?: string | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', id?: number | null, name: string } | null } | null, league?: { __typename?: 'League', id: number } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, startDate?: any | null, endDate?: any | null } | null, entry?: { __typename?: 'TournamentRegistration', id: number, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, rank?: number | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null, citizenship?: string | null } | null }> | null } | null }> };

export type LeagueRankingsQueryVariables = Exact<{
  filter: ListLeagueRankingInput;
  country?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeagueRankingsQuery = { __typename?: 'Query', leagueRankings: Array<{ __typename?: 'LeagueRanking', createdAt: any, date?: string | null, id: number, points?: number | null, place?: number | null, tournaments?: number | null, thirdPartyPoints?: string | null, rankingCategory?: { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null } | null } | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, country?: string | null, nation?: string | null, avatar?: string | null, dob?: string | null } | null }> };

export type LeagueRankingsCustomQueryVariables = Exact<{
  filter: ListLeagueRankingInput;
  country?: InputMaybe<Scalars['String']['input']>;
  isPage1?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeagueRankingsCustomQuery = { __typename?: 'Query', leagueRankingsCustom: { __typename?: 'LeagueRankingResult', total: number, top3: Array<{ __typename?: 'LeagueRanking', id: number, createdAt: any, date?: string | null, points?: number | null, place?: number | null, tournaments?: number | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, country?: string | null, nation?: string | null, avatar?: string | null, dob?: string | null, user_club_id?: { __typename?: 'Club', clubName?: string | null, city?: string | null } | null } | null }>, rankings: Array<{ __typename?: 'LeagueRanking', id: number, createdAt: any, date?: string | null, points?: number | null, place?: number | null, tournaments?: number | null, thirdPartyPoints?: string | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, country?: string | null, nation?: string | null, avatar?: string | null, dob?: string | null, user_club_id?: { __typename?: 'Club', clubName?: string | null, city?: string | null } | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', category?: { __typename?: 'Category', isDisplayClub?: boolean | null } | null } | null }> } };

export type SearchLeaguesByTitleQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchLeaguesByTitleQuery = { __typename?: 'Query', searchLeaguesByTitle: Array<{ __typename?: 'League', title?: string | null, enableLicense?: boolean | null, id: number, type?: string | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number } | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null, athlete?: Array<{ __typename?: 'Athlete', id: number }> | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', id: number, user?: { __typename?: 'User', id?: number | null } | null } | null } | null }> };

export type LeaguePageLeagueRankingQueryVariables = Exact<{
  leagueId: Scalars['Int']['input'];
}>;


export type LeaguePageLeagueRankingQuery = { __typename?: 'Query', leaguePageLeagueRanking: Array<{ __typename?: 'LeagueRanking', id: number, place?: number | null, points?: number | null, tournaments?: number | null, user?: { __typename?: 'User', name?: string | null, avatar?: string | null, id?: number | null } | null, league?: { __typename?: 'League', title?: string | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', category?: { __typename?: 'Category', id: number, name?: string | null } | null } | null }> };

export type LeagueGeneralTournamentsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeagueGeneralTournamentsQuery = { __typename?: 'Query', leagueGeneralTournaments: Array<{ __typename?: 'Tournament', id: number, title?: string | null, tour?: string | null, address?: string | null, startDate?: any | null, endDate?: any | null, entryDeadline?: any | null, createdAt: any, country?: string | null, city?: string | null, logo?: string | null, coverPhoto?: string | null, closeRegistration?: boolean | null, paymentMethod?: string | null, status?: string | null, isFeatured?: boolean | null, registerLink?: string | null, registrationStartDate?: any | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, logo?: string | null, title?: string | null, enableLicense?: boolean | null, abbreviation?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationType?: string | null, organizationAbbreviation?: string | null, logo?: string | null } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', isRegistered?: boolean | null, status?: string | null, id: number, fee?: number | null, currency?: string | null, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null, license?: Array<{ __typename?: 'TournamentCategoryLicense', id: number, license?: { __typename?: 'License', id: number, title?: string | null } | null }> | null } | null }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', name?: string | null, id?: number | null, surname?: string | null, avatar?: string | null } | null } | null, referee?: { __typename?: 'TournamentReferee', referee?: { __typename?: 'User', name?: string | null } | null } | null, registrationRequests?: Array<{ __typename?: 'TournamentRegistration', id: number }> | null }> };

export type LeaguesQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeaguesQuery = { __typename?: 'Query', leagues: Array<{ __typename?: 'League', title?: string | null, enableLicense?: boolean | null, id: number, type?: string | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null } | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null, athlete?: Array<{ __typename?: 'Athlete', id: number }> | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', id: number, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null } | null } | null } | null }> };

export type LeagueForRankingsQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeagueForRankingsQuery = { __typename?: 'Query', leagueForRankings: Array<{ __typename?: 'League', title?: string | null, abbreviation?: string | null, id: number, logo?: string | null }> };

export type SearchLeaguesQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchLeaguesQuery = { __typename?: 'Query', searchLeagues: Array<any> };

export type AllLeaguesWithCountQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  federationId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type AllLeaguesWithCountQuery = { __typename?: 'Query', allLeaguesWithCount: any };

export type LeagueRankingQueryVariables = Exact<{
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeagueRankingQuery = { __typename?: 'Query', leagueRankings: Array<{ __typename?: 'LeagueRanking', league?: { __typename?: 'League', title?: string | null, abbreviation?: string | null, id: number } | null }> };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', getProfile: { __typename?: 'User', email?: string | null, name?: string | null, surname?: string | null, role?: string | null, accessToken?: string | null, gender?: string | null, dob?: string | null, id?: number | null, nation?: string | null, player?: string | null, avatar?: string | null, phone?: string | null, street?: string | null, city?: string | null, facebook?: string | null, instagram?: string | null, website?: string | null, gtw_points?: number | null, preferred_language?: string | null, coach_access?: boolean | null, club_access?: boolean | null, parent_access?: boolean | null, about?: string | null, createdAt: any, user_address?: string | null, linkedIn?: string | null, youtube?: string | null, tiktok?: string | null, citizenship?: string | null, ipinId?: string | null, fideId?: string | null, ltsU10Id?: string | null, duprId?: string | null, wprUserId?: string | null, pdlId?: string | null, teId?: string | null, atpId?: string | null, wtaId?: string | null, additionalUserRole?: string | null, friends?: Array<{ __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, avatar?: string | null, email?: string | null }> | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null } | null }> | null, user_parents?: Array<{ __typename?: 'UserParent', id: number, parent?: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null } | null }> | null, user_club_id?: { __typename?: 'Club', id: number, clubName?: string | null } | null, user_coach?: Array<{ __typename?: 'UserCoach', id: number, user?: { __typename?: 'User', id?: number | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null } | null }> | null }> | null, plans?: Array<{ __typename?: 'UserPlan', id: number, plan?: string | null }> | null, stripe_payments?: Array<{ __typename?: 'StripePayments', productId?: string | null, status?: string | null }> | null } };

export type TournamentMatchesDatesQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupMatchInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TournamentMatchesDatesQuery = { __typename?: 'Query', tournamentMatchesDates: Array<any> };

export type PairingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<ListPairingInput>;
}>;


export type PairingQuery = { __typename?: 'Query', pairing: any };

export type PairingResultsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  filter?: InputMaybe<ListPairingInput>;
}>;


export type PairingResultsQuery = { __typename?: 'Query', pairingResults: any };

export type PairingsQueryVariables = Exact<{
  filter?: InputMaybe<ListPairingInput>;
}>;


export type PairingsQuery = { __typename?: 'Query', pairings: Array<{ __typename?: 'Pairing', id: number, title?: string | null, isCompleted?: boolean | null, hide?: boolean | null, hideStandings?: boolean | null }> };

export type PartnerSearchesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
}>;


export type PartnerSearchesQuery = { __typename?: 'Query', partnerSearches: { __typename?: 'PartnerSearchsResult', total: number, uniqueTotal: number, partnerSearches: Array<{ __typename?: 'PartnerSearch', id: number, status?: string | null, selfInformation?: string | null, rank?: number | null, partnerInformation?: string | null, categoryId?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', id?: number | null, name: string } | null } | null, partner?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, avatar?: string | null, citizenship?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, email?: string | null, avatar?: string | null, citizenship?: string | null } | null }> } };

export type UserPartnerSearchesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserPartnerSearchesQuery = { __typename?: 'Query', userPartnerSearches: Array<any> };

export type PdfGenerationForPairingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  tournamentCategory: Scalars['String']['input'];
  timeControl?: InputMaybe<Scalars['String']['input']>;
  pairingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PdfGenerationForPairingQuery = { __typename?: 'Query', pdfGenerationForPairing: string };

export type PlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformsQuery = { __typename?: 'Query', platforms: { __typename?: 'PlatformsResult', platforms: Array<{ __typename?: 'Platform', id: number, title?: string | null }> } };

export type GetRatingByDuprIdQueryVariables = Exact<{
  duprId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRatingByDuprIdQuery = { __typename?: 'Query', getRatingByDUPRId: any };

export type HomePageLeagueRankingQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomePageLeagueRankingQuery = { __typename?: 'Query', homePageLeagueRanking: Array<{ __typename?: 'LeagueRanking', id: number, place?: number | null, points?: number | null, createdAt: any, date?: string | null, tournaments?: number | null, thirdPartyPoints?: string | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, name?: string | null, surname?: string | null, country?: string | null, nation?: string | null, avatar?: string | null, dob?: string | null, user_club_id?: { __typename?: 'Club', clubName?: string | null, city?: string | null } | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', name?: string | null } | null } | null }> };

export type SearchFederationByTitleQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchFederationByTitleQuery = { __typename?: 'Query', searchFederationByTitle: Array<{ __typename?: 'Federation', id: number, organizationName?: string | null, logo?: string | null, user?: { __typename?: 'User', email?: string | null, nation?: string | null } | null, platforms?: Array<{ __typename?: 'OrganizationPlatform', platform?: { __typename?: 'Platform', sports?: Array<{ __typename?: 'PlateformSport', sport?: { __typename?: 'Sport', title?: string | null, icon?: string | null } | null }> | null } | null }> | null, leagues?: Array<{ __typename?: 'LeagueOwner', league?: { __typename?: 'League', id: number, title?: string | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null } | null }> | null }> };

export type SportFishingResultEntriesQueryVariables = Exact<{
  filter?: InputMaybe<ListSportFishingResultEntryInput>;
}>;


export type SportFishingResultEntriesQuery = { __typename?: 'Query', sportFishingResultEntries: Array<{ __typename?: 'SportFishingResultEntry', id: number, weight?: number | null, location?: string | null, points?: number | null, updatedAt: any, entry?: { __typename?: 'TournamentRegistration', id: number, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, users?: Array<{ __typename?: 'TournamentTeamMember', user?: { __typename?: 'User', name?: string | null, surname?: string | null, avatar?: string | null, nation?: string | null, email?: string | null } | null }> | null } | null }> };

export type SportFishingResultsQueryVariables = Exact<{
  filter?: InputMaybe<ListSportFishingResultInput>;
}>;


export type SportFishingResultsQuery = { __typename?: 'Query', sportFishingResults: Array<any> };

export type SportsWithTournamentCountQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SportsWithTournamentCountQuery = { __typename?: 'Query', sportsWithTournamentCount: Array<{ __typename?: 'SportWithTournamentCount', id: number, title: string, icon?: string | null, tournamentCount: number }> };

export type TeamDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TeamDetailsQuery = { __typename?: 'Query', teamDetails: any };

export type TournamentTopFivePlayersQueryVariables = Exact<{
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type TournamentTopFivePlayersQuery = { __typename?: 'Query', tournamentTopFivePlayers: Array<any> };

export type FindAllTournamentCategoryGroupQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentCategoryGroupInput>;
}>;


export type FindAllTournamentCategoryGroupQuery = { __typename?: 'Query', findAllTournamentCategoryGroup: Array<{ __typename?: 'TournamentCategoryGroup', id: number, name: string }> };

export type TournamentDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentDocumentInput>;
}>;


export type TournamentDocumentsQuery = { __typename?: 'Query', tournamentDocuments: Array<{ __typename?: 'TournamentDocument', id: number, name?: string | null, document?: string | null, section?: string | null }> };

export type TournamentGroupCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ListGroupInput>;
}>;


export type TournamentGroupCategoriesQuery = { __typename?: 'Query', tournamentGroupCategories: Array<any> };

export type SearchTournamentsByTitleQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SearchTournamentsByTitleQuery = { __typename?: 'Query', searchTournamentsByTitle: Array<{ __typename?: 'Tournament', id: number, tour?: string | null, title?: string | null, address?: string | null, startDate?: any | null, endDate?: any | null, country?: string | null, city?: string | null, coverPhoto?: string | null, logo?: string | null, withdrawlDeadline?: any | null, type?: string | null, status?: string | null, entryDeadline?: any | null, createdAt: any, closeRegistration?: boolean | null, paymentMethod?: string | null, additionalQuestion?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null }> | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', id: number, status?: string | null, fee?: number | null, isRegistered?: boolean | null, currency?: string | null, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null } | null }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', name?: string | null, id?: number | null, surname?: string | null, avatar?: string | null } | null } | null, referee?: { __typename?: 'TournamentReferee', referee?: { __typename?: 'User', name?: string | null } | null } | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, enableLicense?: boolean | null, abbreviation?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationType?: string | null, organizationAbbreviation?: string | null, logo?: string | null } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null } | null } | null, registrationRequests?: Array<{ __typename?: 'TournamentRegistration', id: number }> | null, additionalReferee?: Array<{ __typename?: 'TournamentAdditionalReferee', referee?: { __typename?: 'User', name?: string | null } | null }> | null }> };

export type AllTournamentsQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllTournamentsQuery = { __typename?: 'Query', alltournament: { __typename?: 'TournamentsResult', total: number, tournaments: Array<{ __typename?: 'Tournament', id: number, title?: string | null, tour?: string | null, address?: string | null, startDate?: any | null, endDate?: any | null, entryDeadline?: any | null, createdAt: any, country?: string | null, city?: string | null, logo?: string | null, coverPhoto?: string | null, closeRegistration?: boolean | null, paymentMethod?: string | null, status?: string | null, isFeatured?: boolean | null, timeZone?: string | null, registerLink?: string | null, registrationStartDate?: any | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, enableLicense?: boolean | null, abbreviation?: string | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationType?: string | null, organizationAbbreviation?: string | null, logo?: string | null } | null } | null, sports?: { __typename?: 'Sport', id: number, icon?: string | null, title?: string | null } | null } | null } | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', isRegistered?: boolean | null, status?: string | null, id: number, fee?: number | null, currency?: string | null, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, status?: string | null, id?: number | null, ageLimit?: number | null, ageType?: string | null, ageTo?: number | null, ageFrom?: number | null, skillsLevel?: string | null, ageGroup?: string | null } | null }> | null, organizer?: { __typename?: 'LeagueMember', organizationName?: string | null, organizationEmail?: string | null, isOrganization?: boolean | null, member?: { __typename?: 'User', name?: string | null, id?: number | null, surname?: string | null, avatar?: string | null } | null } | null, referee?: { __typename?: 'TournamentReferee', referee?: { __typename?: 'User', name?: string | null } | null } | null, registrationRequests?: Array<{ __typename?: 'TournamentRegistration', id: number }> | null }> } };

export type LeaguesSortedByActiveTournamentsQueryVariables = Exact<{
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeaguesSortedByActiveTournamentsQuery = { __typename?: 'Query', leaguesSortedByActiveTournaments: Array<{ __typename?: 'League', id: number, title?: string | null, logo?: string | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', logo?: string | null } | null } | null }> };

export type UserAllTournamentsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserAllTournamentsQuery = { __typename?: 'Query', userAllTournaments: any };

export type UserLeaguePointsQueryVariables = Exact<{
  filter: ListTournamentRankingsEntryInput;
  rankingId: Scalars['Int']['input'];
}>;


export type UserLeaguePointsQuery = { __typename?: 'Query', userLeaguePoints: Array<any> };

export type UserAllLeaguesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
}>;


export type UserAllLeaguesQuery = { __typename?: 'Query', userAllLeagues: { __typename?: 'LeagueResult', total: number, league: Array<{ __typename?: 'League', title?: string | null, id: number, type?: string | null, status?: string | null, logo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null } | null, leagueCategory?: Array<{ __typename?: 'LeagueCategory', id: number }> | null, tournaments?: Array<{ __typename?: 'LeagueTournament', id: number }> | null, owner?: { __typename?: 'LeagueOwner', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, logo?: string | null } | null } | null }> } };

export type UserPartnerSearchCategoriesQueryVariables = Exact<{
  email: Scalars['String']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
}>;


export type UserPartnerSearchCategoriesQuery = { __typename?: 'Query', userPartnerSearchCategories: Array<any> };

export type UserProfileQueryVariables = Exact<{
  user?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserProfileQuery = { __typename?: 'Query', userProfile: any };

export type UserTournamentCategoriesQueryVariables = Exact<{
  email: Scalars['String']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
}>;


export type UserTournamentCategoriesQuery = { __typename?: 'Query', userTournamentCategories: Array<any> };


export const CreateTournamentRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTournamentRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsAndConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalFee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerSearchId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bothPaymentMethod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTournamentRegistration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerSearchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerSearchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}}},{"kind":"Argument","name":{"kind":"Name","value":"bothPaymentMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bothPaymentMethod"}}},{"kind":"Argument","name":{"kind":"Name","value":"createTournamentRegistrationInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"termsAndConditions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsAndConditions"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalFee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalQuestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFee"}}]}}]}}]} as unknown as DocumentNode<CreateTournamentRegistrationMutation, CreateTournamentRegistrationMutationVariables>;
export const CreateTournamentRegistrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTournamentRegistrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerSearchId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createTournamentRegistrationInputs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTournamentRegistrationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTournamentRegistrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerSearchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerSearchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createTournamentRegistrationInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createTournamentRegistrationInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFee"}}]}}]}}]} as unknown as DocumentNode<CreateTournamentRegistrationsMutation, CreateTournamentRegistrationsMutationVariables>;
export const CreateClubMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createClubMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createClubMemberInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateClubMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClubMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createClubMemberInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createClubMemberInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateClubMemberMutation, CreateClubMemberMutationVariables>;
export const AddFriendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addFriend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"friendId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFriend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"friendId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"friendId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"friends"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AddFriendMutation, AddFriendMutationVariables>;
export const CreateTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"member"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createTeamMemberInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"member"},"value":{"kind":"Variable","name":{"kind":"Name","value":"member"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const CreateLicensePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLicensePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagueTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenseTitle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchasedLicenseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alreayExist"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yearsToAdd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLicensePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createLicensePaymentInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leagueTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagueTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"licenseTitle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenseTitle"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"successUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"purchasedLicenseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchasedLicenseId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"leagueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"yearsToAdd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yearsToAdd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alreayExist"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alreayExist"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"licenseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenseId"}}}]}}]}]}}]} as unknown as DocumentNode<CreateLicensePaymentMutation, CreateLicensePaymentMutationVariables>;
export const CreateFederationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFederation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"federationEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationAbbreviation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"about"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournatedPlatformId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFederation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createFederationInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"federationEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"federationEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationAbbreviation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationAbbreviation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"about"},"value":{"kind":"Variable","name":{"kind":"Name","value":"about"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"website"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"instagram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournatedPlatformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournatedPlatformId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<CreateFederationMutation, CreateFederationMutationVariables>;
export const CreatePartnerRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPartnerRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selfInformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerInformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rank"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"acceptUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"declineUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPartnerRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createPartnerSearchInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"selfInformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selfInformation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnerInformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerInformation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rank"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partner"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"acceptUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"acceptUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"declineUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"declineUrl"}}}]}}]}]}}]} as unknown as DocumentNode<CreatePartnerRequestMutation, CreatePartnerRequestMutationVariables>;
export const CreatePartnerSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPartnerSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selfInformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerInformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rank"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPartnerSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPartnerSearchInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"selfInformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selfInformation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partnerInformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerInformation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rank"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePartnerSearchMutation, CreatePartnerSearchMutationVariables>;
export const CreatePlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlatform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationAbbreviation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alreadyDomain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"needLanding"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"needIntegration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePayment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenseMemberships"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePayments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingCourts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liveStreaming"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liveScoring"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceProvider"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primaryColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secondaryColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"darkLogo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lightLogo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverPhoto"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yourRequest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadFile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signeeFullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signeeRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlatform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPlatformInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"platformType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"alreadyDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alreadyDomain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"primaryColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primaryColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"secondaryColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secondaryColor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uploadFile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadFile"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"yourRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yourRequest"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"coverPhoto"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverPhoto"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lightLogo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lightLogo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"darkLogo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"darkLogo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"serviceProvider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceProvider"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"liveScoring"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liveScoring"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"liveStreaming"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liveStreaming"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlineBookingCourts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlineBookingCourts"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePayments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePayments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"licenseMemberships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenseMemberships"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePayment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePayment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"needIntegration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"needIntegration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"needLanding"},"value":{"kind":"Variable","name":{"kind":"Name","value":"needLanding"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fullAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"registrationNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"companyName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signeeFullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signeeFullName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signeeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signeeRole"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"createFederationInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationAbbreviation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationAbbreviation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contactPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactPhone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"website"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organizationType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"instagram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreatePlatformMutation, CreatePlatformMutationVariables>;
export const CreatePlateformSportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPlateformSport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlateformSport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPlateformSportInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePlateformSportMutation, CreatePlateformSportMutationVariables>;
export const CreateSportFishingEntriesMatricDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSportFishingEntriesMatric"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingResult"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"points"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingResultEntry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingMatric"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"media"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSportFishingEntriesMatric"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createSportFishingEntriesMatricInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sportFishingResult"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingResult"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"points"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sportFishingResultEntry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingResultEntry"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sportFishingMatric"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sportFishingMatric"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"media"},"value":{"kind":"Variable","name":{"kind":"Name","value":"media"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"media"}}]}}]}}]} as unknown as DocumentNode<CreateSportFishingEntriesMatricMutation, CreateSportFishingEntriesMatricMutationVariables>;
export const CreateStripeSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createStripeSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createStripeSessionInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"successUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}]}}]}]}}]} as unknown as DocumentNode<CreateStripeSessionMutation, CreateStripeSessionMutationVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"club"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discipline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createTeamInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"club"},"value":{"kind":"Variable","name":{"kind":"Name","value":"club"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"discipline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discipline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateTeamRegDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTeamReg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamRegistrationRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createTournamentRegistrationInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreateTeamRegMutation, CreateTeamRegMutationVariables>;
export const CreateTournamentRegistrationPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTournamentRegistrationPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryFee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformProcessingFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"registrationRequestIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"VATFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalTournatedServiceFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"totalPartnerServiceFee"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTournamentRegistrationPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createRegistrationPaymentInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"successUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"successUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"entryFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryFee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"platformProcessingFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformProcessingFee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"registrationRequestIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"registrationRequestIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournamentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tournamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"VATFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"VATFee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"totalTournatedServiceFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalTournatedServiceFee"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"totalPartnerServiceFee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"totalPartnerServiceFee"}}}]}}]}]}}]} as unknown as DocumentNode<CreateTournamentRegistrationPaymentMutation, CreateTournamentRegistrationPaymentMutationVariables>;
export const CreateUserCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coaches"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserCoachInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"coaches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coaches"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserCoachMutation, CreateUserCoachMutationVariables>;
export const CreateUserParentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserParent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserParent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserParentInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserParentMutation, CreateUserParentMutationVariables>;
export const CreateUserPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserPlanInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserPlanMutation, CreateUserPlanMutationVariables>;
export const CreateUserSportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserSport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserSport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createUserSportInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserSportMutation, CreateUserSportMutationVariables>;
export const UpdatePartnerSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePartnerSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partner"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePartnerSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updatePartnerSearchInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"partner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partner"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePartnerSearchMutation, UpdatePartnerSearchMutationVariables>;
export const RemovePlateformSportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removePlateformSport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePlateformSport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RemovePlateformSportMutation, RemovePlateformSportMutationVariables>;
export const RemoveTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const RemoveUserSportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUserSport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserSport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserSportMutation, RemoveUserSportMutationVariables>;
export const ForgetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}}}]}]}}]} as unknown as DocumentNode<ForgetPasswordMutation, ForgetPasswordMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rememberMe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"rememberMe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rememberMe"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user_sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"gtw_points"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach_access"}},{"kind":"Field","name":{"kind":"Name","value":"club_access"}},{"kind":"Field","name":{"kind":"Name","value":"parent_access"}},{"kind":"Field","name":{"kind":"Name","value":"user_parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"ipinId"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"ltsU10Id"}},{"kind":"Field","name":{"kind":"Name","value":"duprId"}},{"kind":"Field","name":{"kind":"Name","value":"pdlId"}},{"kind":"Field","name":{"kind":"Name","value":"teId"}},{"kind":"Field","name":{"kind":"Name","value":"atpId"}},{"kind":"Field","name":{"kind":"Name","value":"wtaId"}},{"kind":"Field","name":{"kind":"Name","value":"additionalUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const CreateUserLicenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserLicense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"license"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LicensePaymentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"basePrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPurchasedLicense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPurchasedLicenseInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"license"},"value":{"kind":"Variable","name":{"kind":"Name","value":"license"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payment_status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalQuestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"basePrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"basePrice"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promo"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateUserLicenseMutation, CreateUserLicenseMutationVariables>;
export const SignUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"signUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dob"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"national_fisher_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"has_fisher_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"no_fisher_id_doc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"no_fisher_id_reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ipinId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"atpId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wtaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ltsU10Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalUserRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clubRequests"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wprPermissionCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"redirectURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectURL"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createUserInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_sports"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dob"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dob"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"national_fisher_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"national_fisher_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_fisher_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"has_fisher_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"no_fisher_id_doc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"no_fisher_id_doc"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"no_fisher_id_reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"no_fisher_id_reason"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"citizenship"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ipinId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ipinId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duprId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"atpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"atpId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wtaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wtaId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ltsU10Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ltsU10Id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pdlId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdlId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalUserRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalUserRole"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"clubRequests"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clubRequests"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wprPermissionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wprPermissionCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"gtw_points"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"ltsU10Id"}},{"kind":"Field","name":{"kind":"Name","value":"duprId"}},{"kind":"Field","name":{"kind":"Name","value":"ipinId"}},{"kind":"Field","name":{"kind":"Name","value":"teId"}},{"kind":"Field","name":{"kind":"Name","value":"atpId"}},{"kind":"Field","name":{"kind":"Name","value":"wtaId"}},{"kind":"Field","name":{"kind":"Name","value":"pdlId"}},{"kind":"Field","name":{"kind":"Name","value":"additionalUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"wprUserId"}},{"kind":"Field","name":{"kind":"Name","value":"user_sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignUpMutation, SignUpMutationVariables>;
export const RemoveClubMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeClubMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeClubMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveClubMemberMutation, RemoveClubMemberMutationVariables>;
export const RemoveFriendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeFriend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"friendId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFriend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"friendId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"friendId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"friends"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveFriendMutation, RemoveFriendMutationVariables>;
export const RemovePartnerSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removePartnerSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePartnerSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemovePartnerSearchMutation, RemovePartnerSearchMutationVariables>;
export const RemoveUserCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUserCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserCoachMutation, RemoveUserCoachMutationVariables>;
export const RemoveUserParentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeUserParent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserParent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserParentMutation, RemoveUserParentMutationVariables>;
export const RenewUserLicenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"renewUserLicense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"license"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment_status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LicensePaymentStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSONObject"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"basePrice"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renewUserLicense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createPurchasedLicenseInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"license"},"value":{"kind":"Variable","name":{"kind":"Name","value":"license"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"payment_status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment_status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalQuestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalQuestion"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"basePrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"basePrice"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promo"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RenewUserLicenseMutation, RenewUserLicenseMutationVariables>;
export const UpdateUserpasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUserpassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserpassword"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateUserpasswordMutation, UpdateUserpasswordMutationVariables>;
export const UpdateClubMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateClubMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateClubMemberInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClubMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClubMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateClubMemberInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateClubMemberInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateClubMemberMutation, UpdateClubMemberMutationVariables>;
export const UpdateTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeamMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateTeamMemberInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;
export const UpdateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"club"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"discipline"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateTeamInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"club"},"value":{"kind":"Variable","name":{"kind":"Name","value":"club"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"discipline"},"value":{"kind":"Variable","name":{"kind":"Name","value":"discipline"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dob"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gtw_points"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferred_language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"avatar"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"about"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tiktok"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"youtube"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkedIn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ipinId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"atpId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wtaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ltsU10Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_club_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coach_access"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"club_access"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent_access"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdlId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additionalUserRole"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wprUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wprPermissionCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"surname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dob"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dob"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"nation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"facebook"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facebook"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"instagram"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"website"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"gtw_points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gtw_points"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preferred_language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferred_language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"avatar"},"value":{"kind":"Variable","name":{"kind":"Name","value":"avatar"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"about"},"value":{"kind":"Variable","name":{"kind":"Name","value":"about"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"citizenship"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tiktok"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tiktok"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"youtube"},"value":{"kind":"Variable","name":{"kind":"Name","value":"youtube"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"linkedIn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkedIn"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ipinId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ipinId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duprId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"teId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"atpId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"atpId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wtaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wtaId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ltsU10Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ltsU10Id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_club_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_club_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"coach_access"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coach_access"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"club_access"},"value":{"kind":"Variable","name":{"kind":"Name","value":"club_access"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parent_access"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent_access"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_sports"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pdlId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdlId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"additionalUserRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additionalUserRole"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wprUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wprUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wprPermissionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wprPermissionCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user_sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"gtw_points"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach_access"}},{"kind":"Field","name":{"kind":"Name","value":"club_access"}},{"kind":"Field","name":{"kind":"Name","value":"parent_access"}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"ipinId"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"teId"}},{"kind":"Field","name":{"kind":"Name","value":"atpId"}},{"kind":"Field","name":{"kind":"Name","value":"wtaId"}},{"kind":"Field","name":{"kind":"Name","value":"ltsU10Id"}},{"kind":"Field","name":{"kind":"Name","value":"duprId"}},{"kind":"Field","name":{"kind":"Name","value":"wprUserId"}},{"kind":"Field","name":{"kind":"Name","value":"pdlId"}},{"kind":"Field","name":{"kind":"Name","value":"additionalUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const CheckUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"checkUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primaryEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkValidations2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primaryEmail"}}}]}]}}]} as unknown as DocumentNode<CheckUserMutation, CheckUserMutationVariables>;
export const CheckValidationsToBeDepriciatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"checkValidationsToBeDepriciated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primaryEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkValidationsToBeDepriciated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primaryEmail"}}}]}]}}]} as unknown as DocumentNode<CheckValidationsToBeDepriciatedMutation, CheckValidationsToBeDepriciatedMutationVariables>;
export const WithdrawDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"withdraw"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withdrawReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"withdrawRegistrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateTournamentRegistrationInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"withdrawReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withdrawReason"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<WithdrawMutation, WithdrawMutationVariables>;
export const CsvGenerationForPickleballOopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CsvGenerationForPickleballOOP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CsvGenerationForPickleballOOP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}]}}]} as unknown as DocumentNode<CsvGenerationForPickleballOopQuery, CsvGenerationForPickleballOopQueryVariables>;
export const AlbumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"album"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"album"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"isSpecificTournament"}},{"kind":"Field","name":{"kind":"Name","value":"albumCustomEvent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"albumTags"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photoLink"}},{"kind":"Field","name":{"kind":"Name","value":"photoCaption"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<AlbumQuery, AlbumQueryVariables>;
export const GetGroupsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"identifyTeamMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayPlayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"displayMatches"}},{"kind":"Field","name":{"kind":"Name","value":"participantsAddScore"}},{"kind":"Field","name":{"kind":"Name","value":"hide"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetGroupsDataQuery, GetGroupsDataQueryVariables>;
export const AllGroupsStandingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allGroupsStandings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allGroupsStandings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"queryName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryName"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"identifyTeamMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayPlayOrder"}},{"kind":"Field","name":{"kind":"Name","value":"displayMatches"}},{"kind":"Field","name":{"kind":"Name","value":"participantsAddScore"}},{"kind":"Field","name":{"kind":"Name","value":"hide"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AllGroupsStandingsQuery, AllGroupsStandingsQueryVariables>;
export const AllGroupMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allGroupMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allGroupMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"score"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"roundFormat"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"court"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"round"}},{"kind":"Field","name":{"kind":"Name","value":"winner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"winnerPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"matchStatus"}},{"kind":"Field","name":{"kind":"Name","value":"scoreType"}},{"kind":"Field","name":{"kind":"Name","value":"entry1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entry1partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entry2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entry2partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllGroupMatchesQuery, AllGroupMatchesQueryVariables>;
export const AllNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allNews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListNewsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"news"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"postText"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"federationNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"news"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AllNewsQuery, AllNewsQueryVariables>;
export const AllTournamentCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allTournamentCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCategorySettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTournamentCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<AllTournamentCategoriesQuery, AllTournamentCategoriesQueryVariables>;
export const TournamentCategoriesWithPartnersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentCategoriesWithPartnersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCategorySettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentCategoriesWithPartnersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<TournamentCategoriesWithPartnersCountQuery, TournamentCategoriesWithPartnersCountQueryVariables>;
export const AllTournamentsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allTournamentsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skills"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inProgress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLast7or30Days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allTournamentsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"federationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skills"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skills"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"inProgress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inProgress"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"isLast7or30Days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLast7or30Days"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryGroup"}}}]}]}}]} as unknown as DocumentNode<AllTournamentsListQuery, AllTournamentsListQueryVariables>;
export const CalculateLeaguePointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateLeaguePoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRankingsEntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateLeaguePoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<CalculateLeaguePointsQuery, CalculateLeaguePointsQueryVariables>;
export const CalculateGroupScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateGroupScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateGroupScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<CalculateGroupScoreQuery, CalculateGroupScoreQueryVariables>;
export const CalculateTeamTotaltResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateTeamTotaltResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSportFishingResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateTeamTotaltResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<CalculateTeamTotaltResultQuery, CalculateTeamTotaltResultQueryVariables>;
export const CalculateTotaltFishingResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculateTotaltFishingResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSportFishingResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateTotaltFishingResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<CalculateTotaltFishingResultQuery, CalculateTotaltFishingResultQueryVariables>;
export const MyCareerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myCareer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCareer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<MyCareerQuery, MyCareerQueryVariables>;
export const CheckUserAsParentOrCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckUserAsParentOrCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkUserAsParentOrCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<CheckUserAsParentOrCoachQuery, CheckUserAsParentOrCoachQueryVariables>;
export const CheckUserRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkUserRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkUserRole"}}]}}]} as unknown as DocumentNode<CheckUserRoleQuery, CheckUserRoleQueryVariables>;
export const ClubDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"club"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListClubInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"club"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"howToFindUs"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"instagramLink"}},{"kind":"Field","name":{"kind":"Name","value":"facebookLink"}},{"kind":"Field","name":{"kind":"Name","value":"twitterLink"}},{"kind":"Field","name":{"kind":"Name","value":"tikTok"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"clubMainAdministrator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"approvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"platform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ClubQuery, ClubQueryVariables>;
export const ClubDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clubDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ClubDetailsQuery, ClubDetailsQueryVariables>;
export const ClubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CLUBS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListClubInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<ClubsQuery, ClubsQueryVariables>;
export const PlatformCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"platformCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]} as unknown as DocumentNode<PlatformCoachQuery, PlatformCoachQueryVariables>;
export const PdfGenerationForPickleballDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdfGenerationForPickleball"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PdfGenerationForPickleball"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}},{"kind":"Argument","name":{"kind":"Name","value":"isManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isManager"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationForPickleballQuery, PdfGenerationForPickleballQueryVariables>;
export const CsvGenerationForPickleballGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CsvGenerationForPickleballGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isManager"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CsvGenerationForPickleballGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}},{"kind":"Argument","name":{"kind":"Name","value":"isManager"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isManager"}}}]}]}}]} as unknown as DocumentNode<CsvGenerationForPickleballGroupsQuery, CsvGenerationForPickleballGroupsQueryVariables>;
export const PdfGenerationForDrawDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdfGenerationForDraw"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PdfGenerationForDraw"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationForDrawQuery, PdfGenerationForDrawQueryVariables>;
export const PdfGenerationForGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdfGenerationForGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdfFormat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PdfGenerationForGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"segment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment"}}},{"kind":"Argument","name":{"kind":"Name","value":"pdfFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdfFormat"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationForGroupQuery, PdfGenerationForGroupQueryVariables>;
export const PdfGenerationForGridDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdfGenerationForGrid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PdfGenerationForGrid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationForGridQuery, PdfGenerationForGridQueryVariables>;
export const PdfGenerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PdfGeneration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PdfGeneration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationQuery, PdfGenerationQueryVariables>;
export const FeaturedLeaguesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featuredLeagues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredLeagues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}]}]}}]} as unknown as DocumentNode<FeaturedLeaguesQuery, FeaturedLeaguesQueryVariables>;
export const FeaturedTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"featuredTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredTournaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"poster"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FeaturedTournamentsQuery, FeaturedTournamentsQueryVariables>;
export const SearchCoachByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchCoachByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCoachByEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchCoachByEmailQuery, SearchCoachByEmailQueryVariables>;
export const FindTournamentsByDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findTournamentsByDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findTournamentsByDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<FindTournamentsByDateQuery, FindTournamentsByDateQueryVariables>;
export const AllAthletesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allAthletes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListUsersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}}]}}]}}]} as unknown as DocumentNode<AllAthletesQuery, AllAthletesQueryVariables>;
export const DisciplinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"disciplines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListDisciplineInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disciplines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enableDiscipline"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"resultType"}}]}}]}}]} as unknown as DocumentNode<DisciplinesQuery, DisciplinesQueryVariables>;
export const FederationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"federations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListFederationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"platforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leagues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<FederationsQuery, FederationsQueryVariables>;
export const AllLeagueNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allLeagueNews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueNewsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLeagueNews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"news"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"postText"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllLeagueNewsQuery, AllLeagueNewsQueryVariables>;
export const UserLicensesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userLicenses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPurchasedLicensesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchasedLicenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"paid"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"activePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"licenseStatus"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leagues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserLicensesQuery, UserLicensesQueryVariables>;
export const SportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSportInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"enableDiscipline"}},{"kind":"Field","name":{"kind":"Name","value":"enableCourts"}},{"kind":"Field","name":{"kind":"Name","value":"enableStages"}},{"kind":"Field","name":{"kind":"Name","value":"displayDraws"}},{"kind":"Field","name":{"kind":"Name","value":"displayGroups"}},{"kind":"Field","name":{"kind":"Name","value":"displayLiveStandings"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrderPlay"}},{"kind":"Field","name":{"kind":"Name","value":"displayListResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayPendingResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayTournamentResults"}},{"kind":"Field","name":{"kind":"Name","value":"textBox"}}]}}]}}]} as unknown as DocumentNode<SportsQuery, SportsQueryVariables>;
export const GetAllStripeProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllStripeProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllStripeProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"connectedAccountId"},"value":{"kind":"StringValue","value":"acct_1OKbGGBNPNagASFr","block":false}}]}]}}]} as unknown as DocumentNode<GetAllStripeProductsQuery, GetAllStripeProductsQueryVariables>;
export const TeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTeamMemberInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<TeamMembersQuery, TeamMembersQueryVariables>;
export const PartnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"partners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPartnerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"Field","name":{"kind":"Name","value":"activeFrom"}}]}}]}}]} as unknown as DocumentNode<PartnersQuery, PartnersQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListUsersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const AthletesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"athletes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAthleteInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"athletes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"user_join_club"}},{"kind":"Field","name":{"kind":"Name","value":"national_fisher_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<AthletesQuery, AthletesQueryVariables>;
export const BannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"banners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"banners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"headLine"}},{"kind":"Field","name":{"kind":"Name","value":"subHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLink"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<BannersQuery, BannersQueryVariables>;
export const CaptainsTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"captainsTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"captainTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<CaptainsTeamQuery, CaptainsTeamQueryVariables>;
export const PlatformCoachesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"platformCoaches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCoachInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformCoaches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformCoaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"platform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"students"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"services"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<PlatformCoachesQuery, PlatformCoachesQueryVariables>;
export const PlatformDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"platformDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPlatformDocumentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaguePage"}},{"kind":"Field","name":{"kind":"Name","value":"isTournamentCalender"}},{"kind":"Field","name":{"kind":"Name","value":"isRankings"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PlatformDocumentsQuery, PlatformDocumentsQueryVariables>;
export const DrawsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"draws"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListDrawInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draws"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<DrawsQuery, DrawsQueryVariables>;
export const EligibleTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"eligibleTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTeamMemberInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EligibleTeamMembersQuery, EligibleTeamMembersQueryVariables>;
export const RegistrationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"registrationCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}}]}]}}]} as unknown as DocumentNode<RegistrationCountQuery, RegistrationCountQueryVariables>;
export const FindFederationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findFederation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListFederationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findFederation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FindFederationQuery, FindFederationQueryVariables>;
export const FederationbyidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"federationbyid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"leagues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FederationbyidQuery, FederationbyidQueryVariables>;
export const FederationDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"federationDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federationDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<FederationDetailsQuery, FederationDetailsQueryVariables>;
export const FindAllAlbumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllAlbum"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAlbumInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"league"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllAlbum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournament"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournament"}}},{"kind":"Argument","name":{"kind":"Name","value":"league"},"value":{"kind":"Variable","name":{"kind":"Name","value":"league"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"isSpecificTournament"}},{"kind":"Field","name":{"kind":"Name","value":"albumCustomEvent"}},{"kind":"Field","name":{"kind":"Name","value":"albumTags"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"photoLink"}},{"kind":"Field","name":{"kind":"Name","value":"photoCaption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<FindAllAlbumQuery, FindAllAlbumQueryVariables>;
export const UserleaguesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userleagues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserleaguesQuery, UserleaguesQueryVariables>;
export const GetLeagueByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLeagueById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"enableRankings"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"leagueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLeagueByIdQuery, GetLeagueByIdQueryVariables>;
export const LeagueRankingsDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueRankingsDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueRankingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueRankingsDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<LeagueRankingsDateQuery, LeagueRankingsDateQueryVariables>;
export const LicensesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"licenses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLicenseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOptions"}},{"kind":"Field","name":{"kind":"Name","value":"askEachAthlete"}}]}}]}}]}}]} as unknown as DocumentNode<LicensesQuery, LicensesQueryVariables>;
export const LiveStandingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"liveStandings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLiveStandingsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveStandings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifyTeamMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"standings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"pointsRatio"}},{"kind":"Field","name":{"kind":"Name","value":"setRatio"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiveStandingsQuery, LiveStandingsQueryVariables>;
export const CourtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"courts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCourtInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPublish"}}]}}]}}]} as unknown as DocumentNode<CourtsQuery, CourtsQueryVariables>;
export const GroupMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupMatchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<GroupMatchesQuery, GroupMatchesQueryVariables>;
export const GetTournamentTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTournamentTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentTeamMembersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUnique"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUnique"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUnique"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTournamentTeamMembersQuery, GetTournamentTeamMembersQueryVariables>;
export const TournamentRegistrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentRegistrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRegistrationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentRegistrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"additionalFee"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payForMyself"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteFee"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TournamentRegistrationsQuery, TournamentRegistrationsQueryVariables>;
export const NewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"news"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"news"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"postText"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"youtubeVideoLink"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leagueNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"federationNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"news"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsQuery, NewsQueryVariables>;
export const TournamentAllMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentAllMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupMatchInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hideCompleteMatches"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentAllMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"viewType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewType"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"Argument","name":{"kind":"Name","value":"hideCompleteMatches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hideCompleteMatches"}}}]}]}}]} as unknown as DocumentNode<TournamentAllMatchesQuery, TournamentAllMatchesQueryVariables>;
export const UserParentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userParents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListUserParentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userParents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<UserParentsQuery, UserParentsQueryVariables>;
export const ParticipentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"participents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRegistrationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentRegistrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"rankType"}},{"kind":"Field","name":{"kind":"Name","value":"assignedSegment"}},{"kind":"Field","name":{"kind":"Name","value":"additionalSegment"}},{"kind":"Field","name":{"kind":"Name","value":"seed"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mdwc"}},{"kind":"Field","name":{"kind":"Name","value":"qwc"}},{"kind":"Field","name":{"kind":"Name","value":"qs"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifyTeamMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fideTitle"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"blitzElo"}},{"kind":"Field","name":{"kind":"Name","value":"standardElo"}},{"kind":"Field","name":{"kind":"Name","value":"rapidElo"}},{"kind":"Field","name":{"kind":"Name","value":"duprRating"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipentsQuery, ParticipentsQueryVariables>;
export const CalculatePaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"calculatePayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryPaymentInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryPaymentInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculatePaymentInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculatePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"categoryPaymentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryPaymentInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculatePaymentInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculatePaymentInput"}}}]}]}}]} as unknown as DocumentNode<CalculatePaymentsQuery, CalculatePaymentsQueryVariables>;
export const PlatformDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"platform"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isClient"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isClient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isClient"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"platformType"}},{"kind":"Field","name":{"kind":"Name","value":"primaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryColor"}},{"kind":"Field","name":{"kind":"Name","value":"darkLogo"}},{"kind":"Field","name":{"kind":"Name","value":"lightLogo"}},{"kind":"Field","name":{"kind":"Name","value":"darkEmblem"}},{"kind":"Field","name":{"kind":"Name","value":"lightEmblem"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"isEnablePrice"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyEmail"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"platformType"}},{"kind":"Field","name":{"kind":"Name","value":"landingLink"}},{"kind":"Field","name":{"kind":"Name","value":"isEnableMaintenance"}},{"kind":"Field","name":{"kind":"Name","value":"passcode"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceDescription"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PlatformQuery, PlatformQueryVariables>;
export const GetPlayerRankingsByTennisIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayerRankingsByTennisId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tennisId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayerRankingsByTennisId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tennisId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tennisId"}}},{"kind":"Argument","name":{"kind":"Name","value":"citizenship"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citizenship"}}}]}]}}]} as unknown as DocumentNode<GetPlayerRankingsByTennisIdQuery, GetPlayerRankingsByTennisIdQueryVariables>;
export const GetPlayerFideRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPlayerFideRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlayerFideRanking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fideId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fideId"}}}]}]}}]} as unknown as DocumentNode<GetPlayerFideRankingQuery, GetPlayerFideRankingQueryVariables>;
export const TournamentRankingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentRankings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRankingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentRankings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentRankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"identifyTeamMember"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<TournamentRankingsQuery, TournamentRankingsQueryVariables>;
export const RolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RolesQuery, RolesQueryVariables>;
export const TeamByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<TeamByIdQuery, TeamByIdQueryVariables>;
export const TeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTeamInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<TeamsQuery, TeamsQueryVariables>;
export const ThirdPartyLicensesBySportIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"thirdPartyLicensesBySportId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListThirdPartyLicenseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thirdPartyLicensesBySportId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]} as unknown as DocumentNode<ThirdPartyLicensesBySportIdQuery, ThirdPartyLicensesBySportIdQueryVariables>;
export const TournamentCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentCountries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<TournamentCountriesQuery, TournamentCountriesQueryVariables>;
export const TournamentDetailByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentDetailById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentDetailById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"Album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"albumTags"}},{"kind":"Field","name":{"kind":"Name","value":"albumCustomEvent"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isSpecificTournament"}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfCategories"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isManagerPayingServiceFee"}},{"kind":"Field","name":{"kind":"Name","value":"isPayForMyselfEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"events"}},{"kind":"Field","name":{"kind":"Name","value":"isDuprRatingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDuprRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isWprRequired"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"registrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"customInfoMessage"}},{"kind":"Field","name":{"kind":"Name","value":"customSuccessMessage"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSearch"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"entryFee"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"regulations"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"timeControl"}},{"kind":"Field","name":{"kind":"Name","value":"showOOP"}},{"kind":"Field","name":{"kind":"Name","value":"poster"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentRankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"organizationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPhone"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"displayLiveStandings"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrderPlay"}},{"kind":"Field","name":{"kind":"Name","value":"displayListResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayPendingResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayTournamentResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayGroups"}},{"kind":"Field","name":{"kind":"Name","value":"displayDraws"}},{"kind":"Field","name":{"kind":"Name","value":"enableStages"}},{"kind":"Field","name":{"kind":"Name","value":"enableCourts"}},{"kind":"Field","name":{"kind":"Name","value":"enableDiscipline"}},{"kind":"Field","name":{"kind":"Name","value":"isEnablePairings"}},{"kind":"Field","name":{"kind":"Name","value":"isEnablePairingStandings"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplaySeeds"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplaySegments"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayAthleteChessTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOptions"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"askEachAthlete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayClub"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayCity"}},{"kind":"Field","name":{"kind":"Name","value":"timeControl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteFee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"timePerMove"}},{"kind":"Field","name":{"kind":"Name","value":"timeAfterMove"}},{"kind":"Field","name":{"kind":"Name","value":"extraTime"}},{"kind":"Field","name":{"kind":"Name","value":"pairing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draws"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pairings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hideStandings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isHideEntries"}},{"kind":"Field","name":{"kind":"Name","value":"liveStandings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressCoordinates"}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalReferee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"factSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldTitle"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TournamentDetailByIdQuery, TournamentDetailByIdQueryVariables>;
export const TournamentDrawCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentDrawCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListDrawInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentDrawCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<TournamentDrawCategoriesQuery, TournamentDrawCategoriesQueryVariables>;
export const GetTournamentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTournamentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournament"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"license"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"partnerSearch"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"entryFee"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"regulations"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"timeControl"}},{"kind":"Field","name":{"kind":"Name","value":"showOOP"}},{"kind":"Field","name":{"kind":"Name","value":"poster"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentRankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"organizationLogo"}},{"kind":"Field","name":{"kind":"Name","value":"organizationPhone"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resourceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"displayLiveStandings"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrderPlay"}},{"kind":"Field","name":{"kind":"Name","value":"displayListResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayPendingResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayTournamentResults"}},{"kind":"Field","name":{"kind":"Name","value":"displayGroups"}},{"kind":"Field","name":{"kind":"Name","value":"displayDraws"}},{"kind":"Field","name":{"kind":"Name","value":"enableStages"}},{"kind":"Field","name":{"kind":"Name","value":"enableCourts"}},{"kind":"Field","name":{"kind":"Name","value":"enableDiscipline"}},{"kind":"Field","name":{"kind":"Name","value":"isEnablePairings"}},{"kind":"Field","name":{"kind":"Name","value":"isEnablePairingStandings"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplaySeeds"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplaySegments"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayAthleteChessTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOptions"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"askEachAthlete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDisplayClub"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayCity"}},{"kind":"Field","name":{"kind":"Name","value":"timeControl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteFee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"timePerMove"}},{"kind":"Field","name":{"kind":"Name","value":"timeAfterMove"}},{"kind":"Field","name":{"kind":"Name","value":"extraTime"}},{"kind":"Field","name":{"kind":"Name","value":"pairing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draws"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveStandings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"factSheet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldTitle"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTournamentByIdQuery, GetTournamentByIdQueryVariables>;
export const UserTournamentMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userTournamentMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupMatchInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userTournamentMatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}]}}]} as unknown as DocumentNode<UserTournamentMatchesQuery, UserTournamentMatchesQueryVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FindUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const GetUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"friends"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"gtw_points"}},{"kind":"Field","name":{"kind":"Name","value":"preferred_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach_access"}},{"kind":"Field","name":{"kind":"Name","value":"club_access"}},{"kind":"Field","name":{"kind":"Name","value":"parent_access"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"ltsU10Id"}},{"kind":"Field","name":{"kind":"Name","value":"duprId"}},{"kind":"Field","name":{"kind":"Name","value":"pdlId"}},{"kind":"Field","name":{"kind":"Name","value":"ipinId"}},{"kind":"Field","name":{"kind":"Name","value":"teId"}},{"kind":"Field","name":{"kind":"Name","value":"atpId"}},{"kind":"Field","name":{"kind":"Name","value":"wtaId"}},{"kind":"Field","name":{"kind":"Name","value":"additionalUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const ClubMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clubMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListClubMembers"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clubName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"clubName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clubName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubMainAdministrator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<ClubMembersQuery, ClubMembersQueryVariables>;
export const TournamentTeamMembersWithCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentTeamMembersWithCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentTeamMembersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startCreatedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endCreatedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statusArray"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUpcomingAndProgress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentTeamMembersWithCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"startCreatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startCreatedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"endCreatedAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endCreatedAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"statusArray"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statusArray"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUpcomingAndProgress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUpcomingAndProgress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentTeamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isDelete"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payForMyself"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"additionalFee"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onsiteFee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<TournamentTeamMembersWithCountQuery, TournamentTeamMembersWithCountQueryVariables>;
export const ValidLicensesForUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validLicensesForUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLicenseInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validLicensesForUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"cantBuy"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"fieldOptions"}},{"kind":"Field","name":{"kind":"Name","value":"askEachAthlete"}}]}}]}}]}}]} as unknown as DocumentNode<ValidLicensesForUsersQuery, ValidLicensesForUsersQueryVariables>;
export const GroupsAndDrawsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"groupsAndDraws"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupsAndDraws"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<GroupsAndDrawsQuery, GroupsAndDrawsQueryVariables>;
export const GetUserPartnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserPartners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCategorySettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserPartners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetUserPartnersQuery, GetUserPartnersQueryVariables>;
export const GetUserPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchUserPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<GetUserPlanQuery, GetUserPlanQueryVariables>;
export const UserTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userTournaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserTournamentsQuery, UserTournamentsQueryVariables>;
export const ValidTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTeamInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validTeamMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<ValidTeamMembersQuery, ValidTeamMembersQueryVariables>;
export const OrganizationPlatformByFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organizationPlatformByFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationPlatformByFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationPlatformByFieldsQuery, OrganizationPlatformByFieldsQueryVariables>;
export const LeagueCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueCode"}},{"kind":"Field","name":{"kind":"Name","value":"maxTournaments"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeFrom"}},{"kind":"Field","name":{"kind":"Name","value":"activeTo"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimitType"}},{"kind":"Field","name":{"kind":"Name","value":"selectStage"}},{"kind":"Field","name":{"kind":"Name","value":"countries"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"countAllTournament"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCatgories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enableMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"team"}},{"kind":"Field","name":{"kind":"Name","value":"isAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"moveToSingles"}},{"kind":"Field","name":{"kind":"Name","value":"categoryEntries"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rankingCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayClub"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayCity"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayBirthYear"}}]}}]}}]}}]} as unknown as DocumentNode<LeagueCategoriesQuery, LeagueCategoriesQueryVariables>;
export const LeagueLatestWinnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueLatestWinners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRankingsEntryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueLatestWinners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournament"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeagueLatestWinnersQuery, LeagueLatestWinnersQueryVariables>;
export const LeagueRankingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueRankings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueRankingInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueRankings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rankingCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyPoints"}}]}}]}}]} as unknown as DocumentNode<LeagueRankingsQuery, LeagueRankingsQueryVariables>;
export const LeagueRankingsCustomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueRankingsCustom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueRankingInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPage1"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueRankingsCustom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPage1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPage1"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"top3"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rankings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyPoints"}},{"kind":"Field","name":{"kind":"Name","value":"rankingCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDisplayClub"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<LeagueRankingsCustomQuery, LeagueRankingsCustomQueryVariables>;
export const SearchLeaguesByTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchLeaguesByTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchLeaguesByTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchLeaguesByTitleQuery, SearchLeaguesByTitleQueryVariables>;
export const LeaguePageLeagueRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leaguePageLeagueRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaguePageLeagueRanking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"leagueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rankingCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeaguePageLeagueRankingQuery, LeaguePageLeagueRankingQueryVariables>;
export const LeagueGeneralTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueGeneralTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueGeneralTournaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"registrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"license"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LeagueGeneralTournamentsQuery, LeagueGeneralTournamentsQueryVariables>;
export const LeaguesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeaguesQuery, LeaguesQueryVariables>;
export const LeagueForRankingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueForRankings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueForRankings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]} as unknown as DocumentNode<LeagueForRankingsQuery, LeagueForRankingsQueryVariables>;
export const SearchLeaguesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchLeagues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchLeagues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}]}]}}]} as unknown as DocumentNode<SearchLeaguesQuery, SearchLeaguesQueryVariables>;
export const AllLeaguesWithCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allLeaguesWithCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLeaguesWithCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"federationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}}]}]}}]} as unknown as DocumentNode<AllLeaguesWithCountQuery, AllLeaguesWithCountQueryVariables>;
export const LeagueRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leagueRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueRankingInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leagueRankings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<LeagueRankingQuery, LeagueRankingQueryVariables>;
export const GetProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"friends"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"player"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"gtw_points"}},{"kind":"Field","name":{"kind":"Name","value":"user_parents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferred_language"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clubName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach_access"}},{"kind":"Field","name":{"kind":"Name","value":"club_access"}},{"kind":"Field","name":{"kind":"Name","value":"parent_access"}},{"kind":"Field","name":{"kind":"Name","value":"user_coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user_address"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}},{"kind":"Field","name":{"kind":"Name","value":"ipinId"}},{"kind":"Field","name":{"kind":"Name","value":"fideId"}},{"kind":"Field","name":{"kind":"Name","value":"ltsU10Id"}},{"kind":"Field","name":{"kind":"Name","value":"duprId"}},{"kind":"Field","name":{"kind":"Name","value":"wprUserId"}},{"kind":"Field","name":{"kind":"Name","value":"pdlId"}},{"kind":"Field","name":{"kind":"Name","value":"teId"}},{"kind":"Field","name":{"kind":"Name","value":"atpId"}},{"kind":"Field","name":{"kind":"Name","value":"wtaId"}},{"kind":"Field","name":{"kind":"Name","value":"additionalUserRole"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetProfileQuery, GetProfileQueryVariables>;
export const TournamentMatchesDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentMatchesDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupMatchInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hideCompleteMatches"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentMatchesDates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"hideCompleteMatches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hideCompleteMatches"}}}]}]}}]} as unknown as DocumentNode<TournamentMatchesDatesQuery, TournamentMatchesDatesQueryVariables>;
export const PairingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pairing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPairingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<PairingQuery, PairingQueryVariables>;
export const PairingResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pairingResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPairingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairingResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<PairingResultsQuery, PairingResultsQueryVariables>;
export const PairingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pairings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPairingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pairings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"hide"}},{"kind":"Field","name":{"kind":"Name","value":"hideStandings"}}]}}]}}]} as unknown as DocumentNode<PairingsQuery, PairingsQueryVariables>;
export const PartnerSearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"partnerSearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPartnerSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerSearches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partnerSearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"citizenship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"selfInformation"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"partnerInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueTotal"}}]}}]}}]} as unknown as DocumentNode<PartnerSearchesQuery, PartnerSearchesQueryVariables>;
export const UserPartnerSearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPartnerSearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListPartnerSearchInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPartnerSearches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<UserPartnerSearchesQuery, UserPartnerSearchesQueryVariables>;
export const PdfGenerationForPairingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pdfGenerationForPairing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeControl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pairingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pdfGenerationForPairing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tournamentCategory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentCategory"}}},{"kind":"Argument","name":{"kind":"Name","value":"timeControl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeControl"}}},{"kind":"Argument","name":{"kind":"Name","value":"pairingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pairingId"}}}]}]}}]} as unknown as DocumentNode<PdfGenerationForPairingQuery, PdfGenerationForPairingQueryVariables>;
export const PlatformsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"platforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platforms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<PlatformsQuery, PlatformsQueryVariables>;
export const GetRatingByDuprIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRatingByDUPRId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRatingByDUPRId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"duprId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duprId"}}}]}]}}]} as unknown as DocumentNode<GetRatingByDuprIdQuery, GetRatingByDuprIdQueryVariables>;
export const HomePageLeagueRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"homePageLeagueRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"homePageLeagueRanking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"}},{"kind":"Field","name":{"kind":"Name","value":"thirdPartyPoints"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"user_club_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rankingCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HomePageLeagueRankingQuery, HomePageLeagueRankingQueryVariables>;
export const SearchFederationByTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchFederationByTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchFederationByTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"platforms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leagues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchFederationByTitleQuery, SearchFederationByTitleQueryVariables>;
export const SportFishingResultEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sportFishingResultEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSportFishingResultEntryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sportFishingResultEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"nation"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SportFishingResultEntriesQuery, SportFishingResultEntriesQueryVariables>;
export const SportFishingResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sportFishingResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListSportFishingResultInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sportFishingResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<SportFishingResultsQuery, SportFishingResultsQueryVariables>;
export const SportsWithTournamentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sportsWithTournamentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sportsWithTournamentCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCount"}}]}}]}}]} as unknown as DocumentNode<SportsWithTournamentCountQuery, SportsWithTournamentCountQueryVariables>;
export const TeamDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<TeamDetailsQuery, TeamDetailsQueryVariables>;
export const TournamentTopFivePlayersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentTopFivePlayers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentTopFivePlayers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tournamentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tournamentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}]}]}}]} as unknown as DocumentNode<TournamentTopFivePlayersQuery, TournamentTopFivePlayersQueryVariables>;
export const FindAllTournamentCategoryGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findAllTournamentCategoryGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentCategoryGroupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findAllTournamentCategoryGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindAllTournamentCategoryGroupQuery, FindAllTournamentCategoryGroupQueryVariables>;
export const TournamentDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentDocumentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"section"}}]}}]}}]} as unknown as DocumentNode<TournamentDocumentsQuery, TournamentDocumentsQueryVariables>;
export const TournamentGroupCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"tournamentGroupCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListGroupInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournamentGroupCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<TournamentGroupCategoriesQuery, TournamentGroupCategoriesQueryVariables>;
export const SearchTournamentsByTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchTournamentsByTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ageGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skills"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTournamentsByTitle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"sport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sport"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"ageGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ageGroup"}}},{"kind":"Argument","name":{"kind":"Name","value":"skills"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skills"}}},{"kind":"Argument","name":{"kind":"Name","value":"leagueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leagueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawlDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"additionalQuestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalReferee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTournamentsByTitleQuery, SearchTournamentsByTitleQueryVariables>;
export const AllTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alltournament"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"federationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"federationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tour"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"closeRegistration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isFeatured"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"registerLink"}},{"kind":"Field","name":{"kind":"Name","value":"registrationStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"enableLicense"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournamentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ageLimit"}},{"kind":"Field","name":{"kind":"Name","value":"ageType"}},{"kind":"Field","name":{"kind":"Name","value":"ageTo"}},{"kind":"Field","name":{"kind":"Name","value":"ageFrom"}},{"kind":"Field","name":{"kind":"Name","value":"skillsLevel"}},{"kind":"Field","name":{"kind":"Name","value":"ageGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationEmail"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"registrationRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<AllTournamentsQuery, AllTournamentsQueryVariables>;
export const LeaguesSortedByActiveTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"leaguesSortedByActiveTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sports"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaguesSortedByActiveTournaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"7"}},{"kind":"Argument","name":{"kind":"Name","value":"sports"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sports"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeaguesSortedByActiveTournamentsQuery, LeaguesSortedByActiveTournamentsQueryVariables>;
export const UserAllTournamentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userAllTournaments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUpcomingAndProgress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAllTournaments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"isUpcomingAndProgress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUpcomingAndProgress"}}}]}]}}]} as unknown as DocumentNode<UserAllTournamentsQuery, UserAllTournamentsQueryVariables>;
export const UserLeaguePointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userLeaguePoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListTournamentRankingsEntryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rankingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLeaguePoints"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"rankingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rankingId"}}}]}]}}]} as unknown as DocumentNode<UserLeaguePointsQuery, UserLeaguePointsQueryVariables>;
export const UserAllLeaguesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userAllLeagues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLeagueInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAllLeagues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"league"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"leagueCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tournaments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"federation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationAbbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<UserAllLeaguesQuery, UserAllLeaguesQueryVariables>;
export const UserPartnerSearchCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPartnerSearchCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCategorySettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPartnerSearchCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UserPartnerSearchCategoriesQuery, UserPartnerSearchCategoriesQueryVariables>;
export const UserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}]}}]} as unknown as DocumentNode<UserProfileQuery, UserProfileQueryVariables>;
export const UserTournamentCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userTournamentCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListCategorySettingInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userTournamentCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UserTournamentCategoriesQuery, UserTournamentCategoriesQueryVariables>;